$(document).ready(function () {    

    $.SearchJob = function () {
        $("#page").val('0');
        var search_keyword = decodeURIComponent($("#search_keyword").val());
        //var search_location = decodeURIComponent($("#search_location").val());
        //var search_location_2 = decodeURIComponent($("#search_location_2").val());
        var search_location = decodeURIComponent($("#search_location_2").val());
        var search_category = $("#search_category").val();
        var filter_job_type = $("#filter_job_type").val();
        var filter_salary = $('input[name=filter_salary]:checked').val();
        var search_education = decodeURIComponent($("#search_education").val());
        var search_type = decodeURIComponent($("#search_type").val());
        var search_salary = decodeURIComponent($("#search_salary").val());

        if (filter_salary == undefined)
            filter_salary = '';
        var fjobtype = '';
        var filter_job_type = new Array();
        var i = 0;
        $(".filter_job_type").each(function (index) {
            if ($(this).is(':checked'))
            {
                filter_job_type[i] = $(this).attr("value");
                i++;
            }
        });

        fjobtype = filter_job_type.join();

        if (typeof search_category == 'undefined' || $('#search_category').attr('name') == 'prefer_categories')
            search_category = '0';
        if (typeof search_location == 'undefined' || $('#search_location').attr('name') == 'prefer_locations')
            search_location = '0';

        if (search_keyword == '' && search_category == '0' && search_location == '0') {
            //$("#filter_sorting").addClass("hide"); 
        } else {
            //$("#filter_sorting").removeClass("hide");
            //$("#add-filter").show();
            $('#add-filter').removeClass('disabled');
            /*if($.cookie('guided_search_tuto_1') == null) {
             $.cookie('guided_search_tuto_1', 'yes', { expires: 1, path: '/' });
             $('.btn-filter-popover').popover("show");
             }*/
        }

        //$("#sorthead").html("Relevance");
        //$("#sort_type").val('id');
        //$("#sort_order").val('desc');
        //$(".sort-btn").removeClass("active");
        //$(".sortorder_desc").addClass("active");      

        if (sPage == 'index.php' || sPage == '') {
            var qPage = 'q=' + encodeURIComponent(search_keyword) + "&cat=" + encodeURIComponent(search_category) +
                    "&loc=" + encodeURIComponent(search_location) + "&sal=" + encodeURIComponent(search_salary) +
                    "&jtype=" + encodeURIComponent(search_type) + "&edu=" + encodeURIComponent(search_education);
            window.location.hash = qPage;
            //$.getJobs(0);
            //$.getFeaturedJobs(0, search_keyword == '*');
            //$.getFeaturedJobs(0);
            localStorage.setItem('qPage', qPage);
            //$("#search-btn").trigger("click");
        } else {
            var qPage = 'q=' + encodeURIComponent(search_keyword) + "&cat=" + encodeURIComponent(search_category) +
                    "&loc=" + encodeURIComponent(search_location) + "&sal=" + encodeURIComponent(search_salary) +
                    "&jtype=" + encodeURIComponent(search_type) + "&edu=" + encodeURIComponent(search_education);
            search_keyword = search_keyword.replace(/ /g, '_');
            search_keyword = search_keyword.replace(/&/g, '%26');
            window.location = canvas_url + '#' + qPage;
            localStorage.setItem('qPage', qPage);
        }

        // For Job Alert
        $("#keywords").val(search_keyword);
        $("#prefer_locations").val(search_location);
        $("#prefer_categories").val(search_category);
    }

    $.clearSearch = function ()
    {
        $("#page").val('0');
        $("#search_keyword").val('');
        $("#search_location").val(0);
        $("#search_location_2").val('');
        $("#search_category").val(0);
        $(".filter_job_type").each(function (index) {
            if ($(this).is(':checked'))
            {
                $(this).attr('checked', false);
            }
        });
        $(".filter_salary").each(function (index) {
            if ($(this).is(':checked'))
            {
                $(this).attr('checked', false);
            }
        });
    }

    $.SmartSearchJob = function () {
        $("#page").val('0');
        var search_keyword = decodeURIComponent($("#smartsearch_jobtitle").val());
        var search_location = decodeURIComponent($("#smartsearch_location").val());
        var search_category = $("#smartsearch_cat_id").val();
        var filter_job_type = $("#filter_job_type").val();
        var filter_salary = $('input[name=filter_salary]:checked').val();
        var search_education = decodeURIComponent($("#smartsearch_education").val());
        var search_type = decodeURIComponent($("#search_type").val());
        var search_salary = decodeURIComponent($("#search_salary").val());
        var smartsearch_salary_min = $("#smartsearch_salary_min").val();
        var smartsearch_salary_max = $("#smartsearch_salary_max").val();

        search_salary = smartsearch_salary_min + '-' + smartsearch_salary_max;

        if (filter_salary == undefined)
            filter_salary = '';
        var fjobtype = '';
        var filter_job_type = new Array();
        var i = 0;
        $(".filter_job_type").each(function (index) {
            if ($(this).is(':checked'))
            {
                filter_job_type[i] = $(this).attr("value");
                i++;
            }
        });

        fjobtype = filter_job_type.join();

        if (typeof search_category == 'undefined' || $('#smartsearch_cat_id').attr('name') == 'prefer_categories')
            search_category = '0';
        if (typeof search_location == 'undefined' || $('#smartsearch_location').attr('name') == 'prefer_locations')
            search_location = '0';

        if (search_keyword == '' && search_category == '0' && search_location == '0') {
            //$("#filter_sorting").addClass("hide"); 
        } else {
            //$("#filter_sorting").removeClass("hide");
            //$("#add-filter").show();
            $('#add-filter').removeClass('disabled');
            /*if($.cookie('guided_search_tuto_1') == null) {
             $.cookie('guided_search_tuto_1', 'yes', { expires: 1, path: '/' });
             $('.btn-filter-popover').popover("show");
             }*/
        }

        //$("#sorthead").html("Relevance");
        //$("#sort_type").val('id');
        //$("#sort_order").val('desc');
        //$(".sort-btn").removeClass("active");
        //$(".sortorder_desc").addClass("active");      

        /*if (sPage=='index.php' || sPage=='') {
         var qPage = 'q='+encodeURIComponent(search_keyword)+"&cat="+encodeURIComponent(search_category)+
         "&loc="+encodeURIComponent(search_location)+"&sal="+encodeURIComponent(search_salary)+
         "&jtype="+encodeURIComponent(search_type)+"&edu="+encodeURIComponent(search_education);
         window.location.hash = qPage;
         $.getJobs(0);
         $.getFeaturedJobs(0, search_keyword == '*');
         localStorage.setItem('qPage', qPage);
         //$("#search-btn").trigger("click");
         } else {
         var qPage = 'q='+encodeURIComponent(search_keyword)+"&cat="+encodeURIComponent(search_category)+
         "&loc="+encodeURIComponent(search_location)+"&sal="+encodeURIComponent(search_salary)+
         "&jtype="+encodeURIComponent(search_type)+"&edu="+encodeURIComponent(search_education);
         search_keyword  =   search_keyword.replace(/ /g,'_');
         search_keyword  =   search_keyword.replace(/&/g,'%26');
         window.location = canvas_url+'#'+qPage;
         localStorage.setItem('qPage', qPage);
         }*/

        var qPage = 'q=' + encodeURIComponent(search_keyword) + "&cat=" + encodeURIComponent(search_category) +
                "&loc=" + encodeURIComponent(search_location) + "&sal=" + encodeURIComponent(search_salary) +
                "&jtype=" + encodeURIComponent(search_type) + "&edu=" + encodeURIComponent(search_education);
        search_keyword = search_keyword.replace(/ /g, '_');
        search_keyword = search_keyword.replace(/&/g, '%26');
        window.location = canvas_url + '#' + qPage;
        localStorage.setItem('qPage', qPage);

        // For Job Alert
        $("#keywords").val(search_keyword);
        $("#prefer_locations").val(search_location);
        $("#prefer_categories").val(search_category);
    }

    $.getJobsCount = function () {
        console.log('$.getJobsCount is deprecated');
        return false;
        /*$.get(canvas_url+"api/job/list", {'keyword':'','search_category':'','search_location':'','sort_by':'id','start':0,'noOfRecords':1,'_token':$('meta[name="csrf-token"]').attr('content'), '_method':"GET" }, function(data){
         if (data.status=='success') {
         var counts = data.totalRecords;
         var resultDiv = '<ul>'; 
         var pad_invites = pad(counts, 4);
         for (var i=0;i<pad_invites.length;i++) {
         resultDiv += '<li><span>'+pad_invites.charAt(i)+'</span></li>';
         }
         
         resultDiv += '</ul>';
         //$("#counter").html(resultDiv);
         $("#counter").html(counts+' jobs available');
         }        
         },"json");*/
    }
    
	$(document).on('click', '.remove-filter', function () {
        var parent = $(this).attr('data-parent');

        //reset current search values (to refresh available filters)
        if (guided_search_stuff.active_filters['parent_' + parent].type == 'regions')
            $("#search_location").val('');
        if (guided_search_stuff.active_filters['parent_' + parent].type == 'education')
            $("#search_education").val('');
        if (guided_search_stuff.active_filters['parent_' + parent].type == 'jobType')
            $("#search_type").val('');
        if (guided_search_stuff.active_filters['parent_' + parent].type == 'salary')
            $("#search_salary").val('');

        //guided_search_stuff.active_filters.splice($.inArray(parent, guided_search_stuff.active_filters), 1);
        delete guided_search_stuff.active_filters['parent_' + parent];

        //update stuff
        if ($(this).parent().parent().parent().attr('id') == 'active-filters') {
            //if removing from the main content, instead of modal
            var parent = $(this).attr('data-parent');
            var child = $(this).attr('data-child');
            var element_in_modal = $($($('.available-filters')[parent]).children()[child]);

            //must update modal as well
            //element_in_modal.removeAttr('data-index');
            element_in_modal.removeClass('active');
            element_in_modal.removeClass('remove-filter');
            element_in_modal.addClass('add-filter');
            $(this).parent().remove();
            guidedSearch();
        } else {
            //removing from modal
            //$(this).removeAttr('data-index');
            $(this).removeClass('active');
            $(this).removeClass('remove-filter');
            $(this).addClass('add-filter');
        }

        if ($(".search-filter").find('.filter-tag').children(':visible').length == 0) {
            $(".search-filter").find('.filter-tag').parent().hide();
            /*if($('#search_keyword').val() == '*')
             $('#search_keyword').val('');*/
        }

        $.updateFilters();
    });

    $(document).on('click', '.add-filter', function () {
        var $this = $(this)
        var label = $this.find('span.filter-label').text();
        var count = $this.find('span.filter-count').text().replace(/[\(\)]/g, '');
        var parent = $this.attr('data-parent');
        var child = $this.attr('data-child');
        var type = $this.attr('data-type');
        //update search values (to refresh available filters)
        if (type == 'regions')
            $("#search_location").val(label);
        else if (type == 'education')
            $("#search_education").val(label);
        else if (type == 'jobType')
            $("#search_type").val(label);
        else if (type == 'salary')
            $("#search_salary").val(label);
        //only one filter per category - let's reset the buffer and dom elements
        if ($this.parent().find('.active').length > 0) {
            //var ind = $($this.parent().find('.active')[0]).attr('data-index');
            //guided_search_stuff.active_filters.splice($.inArray(ind, guided_search_stuff.active_filters), 1);
            //guided_search_stuff.active_filters.splice($.inArray(parent, guided_search_stuff.active_filters), 1);
            //$this.parent().find('.active').removeAttr('data-index');
            $this.parent().find('.active').removeClass('remove-filter');
            $this.parent().find('.active').addClass('add-filter');
            $this.parent().find('.active').removeClass('active');
        }
        //mark the correct filter
        guided_search_stuff.active_filters['parent_' + parent] = {label: label, count: count, parent: parent, child: child, type: type};
        //console.log(guided_search_stuff.active_filters);
        //guided_search_stuff.active_filters.push({label:label, count:count, parent:parent, child:child});
        //$this.attr('data-index', guided_search_stuff.active_filters.length - 1);
        $this.addClass('remove-filter');
        $this.removeClass('add-filter');
        $this.addClass('active');

        $.updateFilters();
        /*
         * in case something goes wrong, we can uncomment this to disable the new filters
         */
        //$('#update-filters').trigger('click');
    });

    $(document).on('click', '#clear-filters', function () {
        $.clearFilters();
    })

    $('#update-filters').click(function () {
        $($('#active-filters').find('ul')[0]).html('');
        guidedSearch();
    });

    var guidedSearch = function () {
        //reset everything
        /*if($("#search_keyword").val() == '')
         $("#search_keyword").val('*')*/
        $("#search_location").val('0');
        $("#search_education").val('');
        $("#search_salary").val('');
        //apply the correct filters
        $.each(guided_search_stuff.active_filters, function (k, v) {
            //set values for the search
            if (v.type == 'regions')
                $("#search_location").val(v.label);
            else if (v.type == 'education')
                $("#search_education").val(v.label);
            else if (v.type == 'jobType')
                $("#search_type").val(v.label);
            else if (v.type == 'salary')
                $("#search_salary").val(v.label);
        });
        $.SetJobSearch();
        //$.SearchJob();
    }

    $.clearFilters = function () {
        var search_keyword = $("#search_keyword").val();
        var search_location_2 = decodeURIComponent($("#search_location_2").val());
        $("#search_location").val('');
        $("#search_category").val('');
        $("#filter_job_type").val('');
        $("#search_salary").val('');
        $("#search_education").val('');
        $("#search_type").val('');
        $("#search_salary").val('');
        var qPage = 'q=' + search_keyword + "&cat=&loc=" + encodeURIComponent(search_location_2) + "&sal=&jtype=&edu=";
        window.location.hash = qPage;
        localStorage.setItem('qPage', qPage);
        for (var member in guided_search_stuff.active_filters)
            delete guided_search_stuff.active_filters[member];

        $.updateFilters();
    }

    $.updateFilters = function () {
        $('#guided-search-filters').parent().addClass('load');
        $('.spinner-load').show();
        var search_keyword = decodeURIComponent($("#search_keyword").val());
        //var search_location = decodeURIComponent($("#search_location").val());
        //var search_location_2 = decodeURIComponent($("#search_location_2").val());
        var search_location = decodeURIComponent($("#search_location_2").val());
        var search_location_2 = "";
        var search_education = decodeURIComponent($("#search_education").val());
        var search_type = decodeURIComponent($("#search_type").val());
        var search_salary = decodeURIComponent($("#search_salary").val());
        var sort_by = $("#sort_type").val();
        var orderby = $("#sort_order").val();

        if ($.isNumeric(search_location))
            search_location = $.findLocation(search_location);
        //console.log(search_salary);
        //if(search_location != '' && search_location != '0') guided_search_stuff.active_filters['parent_0'] = {label:search_location, count:$('.totalrec').text(), parent:0, child:0, type:'regions'};
        if (search_salary != '')
            guided_search_stuff.active_filters['parent_0'] = {label: search_salary, count: $('.totalrec').text(), parent: 0, child: 0, type: 'salary'};
        //console.log(guided_search_stuff.active_filters);

        if (search_education != '')
            guided_search_stuff.active_filters['parent_1'] = {label: search_education, count: $('.totalrec').text(), parent: 1, child: 0, type: 'education'};
        if (search_type != '')
            guided_search_stuff.active_filters['parent_2'] = {label: search_type, count: $('.totalrec').text(), parent: 2, child: 0, type: 'jobType'};

        if (search_keyword == '') {
            //update filters thing
            //now we allow users to filter without searching
            /*$.setUpFilters({filters:[]});
             if(search_location == '0' || search_location == '') {
             //hide the filter button
             $('#add-filter').remove();
             }
             return;*/
            //uncoment this: search_keyword = '*';
        }

        var jsonData = {
            keyword: (search_keyword == '' ? '*' : search_keyword),
            company_id: 0,
            search_location: search_location,
            search_location_2: search_location_2,
            search_education: search_education,
            search_type: search_type,
            search_salary: search_salary,
            search_category: '',
            filter_job_type: '',
            filter_salary: 0,
            sort_by: sort_by,
            orderby: orderby,
            start: 0,
            get_filters_only: 'yes',
            noOfRecords: 0, //we dont want job, only filters
            '_token': $('meta[name="csrf-token"]').attr('content'),
            '_method': "GET"
        };

        var request = $.ajax({
            url: canvas_url + "api/job/list",
            data: jsonData,
            type: 'GET',
            crossDomain: true,
            dataType: 'json'
        });
        request.done(function (data) {
            //reset everything
            $('#guided-search-filters').parent().removeClass('load');
            $('.spinner-load').hide();
            //$("#search_location").val('0');
            $("#search_education").val('');
            $("#search_type").val('');
            $("#search_salary").val('');
            //apply the correct filters

            $.each(guided_search_stuff.active_filters, function (k, v) {
                //set values for the search
                if (v.type == 'regions')
                    $("#search_location").val(v.label);
                else if (v.type == 'education')
                    $("#search_education").val(v.label);
                else if (v.type == 'jobType')
                    $("#search_type").val(v.label);
                else if (v.type == 'salary')
                    $("#search_salary").val(v.label);
            });
            $.setUpFilters({filters: data.filters});

            if ($('#guided-search-filters').children().length == 0 && $('#search-filter-modal').is(':visible') == true)
                $('#update-filters').trigger('click');
        });
    }

    $.setUpFilters = function (params) {
        var guided_search = {};
        var root = $('#guided-search-filters');
        var html = '';
        var parent = 0;
        $.each(params.filters, function (k, v) {
            var label = '';
            if (k == 'regions')
                label = txt_job_loc + ' <i class="mdi mdi-map-marker"></i>';
            else if (k == 'education')
                label = min_education + ' <i class="mdi mdi-school"></i>';
            else if (k == 'jobType')
                label = txt_job_type + ' <i class="mdi mdi-checkbox-marked-circle-outline"></i>';
            else if (k == 'salary')
                label = txt_salary + ' <i class="mdi mdi-cash-usd"></i>';
            else
                label = k.charAt(0).toUpperCase() + k.slice(1);

            html += '<div class="form-group"><p>' + label + '</p><ul class="filter-tag available-filters">';

            for (var i = 0; i < v.length; i++) {
                if (k == 'salary') {
                    //if(v[i].label != '10001.0-*')
                    v[i].label = v[i].label.replace(/(\.0)/g, '');
                    //else
                    //    v[i].label = 'Above 10000';
                }

                //find out if this filter is active (when refreshing the page)
                var is_active = false;
                //if($(".search-filter").find('.filter-tag').children().length == 0) {
                $.each(guided_search_stuff.active_filters, function (filter_k, filter_v) {
                    if (filter_v.label == v[i].label)
                        is_active = true;
                });
                //} else {
                //    $.each(guided_search_stuff.active_filters, function(filter_k, filter_v) {
                //        if(filter_v.label == v[i].label) is_active = true;
                //    });
                //}
                if (is_active == true) {
                    html += '<li class="remove-filter active" data-child="' + i + '" data-parent="' + parent + '" data-type="' + k + '"><span class="filter-label">' + v[i].label + '</span> <span class="filter-count">(' + v[i].count + ')</span></li>';
                } else {
                    if (guided_search_stuff.active_filters['parent_' + parent] == undefined && v[i].count > 0)
                        html += '<li class="add-filter" data-child="' + i + '" data-parent="' + parent + '" data-type="' + k + '"><span class="filter-label">' + v[i].label + '</span> <span class="filter-count">(' + v[i].count + ')</span></li>';

                }
            }
            html += '</ul></div>';
            parent++;
        });

        if (html != '')
            root.html(html);

        $(".search-filter").find('.filter-tag').html('');
        //if(guided_search_stuff.fresh == true) {
        $.each(guided_search_stuff.active_filters, function (k, v) {
            var tag = '<li class="active">' +
                    v.label + ' <span class="hide">(' + v.count +
                    ')</span><a class="remove-filter text-primary" data-target="' + i + '" data-parent="' + k.replace(/\D/g, '') +
                    '" data-child="' + v.child + '" data-type="' + v.type + '"><i class="fa fa-close"></i></a></li>';
            $(".search-filter").find('.filter-tag').append(tag);
        });
        //}

        if ($(".search-filter").find('.filter-tag').children().length > 0 && $('#search-filter-modal').is(':visible') == false){
            $(".search-filter").css({'padding':'10px 0px'});
            $('#clearAllFilter').show()
            $(".search-filter").show();
  
        }
        else{
            $(".search-filter").hide();
            $(".search-filter").css({'padding':'0px 0px'}); 
            $('#clearAllFilter').hide()
        }

        //guided_search_stuff.fresh = false;
        //console.log(params);

    };

    $.findLocation = function (id) {
        var real_location = '';
        id = parseInt(id);
        switch (id) {
            case 17:
                real_location = 'Selangor';
                break;
            case 18:
                real_location = 'Kuala Lumpur';
                break;
            case 19:
                real_location = 'Perak';
                break;
            case 20:
                real_location = 'Terengganu';
                break;
            case 21:
                real_location = 'Sabah';
                break;
            case 22:
                real_location = 'Sarawak';
                break;
            case 23:
                real_location = 'Kedah';
                break;
            case 24:
                real_location = 'Perlis';
                break;
            case 25:
                real_location = 'Kelantan';
                break;
            case 26:
                real_location = 'Melaka';
                break;
            case 27:
                real_location = 'Johor';
                break;
            case 28:
            case 42:
            case 59:
                real_location = 'Pulau Pinang';
                break;
            case 29:
                real_location = 'Negeri Sembilan';
                break;
            case 30:
                real_location = 'Pahang';
                break;
            case 31:
                real_location = 'Labuan';
                break;
            case 32:
                real_location = 'Singapore';
                break;
            case 33:
                real_location = 'Oversea Jobs';
                break;
            case 34:
            case 51:
                real_location = 'Johor';
                break;
            case 35:
            case 52:
                real_location = 'Kedah';
                break;
            case 36:
            case 53:
                real_location = 'Kelantan';
                break;
            case 37:
            case 54:
                real_location = 'Kuala Lumpur';
                break;
            case 38:
            case 55:
                //$real_location = 'Malacca';
                real_location = 'Melaka';
                break;
            case 39:
            case 56:
                real_location = 'Negeri Sembilan';
                break;
            case 40:
            case 57:
                real_location = 'Other';
                break;
            case 41:
            case 58:
                real_location = 'Pahang';
                break;
                /*case 42:
                 case 59:
                 real_location = 'Penang';
                 break;*/
            case 43:
            case 60:
                real_location = 'Perak';
                break;
            case 44:
            case 61:
                real_location = 'Perlis';
                break;
            case 45:
            case 62:
                real_location = 'Sabah';
                break;
            case 46:
            case 63:
                real_location = 'Sarawak';
                break;
            case 47:
            case 64:
                real_location = 'Selangor';
                break;
            case 48:
            case 65:
                real_location = 'Singapore';
                break;
            case 49:
            case 66:
                real_location = 'Terengganu';
                break;
            case 50:
            case 67:
                real_location = 'Wilayah Labuan';
                break;
            default:
                real_location = '';
                break;
        }
        return real_location;
    }

    //-- Re-enable recommendation
    $.getJobRecommendation = function (recType, jobId, limit, display_limit, category, location)
    {
        if (typeof recType == "undefined") {
            recType = 'trend';
        }
        if (typeof jobId == "undefined") {
            jobId = '';
        }

        if (typeof limit == "undefined") {
            limit = '';
        }
        if (typeof display_limit == "undefined") {
            display_limit = '';
        }
        if (typeof category == "undefined") {
            category = '';
        }
        if (typeof location == "undefined") {
            location = '';
        }

        var jsonData = {
            job_id: jobId,
            rec_type: recType,
            category: category,
            location: location,
            limit: limit,
            '_token': $('meta[name="csrf-token"]').attr('content'),
            '_method': "POST"
        };

        var request = $.ajax({
            url: canvas_url + "api/job/recommendation",
            data: jsonData,
            type: 'POST',
            crossDomain: true,
            dataType: 'json',
            timeout: 5000,
            error: function (jqXHR, textStatus, errorThrown) {
                if (textStatus === "timeout") {
                    //do something on timeout
                    //alert("timeout");
                }
            }
        });
        request.done(function (data) {
            $('#spinner').hide();

            if (data.status == 'success') {
                var recommendation = data.recommendation;
                if (recommendation) {
                    var recommendation_jobs = recommendation.recommendation_jobs;
                    var recommendation_heading = recommendation.recommendation_heading;
                    if (recommendation_jobs.length > 0) {
                        var current = recommendation_jobs.length;

                        var rec = '<div>\
                                    <h4 class="text-bold xs-mt-0 xs-mb-0"><i class="mdi mdi-fire"></i>' + recommendation_heading.heading + '</h4>';
                        for (var i = 0; i < current; i++) {
                            rec += '<a  href="' + recommendation_jobs[i].job_url + '" target="_blank" class="xs-mt-10 d-inline-block">\
                                    <p class="xs-mb-0 text-dark">' + recommendation_jobs[i].job_title + '</p>\
                                    <p class="xs-mb-0 text-dark text-small"><i class="fa fa-briefcase w-20"></i> ' + recommendation_jobs[i].company_title + '</p>\
                                    <p class="xs-mb-0 text-primary text-small"><i class="fa fa-usd w-20"></i> ' + recommendation_jobs[i].final_salary + '</p>\
                                    <p class="xs-mb-0 text-dark text-small"><i class="fa fa-map-marker w-20"></i> ' + recommendation_jobs[i].job_location + '</p>\
                                </a>';
                        }
                        rec += '</div>';

                        $("#tour-hotjob-new").html(rec);
                        $("#tour-hotjob-new").show();

                    }
                }
            }
        });
    }

    //-- Re-enable recommendation
    $.getSimilarJobRecommendation = function (recType, jobId, hashed, limit, display_limit, category, location)
    {
        if (typeof recType == "undefined") {
            recType = 'trend';
        }
        if (typeof jobId == "undefined") {
            jobId = '';
        }
        if (typeof hashed == "undefined") {
            hashed = false;
        }
        if (typeof limit == "undefined") {
            limit = '';
        }
        if (typeof display_limit == "undefined") {
            display_limit = '';
        }
        if (typeof category == "undefined") {
            category = '';
        }
        if (typeof location == "undefined") {
            location = '';
        }

        var jsonData = {
            job_id: jobId,
            hashed: hashed,
            rec_type: recType,
            category: category,
            location: location,
            limit: limit,
            '_token': $('meta[name="csrf-token"]').attr('content'),
            '_method': "POST"
        };

        var request = $.ajax({
            url: canvas_url + "api/job/recommendation",
            data: jsonData,
            type: 'POST',
            crossDomain: true,
            dataType: 'json',
            timeout: 10000,
            error: function (jqXHR, textStatus, errorThrown) {
                console.log(textStatus);
                if (textStatus === "timeout") {
                    //do something on timeout
                    //alert("timeout");
                }
            }
        });
        request.done(function (data) {
            $('#spinner').hide();

            if (data.status == 'success') {
                var recommendation = data.recommendation;
                if (recommendation) {
                    var job = recommendation.recommendation_jobs;
                    var recommendation_heading = recommendation.recommendation_heading;
                    if (job.length > 0) {
                        var current = job.length;

                        var rec = '';

                        for (var i = 0; i < current; i++) {

                            if (job[i].category_title) {
                                var c_title = job[i].category_title;
                                var category_title = c_title.replace('.png', '', c_title);
                            } else {
                                var category_title = 'N/A';
                            }

                            if (job[i].platform_id) {
                                var platform_id = job[i].platform_id;
                                if (platform_id == 2)
                                    var ref = 'mkRecommend';
                                else if (platform_id == 5)
                                    var ref = 'inRecommend';
                                else
                                    var ref = 'rbRecommend';
                            } else {
                                var ref = 'rbRecommend';
                            }

                            rec += '<div class="job-detail-content" style="margin-top:15px;">\
                                        <div class=" job-list">\
                                            <div class="content">\
                                                <div class="content-wrap">\
                                                    <div class="content-pic">\
                                                        <div class="pic-wrap">\
                                                            <img src="' + job[i].logo + '">\
                                                        </div>\
                                                    </div>\
                                                    <a href="+job[i].job_url+" class="content-info" style="cursor:pointer;">\
                                                        <div class="info-wrap">\
                                                            <div class="info-right">\
                                                                <p class="job-date">' + job[i].created_at_human + '<i class="mdi mdi-timer"></i></p>\
                                                                <div class="job-type" onclick="initTooltip(event)" data-toggle="tooltip" title="" data-original-title="Full Time">\
                                                                    <div>' + job[i].job_type + '</div>\
                                                                    <i class="mdi mdi-star-outline"></i>\
                                                                </div>\
                                                            </div>\
                                                            <div class="info-left">\
                                                                <p class="job-title">' + job[i].job_title + '</p>\
                                                                <p class="job-name">' + job[i].company_title + '</p>\
                                                                <p class="job-cat">' + category_title + '</p>\
                                                                <p class="job-salary">\
                                                                    <i class="mdi mdi-currency-usd"></i>' + job[i].final_salary + '\
                                                                </p>\
                                                                <p class="job-location">\
                                                                    <i class="mdi mdi-map-marker"></i>' + job[i].job_location + '\
                                                                </p>\
                                                            </div>\
                                                        </div>\
                                                    </a>\
                                                </div>\
                                                <div class="content-action">\
                                                    <div class="row">\
                                                        <div class="left">\
                                                            <li class="hide">\
                                                                <a class="btn btn-default save_job_normal" data-id="' + job[i].job_id + '" id="savejobn-' + job[i].job_id + '">\
                                                                    <i class="mdi mdi-star-outline"></i>txt_save_button_featured\
                                                                </a>\
                                                            </li>\
                                                            <li>\
                                                                <a style="cursor:pointer;" class="btn btn-default fb-share-button" data-id="' + job[i].job_id + '" data-url="' + job[i].job_url + '">\
                                                                    <i class="mdi mdi-share"></i>' + txt_share_button + '\
                                                                </a>\
                                                            </li>\
                                                            <li>\
                                                                <a href="' + job[i].job_url + '?ref=' + ref + '" class="btn btn-default">\
                                                                    <i class="mdi mdi-eye"></i>' + txt_view_button + '\
                                                                </a>\
                                                            </li>\
                                                        </div>\
                                                        <div class="right">\
                                                            <li>\
                                                                <a href="' + canvas_url + '/job/apply-job?job_id=' + job[i].job_id + '?ref=' + ref + '" target="_blank" class="btn btn-info">\
                                                                    <i class="mdi mdi-check"></i>' + txt_apply_button + '\
                                                                </a>\
                                                            </li>\
                                                        </div>\
                                                    </div>\
                                                </div>\
                                            </div>\
                                        </div>\
                                    </div>';

                        }


                        $("#similar-job-recommend-list").html(rec);
                        $("#similar-job-recommend").show();

                    }
                }
            }
        });
    }

    

    $.getRelatedBetterJobs = function (page, params, categorysearch) {
        var search_keyword = decodeURIComponent(params['better_keyword']);
        search_keyword = encodeURIComponent(search_keyword);

        var search_location = decodeURIComponent(params['better_location']);
        var search_location_2 = decodeURIComponent(params['better_location']);
        var search_category = decodeURIComponent(params['better_category']);
        var search_education = "";
        var search_type = "";
        var search_salary = "";

        if (
                search_keyword == '' && (
                        (search_location != '0' && search_location != '') ||
                        (search_location_2 != '0' && search_location_2 != '') ||
                        (search_education != '0' && search_education != '') ||
                        (search_type != '0' && search_type != '') ||
                        (search_salary != '0' && search_salary != '')
                        )
                )
            search_keyword = '*';

        if (
                job_sorting_stuff.sorting == false && //if we didnt manually click to sort
                (search_keyword != '' || search_location_2 != '')
                ) {
            //set sorting by relevancy
            $('.sorting-thing').removeClass('active');
            $('#sorting-thing-relevancy').addClass('active');
            job_sorting_stuff.sort = 'Relevance';
            $("#sort_type").val('id');
            $("#sort_order").val('desc');
        }
        job_sorting_stuff.sorting = false; //reset the thing

        var search_category = params['better_category'];
        var resultDiv = '';
        var sort_by = $("#sort_type").val();
        var orderby = $("#sort_order").val();
        var current_page = parseInt($("#page").val());
        if (current_page > 1)
            page = current_page;
        var limit = 8;
        var start_limit = (page - 1) * limit;
        start_limit = (start_limit < 0) ? 0 : start_limit;

        var jsonData = {
            keyword: search_keyword,
            company_id: "",
            tag_name: "",
            job_type: "",
            search_location: (search_location_2 != '' ? search_location_2 : search_location),
            search_education: search_education,
            search_type: search_type,
            search_salary: search_salary,
            sort_by: "",
            search_category: search_category,
            orderby: "",
            start: start_limit,
            noOfRecords: limit,
            '_token': $('meta[name="csrf-token"]').attr('content'),
            '_method': "GET"
        };

        var request = $.ajax({
            url: canvas_url + "api/job/list",
            data: jsonData,
            type: 'GET',
            crossDomain: true,
            dataType: 'json'
        });

        $("#better-related-job").hide();
        $("#empty-job").hide();
        $('#engine-tech-issue-wrapper').hide();
        $("#better-paging").show();

        request.done(function (data) {
            $('#spinner').hide();

            if (data.status == 'success') {
                $.showJobsAvailable(data);
            } else {
                if (typeof categorysearch == "undefined") {
                    var param = [];
                    param["better_category"] = localStorage.getItem("search_category");
                    $.getRelatedBetterJobs(0, param, true);
                } else {
                    $.showNoJobsAvailable(data);
                }
            }

            $('.suggestion-thing-content').hide();
        });

        request.fail(function (jqXHR, textStatus) {
            $('#spinner').hide();
            $("#jobListing").hide();
            $("#total_counter").hide();
            $("#Paging").hide();
            $(".totalrec").html("0");
            if ($(guided_search_stuff.active_filters).children().length == 0)
            //$('#add-filter').hide();
            $('#add-filter').addClass('disabled');
            //$("#filter_sorting").addClass("hide");
            $("#n_count_results").val(0);
            setTimeout(function () {
                var nc = parseInt($("#n_count_results").val());
                var fc = parseInt($("#f_count_results").val());
                if (nc == 0 && fc == 0) {

                } else if (search_keyword != '' && nc == 0) {

                } else {

                }
            }, 1000);
        });
    }

    $.showJobsAvailable = function (data) {

        var resultDiv = '';

        var count = data.totalRecords;
        var totalNonFeatured = data.totalNonFeatured;
        var job = data.data;
        var current = job.length;
        var statusBar = '';
        var setClass = '';
        var setClass_h = '';
        var featuredBar = '';
        var hightlightAction = '';
        var clogo = '';
        var joburl = '';
        var applylink = '';
        var source = '';
        var save_class = '';
        var applied_class = '';
        var hightlighted_text = '';
        var newurl = cUrl.href;
        var has_badge = '';

        var idx = current >= 8 ? 8 : current;
        for (var i = 0; i < idx; i++) {

            if (job[i].logo != null && job[i].logo != '') {
                clogo = '<img src="' + job[i].logo + '" alt="' + job[i].company_name + ' Logo" class="">';
            } else {
                if (job[i].category_pic == null || job[i].category_pic == '') {
                    if (job[i].industry_id == null) {
                        job[i].industry_id = 1;
                    }
                    clogo = '<div class="splash-' + job[i].industry_id + '"></div>';
                } else {
                    clogo = '<img src="' + job[i].category_pic + '" alt="' + job[i].category_name + ' Category" class="">';
                }
            }

            if (job[i].company_privacy == 'private') {
                clogo = '<img src="https://s3-ap-southeast-1.amazonaws.com/brightan-assets/images/others/v1/private-company.jpg" alt="Private Company" class="">';
            }

            if (job[i].seo_link == null || typeof job[i].seo_link == undefined) {
                joburl = canvas_url + 'job/' + job[i].job_id + '-' + FilterURL(job[i].title);
            } else {
                joburl = canvas_url + 'job/' + job[i].job_id + '-' + job[i].seo_link;
            }

            if (job[i].seo_title != null || typeof job[i].seo_title != undefined) {
                if (newurl.indexOf("/en") != -1) {
                    joburl = canvas_url + 'en/job/' + job[i].job_id + '-' + FilterURL(job[i].seo_title);
                } else if (newurl.indexOf("/zh") != -1) {
                    joburl = canvas_url + 'zh/job/' + job[i].job_id + '-' + FilterURL(job[i].seo_title);
                } else
                    joburl = canvas_url + 'job/' + job[i].job_id + '-' + FilterURL(job[i].seo_title);
            }

            if (newurl.indexOf("/en") != -1)
            {
                applylink = canvas_url + 'en/job/apply-job?job_id=' + job[i].job_id;
            } else if (newurl.indexOf("/zh") != -1)
            {
                applylink = canvas_url + 'zh/job/apply-job?job_id=' + job[i].job_id;
            } else
                applylink = canvas_url + 'job/apply-job?job_id=' + job[i].job_id;

            source = '';

            if (job[i].apply_direct != null && job[i].apply_direct == 'yes')
            {
                applylink = job[i].apply_link;
                source = '<a class="right link-success-o comp" href="' + applylink + '" target="_blank"> ' + job[i].source + '</a> <i class="mdi mdi-radiobox-marked"></i>';
            }

            if (job[i].highlighted == 'yes' && job[i].is_featured == '0') {
                setClass_h = 'highlighted';
                hightlighted_text = '<span class="highlighted-icon"><i class="mdi mdi-star"></i></span>';
                if (source == '')
                    source = hightlighted_text;
                else
                    source = source + hightlighted_text;
            } else {
                setClass_h = '';
                hightlighted_text = '';
            }

            if (job[i].job_saved == 'false')
            {
                save_class = '<a class="btn btn-default save_job_normal" data-id="' + job[i].job_id + '" id="savejobn-' + job[i].job_id + '"><i class="mdi mdi-star-outline"></i> ' + txt_save + '</a> ';
            } else
            {
                save_class = '<a class="btn btn-default btn-job-saved disabled" data-id="' + job[i].job_id + '"><i class="mdi mdi-star"></i> ' + txt_job_saved + '</a>';
            }

            if (job[i].job_applied == 'false') {
                if (job[i].is_featured == '1')
                    applied_class = '<a href="' + applylink + '" target="_blank" class="btn btn-info featuredapply" onclick="trackEvent({ event:\'click\', key:\'job apply button\', value:\'' + job[i].job_id + '\' })"><i class="mdi mdi-check"></i> ' + txt_apply_button + '</a>';
                else
                    applied_class = '<a href="' + applylink + '" target="_blank" class="btn btn-info" onclick="trackEvent({ event:\'click\', key:\'job apply button\', value:\'' + job[i].job_id + '\' })"><i class="mdi mdi-check"></i> ' + txt_apply_button + '</a>';
            } else {
                applied_class = '<a target="_blank" class="btn btn-default btn-applied disabled"><i class="mdi mdi-check"></i> ' + txt_applied + '</a>';
            }

            if (job[i].area != '') {
                job[i].area = job[i].area + ' ,';
            }
            if (job[i].final_salary == 'RM' || job[i].final_salary == 'RM1-RM1' || job[i].final_salary == 'RMRM1' || job[i].final_salary == '')
                job[i].final_salary = txt_negotiable;
            if (job[i].final_salary == 0)
                job[i].final_salary = txt_negotiable;

            has_badge = 'hide';
            if (job[i].has_badge == 'yes')
                has_badge = '';

            //put a video in the middle of the job list
            if (i == Math.round(current / 2)) {
                resultDiv += '<div id="video-banner-0" class="video-details" style="margin:20px 0;"></div>\
                    <div id="video-modal-0" class="modal fade" role="dialog">\
                      <div class="modal-dialog">\
                        <div class="modal-content">\
                          <div class="modal-header" style="padding:3px 8px!important;">\
                            <button type="button" class="close" data-dismiss="modal">&times;</button>\
                          </div>\
                          <div class="modal-body"></div>\
                        </div>\
                      </div>\
                    </div>';
            }

            resultDiv += '<div class=" job-list ' + setClass_h + ' ' + (job[i].is_featured == '1' ? 'featured' : '') + '">\
              <div class="content">\
                  <div class="employer-badge-wrap ' + has_badge + '"><div class="employer-badge">\
                    <span class="icon">\
                      <img alt="Friendly Responsive" src="' + canvas_url + 'employer_assets/img/big-heart.png">\
                    </span>\
                    <span class="badge">Friendly Responsive</span>\
                  </div></div>\
                  <div class="content-wrap">\
                    <div class="content-pic">\
                     <div class="pic-wrap">\
                        ' + clogo + '\
                     </div>\
                    </div>\
                    <a href="' + joburl + '" class="content-info" style="cursor:pointer;">\
                        <div class="info-wrap">\
                            <div class="info-right">\
                              <p class="job-date">' + job[i].created_at_human + ' <i class="mdi mdi-timer"></i></p>\
                              <div class="job-type" onclick="initTooltip(event)" data-toggle="tooltip" title="' + job[i].job_type + '"><div>' + job[i].job_type + '</div> <i class="mdi mdi-star-outline"></i> </div>\
                            </div>\
                            <div class="info-left">\
                              <p class="job-title">' + job[i].title + '</p>\
                              <p class="job-name">' + job[i].company_name + '</p>\
                              <p class="job-salary"><i class="mdi mdi-currency-usd"></i> ' + job[i].final_salary + '</p>\
                              <p class="job-location"><i class="mdi mdi-map-marker"></i> ' + job[i].job_location + '</p>\
                            </div>\
                        </div>\
                    </a>\
                </div>\
                <div class="content-action">\
                  <div class="row">\
                    <div class="left">\
                        <li>' + save_class + '</li>\
                        <li><a style="cursor:pointer;" class="btn btn-default fb-share-button" data-id="' + job[i].job_id + '" data-url="' + joburl + '"><i class="mdi mdi-share"></i> ' + txt_share_button + '</a></li>\
                        <li><a href="' + joburl + '" class="btn btn-default"><i class="mdi mdi-eye"></i> ' + txt_view_button + '</a></li>\
                    </div>\
                    <div class="right">\
                      <li>' + applied_class + '</li>\
                    </div>\
                  </div>\
                </div>\
              </div>\
            </div>';
        }

        $("#betterJobListing").html(resultDiv);
        $("#better-related-job").show();
        $("#betterJobListing").show();

        getVideo({type: 'job-listing'}, function (videos) {
            $(videos).each(function (vi, v) {
                var v_html = '<div class=" job-list">\
                    <div class="content" data-toggle="modal" onClick="trackEvent({ event:\'click\', key:\'video in main page\', value:\'' + v.id + '\' });$(\'#video-modal-0 .modal-body\').html(video_stuff[\'video_' + vi + '\']);" data-target="#video-modal-0";>\
                        <div class="content-wrap">\
                            <div class="content-pic video">\
                                <i class="mdi mdi-youtube-play"></i>\
                                <div style="display:inline-block;float:left;">\
                                    <img src="' + v.thumbnail.replace('http://', 'https://') + '" style="float:left;width:200px;" class="video-img">\
                                </div>\
                            </div>\
                            <div class="content-info" style="cursor:pointer;display:inline-block;width:100%;margin-left: 10px; padding-right: 10px;">\
                                <div class="info-wrap" style="margin:0;">\
                                    <div class="info-left">\
                                        <p class="job-title">' + v.title + '</p>\
                                        <p class="job-name">' + v.description + '</p>\
                                        <p class="job-salary hide" style="float:left;margin-right:15px;">\
                                            <i class="mdi mdi-calendar"></i> ' + v.post_date + '\
                                        </p>\
                                        <p class="job-location hide">\
                                            <i class="mdi mdi-eye"></i> ' + v.views + '\
                                        </p>\
                                    </div>\
                                </div>\
                                <div class="content-action" style="bottom:15px;right:15px;position: absolute;">\
                                    <div class="right">\
                                        <li>\
                                            <a href="#" class="btn btn-info" onClick="return false;">\
                                                <i class="mdi mdi-play"></i> Play Now\
                                            </a>\
                                        </li>\
                                    </div>\
                                </div>\
                            </div>\
                        </div>\
                    </div>\
                </div>';

                $('#video-banner-0').html(v_html);
                video_stuff['video_' + vi] = '<iframe id="video-iframe-' + vi + '" width="560" height="315" style="display: block; width: 100%;" src="https://www.youtube.com/embed/' + v.y_id + '?showinfo=0&rel=0&autoplay=1" frameborder="0" allowfullscreen></iframe>';

                $('#video-modal-0').on('hidden.bs.modal', function () {
                    //$(promotional_videos[vi]).attr('src', promotional_videos[vi].attr('src').replace('&rel=0&autoplay=1', ''));
                    $('#video-modal-0 .modal-body').html('');
                })
            });
        });

        //layout();
        $('[data-toggle="tooltip"]').tooltip();

        $(".fb-share-button").bind("click", function () {
            var id = $(this).attr('data-id');
            var url = $(this).attr('data-url');
            FB.ui({
                method: 'share',
                href: url,
            }, function (response) {});
        });

        /*$(".save_job_normal").bind("click", function () {
            var id = $(this).attr('data-id');
            if ($(".save_job_normal").hasClass("disabled")) {
                return false;
            } else
            {
                $.post(canvas_url + "api/job/saved", {'job_id': id, '_token': $('meta[name="csrf-token"]').attr('content'), '_method': "POST"}, function (data) {
                    if (data.status == 'success')
                    {
                        $("#savejobn-" + id).removeClass("save_job_normal");
                        $("#savejobn-" + id).addClass("btn-job-saved");
                        $("#savejobn-" + id).addClass("disabled");
                        $("#savejobn-" + id).html('<i class="mdi mdi-star"></i> ' + txt_job_saved + '');
                        swal("DONE!", txt_job_saved_list, "success");
                    } else {
                        $(".save_job_normal").addClass("disabled");
                        notify(data.msg, "warning");
                    }

                }, "json");
            }
        });*/
    }

    $.showNoJobsAvailable = function (data) {
        var resultDiv = '';
        $("#better-related-job").hide();
        $("#total_counter").hide();
        $("#Paging").hide();
        $(".totalrec").html("0");
        if (
                $(guided_search_stuff.active_filters).children().length == 0
                && $("#search_keyword").val() != '*' && $("#search_keyword").val() != ''
                )
            //$('#add-filter').hide();
            $('#add-filter').addClass('disabled');

        $("#n_count_results").val(0);
        setTimeout(function () {
            var nc = parseInt($("#n_count_results").val());
            var fc = parseInt($("#f_count_results").val());
            if (nc == 0 && fc == 0) {
                $("#Paging").hide();
                if (data.msg == 'engine is down') {

                } else {
                    $('#better-related-job').hide();
                }
            } else if (
                    (search_keyword != '' || search_location_2 != '') &&
                    nc == 0
                    ) {
                $("#Paging").hide();
                if (data.msg == 'engine is down') {

                } else {
                    $('#better-related-job').hide();
                }
            } else {
                $("#empty-job").hide();
                $("#Paging").show();
            }
        }, 1000);
    }

    $("#browse-better-jobs-btn").bind("click", function () {
        $('#empty-better-job').hide();
        $('#better-related-job').hide();

        var search_keyword = localStorage.getItem("better_keyword");
        var search_location = localStorage.getItem("better_location");
        var qPage = 'q=' + search_keyword + "&loc=" + search_location;
        $("#search_keyword").val(search_keyword)
        $("#search_location_2").val(search_location)
        $("#search_salary").val("")

        search_keyword = search_keyword.replace(/ /g, '_');
        search_keyword = search_keyword.replace(/&/g, '%26');
        window.location = canvas_url + '#' + qPage;
        localStorage.setItem('qPage', qPage);

        $(".remove-filter").trigger("click");
        //$.getJobs(0);

    });

    

    $.getFeaturedJobs = function (page, filter_only) {
        //disabled because now we get normal jobs and featured jobs in the same function
        return false;
    }

    $(".save_askhelp").bind("click", function (e) {
        e.preventDefault();
        if ($(".save_askhelp").hasClass("disabled")) {
            return false;
        } else {
            var arrValues = validateForm('askhelp');
            if ($.isArray(arrValues)) {

                //dob
                if ($('#askhelp-dob').length) {
                    var alert_dob = $('#askhelp-dob').val();
                    if (alert_dob === '') {
                        $("#askhelp-dob").parent().addClass('error');
                        go('#askhelp-dob', 150, 500);
                        $.notify(notify_msg.required.birth);
                        return false;
                    }
                    if (!validateDate(alert_dob)) {
                        $("#askhelp-dob").parent().addClass('error');
                        go('#askhelp-dob', 150, 500);
                        $.notify(notify_msg.invalid.date);
                        return false;
                    }
                }

                //Salary
                if (!validateInt($('#askhelp-expected-salary').val())) {
                    $("#askhelp-expected-salary").parent().addClass('error');
                    go('#askhelp-expected-salary', 150, 500);
                    $.notify(notify_msg.invalid.salary);
                    return false;
                }

                //Internsheeps
                if ($('#askhelp-start').length) {
                    var is_start_date = $('#askhelp-start').val();
                    var is_end_date = $('#askhelp-end').val();

                    if (is_start_date === '') {
                        $("#askhelp-start").parent().addClass('error');
                        go('#askhelp-start', 150, 500);
                        $.notify(notify_msg.required.start_date);
                        return false;
                    }
                    if (!validateDate(is_start_date)) {
                        $("#askhelp-start").parent().addClass('error');
                        go('#askhelp-start', 150, 500);
                        $.notify(notify_msg.invalid.date);
                        return false;
                    }
                    if (is_end_date === '') {
                        $("#askhelp-end").parent().addClass('error');
                        go('#askhelp-end', 150, 500);
                        $.notify(notify_msg.required.end_date);
                        return false;
                    }
                    if (!validateDate(is_end_date)) {
                        $("#askhelp-end").parent().addClass('error');
                        go('#askhelp-end', 150, 500);
                        $.notify(notify_msg.invalid.date);
                        return false;
                    }
                }

                var $btn = $(this);
                $btn.button("loading");
                sendNewSuggestion();
                arrValues['askhelp-contact'] = cleanPhone(arrValues['askhelp-contact']);
                $.post(canvas_url + "api/jobseeker/jobalert", {
                    'title': 'Ask Help',
                    'keywords': arrValues['askhelp-keywords'],
                    'category': arrValues['askhelp-prefer-categories'],
                    'expected_salary_curr': arrValues['askhelp-expected-salary-curr'],
                    'expected_salary': arrValues['askhelp-expected-salary'],
                    'country': arrValues['askhelp-country'],
                    'state': $("#new_state_id-askhelp").val(),
                    'city': arrValues['askhelp-city'],
                    'level': arrValues['askhelp-education'],
                    'university': arrValues['askhelp-uni'],
                    'major': arrValues['askhelp-major'],
                    'internship_start': (typeof is_start_date !== 'undefined') ? is_start_date : "",
                    'internship_end': (typeof is_end_date !== 'undefined') ? is_end_date : "",
                    'dob': $('#askhelp-dob').val(),
                    'gender': arrValues['askhelp-gender-thing'],
                    'name': arrValues['askhelp-name'],
                    'jobalert_email': arrValues['askhelp-email'],
                    'jobalert_contact': arrValues['askhelp-contact'],
                    'job_type': $('#askhelp-prefer-jobtype').val(),
                    '_token': $('meta[name="csrf-token"]').attr('content'),
                    '_method': "POST"
                }, function (data) {
                    if (data.status == 'success') {
                        /*swal({   
                         title: txt_done_label,   
                         text: txt_job_alert_saved,   
                         type: "success",
                         html: true,
                         showConfirmButton: true 
                         }, function(isConfirm){   
                         window.location = canvas_url;                    
                         });*/
                        $.notify(txt_job_alert_askhelp, {type: 'success', timer: 10000});
                        setTimeout(function () {
                            //window.location = canvas_url;
                            $('#askhelp').modal('hide');
                            window.location = canvas_url;
                            $btn.button('reset');
                        }, timeout_redirect);
                    } else {
                        //swal("Opps!", "There seems to be an error in saving alert details."+" "+data.msg, "warning");
                        $.notify(data.msg);
                        $btn.button('reset');
                    }
                }, "json");
            }
        }
    });

    /****************************************** Update Jobseeker ********************************/
    $(".submit_updatejobseeker").bind("click", function () {
        var platform_id = $("#platform_id").val();
        var user_id = $("#user_id").val();
        var name = $("#name").val();
        var email = $("#email").val();
        var password = $("#password").val();
        var phone = $("#register_phone").val();

        if ($(".submit_updatejobseeker").hasClass("disabled")) {
            return false;
        } else
        {
            $("#phone-div").css({"border": "none"});
            $("#name-div").removeClass("has-error");
            $("#email-div").removeClass("has-error");
            $("#password-div").removeClass("has-error");
            $("#platform_id-div").removeClass("has-error");

            if (platform_id == '0')
            {
                $("#platform_id-div").addClass("has-error");
                $("#platform_id").focus();
                return false;
            } else if (name == '')
            {
                $("#name-div").addClass("has-error");
                $("#name").focus();
                return false;
            } else if (email == '')
            {
                $("#email-div").addClass("has-error");
                $("#email").focus();
                return false;
            } else if (validateEmail(email) == false)
            {
                $("#email-div").addClass("has-error");
                $("#email").focus();
                return false;
            } else if (password == '')
            {
                $("#password").addClass("has-error");
                $("#password").focus();
                return false;
            } else
            {
                $.post("../api/admin/jobseeker/" + user_id, {'platform_id': platform_id, 'user_id': user_id, 'name': name, 'email': email, 'password': password, 'phone': phone, '_token': $('meta[name="csrf-token"]').attr('content'), '_method': "PUT"}, function (data) {
                    if (data.status == 'success')
                    {
                        swal({
                            title: txt_done_label,
                            text: txt_job_saved_success,
                            type: "success",
                            html: true,
                            showConfirmButton: true
                        }, function (isConfirm) {
                            window.location = "jobseeker-list";
                        });
                    } else
                    {
                        swal("Opps!", "There seems to be an error in saving Jobseeker details." + " " + data.msg, "warning");
                    }

                }, "json");
            }
        }
    });

    $(".save_resume").bind("click", function () {
        var btn = $(this);
        var resume_title = $("#resume_title").val();
        var resume_filename = $("#resume_filename").val();
        var job_id = $("#job_id").val();

        if ($(".save_resume").hasClass("disabled")) {
            return false;
        } else {
            $("#resume_title").css({"border": "1px solid #EBEBEB"});
            $("#resume_filename-div").css({"border": "none"});

            if (resume_title == '') {
                $("#resume_title").css({"border": "1px solid #fccbc7"});
                $.notify(notify_msg.required.resume_title);
                return false;
            } else if (resume_filename == '') {
                $("#resume_file-div").css({"border": "1px solid #fccbc7"});
                $.notify(txt_plz_upload_resume);
                return false;
            } else {
                btn.button("loading");
                $.post(canvas_url + "api/jobseeker/resume", {'resume_title': resume_title, 'resume_filename': resume_filename, 'job_id': job_id, '_token': $('meta[name="csrf-token"]').attr('content'), '_method': "POST"}, function (data) {
                    btn.button("reset");
                    if (data.status == 'success') {
                        
                        $("#resume_frame").attr("src", canvas_url + "upload_resume.php");
                        $("#resume_title").val("");
                        $("#resume_filename").val("");
                        $('#resume_id').append($('<option>', {
                            value: data.data.resume_id,
                            text: resume_title
                        }));

                        
                        $(".modal").modal("hide"); //hide modal
                        if($('.jobseeker-timeline-page').length > 0){
                            getAllResumes(); //update on timeline page
                        }else if($('.jobseeker-profile-page').length > 0){
                            window.location = canvas_url + 'jobseeker/resumes';//profile page
                        }
                        else{
                            getJobseekerResumes(); //update on resume page
                        }

                        //show message
                        // swal({
                        //   title: txt_done_label,
                        //   text: txt_resume_upload_successfully,
                        //   type: 'success',
                        //   confirmButtonText: 'Ok, Thanks',
                        //   confirmButtonClass: 'btn btn-primary',
                        //   buttonsStyling: false
                        // });
                        

                    } else {
                        $.notify(data.data);
                    }
                }, "json").fail(function () {
                    btn.button("reset");
                    $.notify('There seems to be a problem, please try again.');
                });
            }
        }
    });

    $(".upload_newresume").bind("click", function () {
        var resume_title = $("#resume_title").val();
        var resume_filename = $("#resume_filename").val();
        var job_id = $("#job_id").val();
        var cp = $("#cp").val();
        if ($(".save_resume").hasClass("disabled")) {
            return false;
        } else {
            $("#resume_title").css({"border": "1px solid #EBEBEB"});
            $("#resume_filename-div").css({"border": "none"});
            $("#resume_error").hide();

            if (resume_title == '') {
                $("#resume_title").css({"border": "1px solid #fccbc7"});
                //$("#resume_title").focus();
                //go('#resume_title', 150, 500);
                $.notify(notify_msg.required.resume_title);
                return false;
            } else if (resume_filename == '') {
                /*$("#resume_error").fadeIn("fast");
                 setTimeout(function(){
                 $("#resume_error").fadeOut("fast");
                 }, 3000);*/
                $("#resume_file-div").css({"border": "1px solid #fccbc7"});
                //$("#resume_filename").focus();
                $.notify(txt_plz_upload_resume);
                return false;
            } else {
                $("#resume-spinner").show();
                $.post(canvas_url + "api/jobseeker/uploadResume", {'resume_title': resume_title, 'resume_filename': resume_filename, 'job_id': job_id, 'cp': cp, '_token': $('meta[name="csrf-token"]').attr('content'), '_method': "POST"}, function (data) {
                    if (data.status == 'success') {
                        $("#resume_frame").attr("src", canvas_url + "upload_resume.php");
                        $("#resume_title").val("");
                        $("#resume_filename").val("");
                        /*swal({   
                         title: txt_done_label,   
                         text: txt_resume_upload_successfully,   
                         type: "success",
                         html: true,
                         showConfirmButton: true 
                         }, function(isConfirm){   
                         window.location = canvas_url+"jobseeker/account?resumeuploaded=yes";  
                         
                         });*/
                        setTimeout(function () {
                            window.location = canvas_url + "jobseeker/resumes?resumeuploaded=yes";
                        }, timeout_redirect);
                    } else {
                        //swal("Opps!", "There seems to be an error in saving resume details."+" "+data.msg, "warning");
                        $.notify(data.msg);
                    }
                    $("#resume-spinner").hide();
                }, "json").fail(function () {
                    $.notify('There seems to be a problem, please try again.');
                });
            }
        }
    });

    $(".apply_jobBKKKKKK").bind("click", function (e) {
        e.preventDefault(); //prevent the page from jolting up to the top

        var resume_id = $("#resume_id").val();
        var cover_letter = $("#cover_letter").val();
        var cover_letter_english = $("#cover_letter_english").val();
        var expected_salary_cur = $("#expected_salary_cur").val();
        var expected_salary = $("#expected_salary").val();
        var apply_email = $("#apply_email").val();
        var apply_phone = $("#apply_phone").val();
        var selectedDialCode = $(".selected-dial-code").html();
        if (selectedDialCode=='') selectedDialCode = '+60';
        var base_country = '';// Nationality
        var job_id = $("#job_id").val();
        var ref = $("#ref").val();
        var saving_exp = $("#saving_exp").val(); //showing experience thing or not?
        var saving_exp_logged_in = 'no';
        var saved_exp_data = {}; //data
        var saved_exp_data_string = ''; //stringified data
        var usercontact = $("#usercontact").val(); //ask profile question or not?
        var resume_check = $('input[name=resume_check]:checked').val();
        var $btn = $(this);
        var login_first_before_apply = $btn.attr('data-login-first') != undefined;
        var warning_input = {};
        var photo_filename = $('#photo_filename').val();
        var apply_edit_phone_status = $('#apply_edit_phone_status').val();
        var apply_edit_email_status = $('#apply_edit_email_status').val();
        var apply_edit_email = $('#apply_edit_email').val();
        var apply_edit_phone = $('#apply_edit_phone').val();

        if (typeof apply_edit_phone != "undefined" && apply_edit_phone != '')
        {
           apply_edit_phone = apply_edit_phone.replace("-","");
           apply_edit_phone = apply_edit_phone.replace(" ","");
        }

        //Internsheeps        
        var is_start_date = '';
        var is_end_date = '';
        var is_graduation_date = '';
        if ($('#is_start_date').length) {
            is_start_date = $('#is_start_date').val();
            is_end_date = $('#is_end_date').val();
            is_graduation_date = $('#is_graduation_date').val();
        }
        var has_badge = '';

        var hahaha = '';
        if (apply_edit_email_status != undefined && apply_edit_email_status == 'false') {
            $("#apply_edit_email").parent().addClass('error');
            go('#top_content', 150, 500);
            hahaha += txt_user_exist;
        } else if (apply_edit_email_status != undefined && apply_edit_email != '' && validateEmail(apply_edit_email) == false) {
            $("#apply_edit_email").parent().addClass('error');
            go('#top_content', 150, 500);
            hahaha += (hahaha == '' ? txt_correct_email_address : '<br>' + txt_correct_email_address);
        }
        if (typeof apply_edit_phone_status != "undefined" && apply_edit_phone_status == 'false') {
            $("#apply_edit_phone").parent().addClass('error');
            go('#top_content', 150, 500);
            hahaha += (hahaha == '' ? txt_user_exist_phone_only : '<br>' + txt_user_exist_phone_only);
        } else if (typeof apply_edit_phone != "undefined" && apply_edit_phone == '') {
            $("#apply_edit_phone").parent().addClass('error');
            go('#top_content', 150, 500);
            hahaha += (hahaha == '' ? txt_enter_phone_number : '<br>' + txt_enter_phone_number);
        }/* else if (!$("#apply_edit_phone").intlTelInput("isValidNumber")){
         $("#apply_edit_phone").parent().addClass('error');
         go('#top_content', 150, 500);
         hahaha += (hahaha == '' ? notify_msg.invalid.phone : '<br>' + notify_msg.invalid.phone);
         ;
         }*/
        if (hahaha != '') {
            $.notify(hahaha);
            return false
        }
        ;

        if (login_first_before_apply) {
            //$('#m-login').hide();
            //$('#fb-contact-prompt').show();
            //$('#login-first-modal').modal();
            //return false;
        }
        
        if ($('#basenationality-div').is(':visible')) {
            base_country = $("#base_country").val();
        }

        //dynamic input fields for logged in users filtering warning messages
        if ($('#confirming-profile').val() == 'true') {
            if ($('#nationality-div').is(':visible') && $('input[name=nationality]:checked').length > 0)
                warning_input.nationality = $('input[name=nationality]:checked').attr('data-val');

            if ($('#work_permit-div').is(':visible') && $('input[name=work_permit]:checked').length > 0)
                warning_input.work_permit = $('input[name=work_permit]:checked').val();
            
            if ($('#ic-div').is(':visible')) {
                if ($('#ic').val() != '')
                    warning_input.ic = $('#ic').val();
                else {
                    $("#ic").parent().addClass('error');
                    go('#ic-div', 150, 500);
                    $.notify(notify_msg.required.ic_number);
                    return false;
                }
            }

            if ($('#dob-div').is(':visible')) {
                if ($('#dob').val() != '')
                    warning_input.dob = $('#dob').val();
                else {
                    $("#dob").parent().addClass('error');
                    go('#dob-div', 150, 500);
                    $.notify(notify_msg.required.birth);
                    return false;
                }
            }

            if ($('#gender-div').is(':visible') && $('input[name=gender]:checked').length > 0)
                warning_input.gender = $('input[name=gender]:checked').val();

            if ($('#relocate-div').is(':visible') && $('input[name=willing-to-relocate]:checked').length > 0)
                warning_input.relocate = $('input[name=willing-to-relocate]:checked').val();

            if ($('#ae_degree-div').is(':visible') && $('#ae_degree').val() != '')
                warning_input.qualification = $('#ae_degree').val();

            if ($('#language1').is(':visible') && $('input[name=language1]:checked').length > 0)
                warning_input.english = $('input[name=language1]:checked').val();

            if ($('#language2').is(':visible') && $('input[name=language2]:checked').length > 0)
                warning_input.malay = $('input[name=language2]:checked').val();

            if ($('#language3').is(':visible') && $('input[name=language3]:checked').length > 0)
                warning_input.chinese = $('input[name=language3]:checked').val();

            if ($('#otherlanguage').is(':visible') && $('input[name=otherlanguage]:checked').length > 0)
                warning_input.tamil = $('input[name=otherlanguage]:checked').val();
        }

        if ($(".apply_job").hasClass("disabled")) {
            return false;
        } else {
            if (typeof apply_email != 'undefined' && apply_email != 'na' && apply_email != '' && validateEmail(apply_email) == false) {
                $("#apply_email").parent().addClass('error');
                go('#apply_email', 150, 500);
                $.notify(txt_correct_email_address);
                return false;
            }
            if (typeof apply_phone != 'undefined' && apply_phone == '') {
                $("#apply_phone").parent().addClass('error');
                go('#apply_phone', 150, 500);
                $.notify(notify_msg.required.contact_number);
                return false;
            }

            if (typeof apply_phone != 'undefined' && !$.isNumeric(apply_phone)) {
                $("#apply_phone").parent().addClass('error');
                go('#apply_phone', 150, 500);
                $.notify(notify_msg.invalid.phone);
                return false;
            }
            
            if (typeof apply_edit_phone != 'undefined' && !$.isNumeric(apply_edit_phone)) {
                $("#apply_edit_phone").parent().addClass('error');
                go('#apply_edit_phone', 150, 500);
                $.notify(notify_msg.invalid.phone);
                return false;
            }
            
            //Internsheeps
            if ($('#is_start_date').length) {
                if (is_start_date === '') {
                    $("#is_start_date").parent().addClass('error');
                    go('#is_start_date', 150, 500);
                    $.notify(notify_msg.required.start_date);
                    return false;
                }
                if (!validateDate(is_start_date)) {
                    $("#is_start_date").parent().addClass('error');
                    go('#is_start_date', 150, 500);
                    $.notify(notify_msg.invalid.date);
                    return false;
                }
                if (is_end_date === '') {
                    $("#is_end_date").parent().addClass('error');
                    go('#is_end_date', 150, 500);
                    $.notify(notify_msg.required.end_date);
                    return false;
                }
                if (!validateDate(is_end_date)) {
                    $("#is_end_date").parent().addClass('error');
                    go('#is_end_date', 150, 500);
                    $.notify(notify_msg.invalid.date);
                    return false;
                }
                if (is_graduation_date === '') {
                    $("#is_graduation_date").parent().addClass('error');
                    go('#is_graduation_date', 150, 500);
                    $.notify(txt_graduation_date);
                    return false;
                }
                if (!validateDate(is_graduation_date)) {
                    $("#is_graduation_date").parent().addClass('error');
                    go('#is_graduation_date', 150, 500);
                    $.notify(notify_msg.invalid.date);
                    return false;
                }
            }
            if (expected_salary == '') {
                $("#expected_salary").parent().addClass('error');
                go('#expected_salary', 150, 500);
                $.notify(txt_enter_expected_sa);
                return false;
            }

            //if the user has been asked for their experience (asked at the first step) save it first
            if (saving_exp == 'yes') {
                //saved_exp_data.first_time_working = $("input[name=first_time_working]:option selected").val(); 
                saved_exp_data.first_time_working = $("input[name=first_time_working]:checked").val();
                //saved_exp_data.currently_working = $("#currently_working").val();
                saved_exp_data.currently_working = $("input[name=currently_working]:checked").val();
                saved_exp_data.current_company_name = $("#current_company_name").val();
                saved_exp_data.current_title = $("#current_title").val();
                saved_exp_data.current_salary_curr = $("#current_salary_curr").val();
                saved_exp_data.current_salary = $("#current_salary").val();
                saved_exp_data.job_description = $("#current_description").val();
                saved_exp_data.previous_company_name = $("#previous_company_name").val();
                saved_exp_data.previous_title = $("#previous_title").val();
                saved_exp_data.previous_salary_curr = $("#previous_salary_curr").val();
                saved_exp_data.previous_salary = $("#previous_salary").val();
                saved_exp_data.previous_job_description = $("#previous_description").val();

                //everything is required
                if (typeof saved_exp_data.first_time_working == 'undefined') {
                    $('#first_time_working').addClass('error');
                    //$('#first_time_working').focus();
                    go('#first_time_working', 150, 500);
                    $.notify(notify_msg.required.first_time_working);
                    return;
                } else if (saved_exp_data.first_time_working == 'No') {
                    if (typeof saved_exp_data.currently_working == 'undefined') {
                        $('#currently_working').addClass('error');
                        //$('#currently_working').focus();
                        go('#currently_working', 150, 500);
                        $.notify(notify_msg.required.currently_working);
                        return;
                    } else if (saved_exp_data.currently_working == 'Yes') {
                        //validate current company
                        if (saved_exp_data.current_company_name == '') {
                            $('#current_company_name').parent().addClass('error');
                            //$('#current_company_name').focus();
                            go('#current_company_name', 150, 500);
                            $.notify(notify_msg.required.company_name);
                            return;
                        } else if (saved_exp_data.current_title == '') {
                            $('#current_title').parent().addClass('error');
                            go('#current_title', 150, 500);
                            $.notify(notify_msg.required.job_title);
                            return;
                        } else if (saved_exp_data.job_description == '') {
                            $('#current_description').parent().addClass('error');
                            go('#current_description', 150, 500);
                            $.notify(notify_msg.required.job_description);
                            return;
                        } else if (saved_exp_data.current_salary == '') {
                            $('#current_salary').parent().addClass('error');
                            go('#current_salary', 150, 500);
                            $.notify(notify_msg.required.salary);
                            return;
                        } else if (!$.isNumeric(saved_exp_data.current_salary)) {
                            $('#current_salary').parent().addClass('error');
                            go('#current_salary', 150, 500);
                            $.notify(notify_msg.invalid.salary);
                            return;
                        }
                    } else if (saved_exp_data.currently_working == 'No') {
                        //validate previous company
                        if (saved_exp_data.previous_company_name == '') {
                            $('#previous_company_name').parent().addClass('error');
                            go('#previous_company_name', 150, 500);
                            $.notify(notify_msg.required.company_name);
                            return;
                        } else if (saved_exp_data.previous_title == '') {
                            $('#previous_title').parent().addClass('error');
                            go('#previous_title', 150, 500);
                            $.notify(notify_msg.required.job_title);
                            return;
                        } else if (saved_exp_data.previous_job_description == '') {
                            $('#previous_description').parent().addClass('error');
                            go('#previous_description', 150, 500);
                            $.notify(notify_msg.required.previous_job_description);
                            return;
                        } else if (saved_exp_data.previous_salary == '') {
                            $('#previous_salary').parent().addClass('error');
                            //$('#previous_salary').focus();
                            go('#previous_salary', 150, 500);
                            $.notify(notify_msg.required.salary);
                            return;
                        } else if (!$.isNumeric(saved_exp_data.previous_salary)) {
                            $('#previous_salary').parent().addClass('error');
                            //$('#previous_salary').focus();
                            go('#previous_salary', 150, 500);
                            $.notify(notify_msg.invalid.salary);
                            return;
                        }
                    }
                }
                saving_exp_logged_in = 'yes';

                //if logged in we save this thing in the profile
                if (saving_exp_logged_in == 'yes') {
                    saved_exp_data._token = $('meta[name="csrf-token"]').attr('content');
                    saved_exp_data._method = 'POST';
                    //$.post(canvas_url+"api/jobseeker/field", saved_exp_data, function(data) {}, "json");
                }
                saved_exp_data_string = JSON.stringify(saved_exp_data);
            }

            if (!$.isNumeric(expected_salary)) {
                $("#expected_salary").parent().addClass('error');
                go('#expected_salary', 150, 500);
                $.notify(notify_msg.invalid.salary);
                return false;
            }
            if (resume_id == '0') {
                $("#resume_id").parent().addClass('error');
                //$("#resume_id").focus();
                go('#resume_id', 150, 500);
                $.notify(txt_plz_upload_resume);
                return false;
            }
            if (resume_id == 'na' && typeof resume_check == 'undefined') {
                $("#resume_id").parent().addClass('error');
                go('#resume_id', 150, 500);
                $.notify(notify_msg.required.no_resume_reason);
                return false;
            }
            if (cover_letter == '') {
                $("#cover_letter").parent().addClass('error');
                go('#cover_letter', 150, 500);
                $.notify(notify_msg.required.coverletter);
                return false;
            }
            /*if(DETECT CHINESE in cover_letter && detect empty or chinese in cover_letter_english) {
             $("#cover_letter").parent().addClass('error');
             go('#cover_letter', 150, 500);
             $.notify(notify_msg.required.coverletter);
             return false;
             }*/

            sendNewSuggestion();

            //show profile question?
            if (usercontact == 'yes') {
                $("#apply-form").fadeOut('fast', function () {
                    $("#no-contact").fadeIn('fast', function () {
                        //the user has clicked "submit" for the first time and now we should display profile questions
                        if (first_step) {
                            //halt everything and simply scroll up to the top
                            go('#top_content', 150, 500);
                            first_step = false;
                        }
                    });
                });
                if (first_step)
                    return false;

                var allow_apply = false;

                if ($(this).attr('data-action') == 'skip') {
                    //clicked to skip details input, go straight to apply
                    allow_apply = true;
                } else {
                    //clicked to send profile details and apply
                    //find out what type of question to display
                    var question_type = $('#question_type').val();

                    switch (question_type) {
                        case 'required-values':
                            //required values to send only
                            var name = $("#name").val();
                            var availability = $('input[name=availability]:checked').val();
                            var nationality = $('input[name=nationality]:checked').attr('data-val');
                            var ic = $("#ic").val();
                            var work_permit = $('input[name=work_permit]:checked').attr('data-val');
                            var passport = $("#passport").val();
                            var dob = $("#dob").val();
                            var gender = '';
                            if ($('input[name=gender]:checked').length > 0)
                                gender = $('input[name=gender]:checked')[0].value;
                            //languages
                            var language1 = 'English';
                            var language_rate1 = $("input[name=language1]:checked").val();
                            var language2 = 'Bahasa Malaysia';
                            var language_rate2 = $("input[name=language2]:checked").val();
                            var language3 = 'Chinese';
                            var language_rate3 = $("input[name=language3]:checked").val();
                            var otherlanguage = 'Tamil';
                            var otherlanguage_rate = $("input[name=otherlanguage]:checked").val();
                            if (typeof language_rate1 == 'undefined')
                                language_rate1 = '';
                            if (typeof language_rate2 == 'undefined')
                                language_rate2 = '';
                            if (typeof language_rate3 == 'undefined')
                                language_rate3 = '';
                            if (typeof otherlanguage_rate == 'undefined')
                                otherlanguage_rate = '';
                            //education
                            var currently_studing = $("#currently_studing").is(':checked');
                            var ae_school_name = $("#ae_school_name").val();
                            var ae_degree = $("#ae_degree").val();
                            var aedu_start_date = $("#aedu_start_date").val();
                            var aedu_end_date = $("#aedu_end_date").val();
                            var ae_major = $("#ae_major").val();

                            //validate the ic number
                            var invalid_ic = '';
                            if ($("#ic").val() != undefined && ic != '') {
                                var ic_yy = ic.substr(0, 2);
                                var ic_mm = ic.substr(2, 2);
                                var ic_dd = ic.substr(4, 2);
                                var y = new Date().getFullYear();
                                if (ic_yy <= 15 && ic_yy >= 0) {
                                    ic_yy = "20" + ic_yy;
                                } else {
                                    ic_yy = "19" + ic_yy;
                                }
                                var current_dob = ic_yy + '-' + ic_mm + '-' + ic_dd;
                                var dd = new Date(current_dob);
                                if (ic.length != 14) {
                                    dd = 'Invalid Date';
                                }
                                if (dd == 'Invalid Date') {
                                    invalid_ic = txt_invalid_ic;
                                }
                            }

                            //required values to save
                            var willing_to_relocate = $("#willing-to-relocate").val();
                            var address1 = $("#address1").val();
                            var city = $("#city").val();
                            var postal_code = $("#postal_code").val();
                            //var area = $("#area").val();
                            var country = $("#country").val();
                            /*if ($('input[name=country]:checked').siblings()[0] != undefined)
                                country = $('input[name=country]:checked').siblings()[0].innerHTML;*/
                            //var contact_number = $("#contact_number").val();
                            if (country == '' || country == '0' || country == 'Other') {
                                var state = $("#Other-state").val();
                            } else {
                               // var state = $("#" + country + "-state").val();
                                var state = $("#new_state_id").val();
                            }

                            //required values that won't overwrite existing values
                            if (document.getElementById('name') != null & name == '') {
                                $("#name").parent().addClass('error');
                                go('#name', 150, 500);
                                $.notify(notify_msg.required.name);
                                return false;
                            } else if (document.getElementById('availability-div') != null && (availability == undefined || availability == '' || availability == txt_select_one || availability == "0")) {
                                $("#availability-div").addClass('error');
                                go('#availability-div', 150, 500);
                                $.notify(notify_msg.required.availability);
                                return false;
                            } else if (document.getElementById('nationality-div') != null && (nationality == undefined || nationality == '' || nationality == txt_select_one)) {
                                $("#nationality-div").addClass('error');
                                go('#nationality-div', 150, 500);
                                $.notify(notify_msg.required.nationality);
                                return false;
                            } else if ($("#ic").length > 0 && nationality == 'Malaysian' && ic == '') {
                                $("#ic").parent().addClass('error');
                                go('#ic', 150, 500);
                                $.notify(notify_msg.required.ic_number);
                                return false;
                            } else if ($("#ic").length > 0 && nationality == 'Malaysian' && invalid_ic.length > 0) {
                                $("#ic").parent().addClass('error');
                                go('#ic', 150, 500);
                                $.notify(invalid_ic);
                                return false;
                            } else if (nationality == 'Non-Malaysian') {
                                var el_t = '';
                                var el_msg = '';
                                if ($("#work_permit-div").length > 0 && (work_permit == undefined || work_permit == '')) {
                                    $('#work_permit-div').addClass('error');
                                    go('#work_permit-div', 150, 500);
                                    $.notify(notify_msg.required.work_permit);
                                    return false;
                                } else if ($("#passport").length > 0 && passport == '') {
                                    $('#passport').parent().addClass('error');
                                    go('#passport', 150, 500);
                                    $.notify(notify_msg.required.passport);
                                    return false;
                                } else if ($("#gender-div").length > 0 && (gender == '' || gender == txt_select_one)) {
                                    $('#gender-div').addClass('error');
                                    go('#gender-div', 150, 500);
                                    $.notify(notify_msg.required.gender);
                                    return false;
                                }
                            }
                            if ($("#dob").length > 0 && dob == '' && $('#dob').is(':visible') == true) {
                                $('#dob').parent().addClass('error');
                                go('#dob', 150, 500);
                                $.notify(notify_msg.required.birth);
                                return false;
                            }

                            if ($("input[name=language1]").length > 0 && language_rate1 == '') {
                                $("#language1").addClass('error');
                                go('#language1', 150, 500);
                                $.notify(notify_msg.required.language1);
                                return false;
                            } else if ($("input[name=language2]").length > 0 && language_rate2 == '') {
                                $("#language2").addClass('error');
                                go('#language2', 150, 500);
                                $.notify(notify_msg.required.language1);
                                return false;
                            } else if ($("input[name=language3]").length > 0 && language_rate3 == '') {
                                $("#language3").addClass('error');
                                go('#language3', 150, 500);
                                $.notify(notify_msg.required.language1);
                                return false;
                            } else if ($("input[name=otherlanguage]").length > 0 && otherlanguage_rate == '') {
                                $("#otherlanguage").addClass('error');
                                go('#otherlanguage', 150, 500);
                                $.notify(notify_msg.required.language1);
                                return false;
                            } else if ($("#ae_school_name").length > 0 && ae_school_name == '') {
                                $("#ae_school_name").parent().addClass('error');
                                go('#ae_school_name', 150, 500);
                                $.notify(notify_msg.required.school);
                                return false;
                            } else if ($("#ae_degree").length > 0 && ae_degree == '') {
                                $("#ae_degree").parent().addClass('error');
                                go('#ae_degree', 150, 500);
                                $.notify(notify_msg.required.degree);
                                return false;
                            } else if ($("#aedu_start_date").length > 0 && aedu_start_date == '') {
                                $("#aedu_start_date").parent().addClass("error");
                                go('#aedu_start_date', 150, 500);
                                $.notify(notify_msg.required.start_date);
                                return false;
                            } else if ($("#aedu_end_date").length > 0 && currently_studing == false && aedu_end_date == '') {
                                $("#aedu_end_date").parent().addClass("error");
                                go('#aedu_end_date', 150, 500);
                                $.notify(notify_msg.required.end_date);
                                return false;
                            } else if ($("#ae_major").length > 0 && ae_major == '') {
                                $("#ae_major").parent().addClass("error");
                                go('#ae_major', 150, 500);
                                $.notify(notify_msg.required.major);
                                return false;
                            }

                            //required values that will overwrite existing values
                            //if(document.getElementById('name') != null)
                            if (document.getElementById('address1') != null & address1 == '') {
                                $("#address1").parent().addClass('error');
                                go('#address1', 150, 500);
                                $.notify(notify_msg.required.address1);
                                return false;
                            } else if (document.getElementById('city') != null & city == '') {
                                $("#city").parent().addClass('error');
                                go('#city', 150, 500);
                                $.notify(notify_msg.required.city);
                                return false;
                            } else if (document.getElementById('country-div') != null & (country == '' || country == '0' || country == txt_select_one)) {
                                $("#country-div").addClass('error');
                                go('#country-div', 150, 500);
                                $.notify(notify_msg.required.country);
                                return false;
                            } else if (document.getElementById('states-div') != null & (state == '' || state == '0' || state == txt_select_one)) {
                                $("#states-div").addClass('error');
                                go('#states-div', 150, 500);
                                $.notify(notify_msg.required.states);
                                return false;
                            } else if (document.getElementById('postal_code') != null & postal_code == '') {
                                $("#postal_code").parent().addClass('error');
                                go('#postal_code', 150, 500);
                                $.notify(notify_msg.required.postal_code);
                                return false;
                            }
                            var required_questions_obj = {'name': name, 'availability': availability,
                                'willing_to_relocate': willing_to_relocate, 'address1': address1, 'city': city, 'postcode': postal_code, 'state': state,
                                '_token': $('meta[name="csrf-token"]').attr('content'), '_method': "POST"
                            }
                            if (country != '')
                                required_questions_obj.country = country;
                            if (nationality != '' && nationality != 'na')
                                required_questions_obj.nationality = nationality;
                            //if(dob!='' && (nationality=='Non-Malaysian' || nationality=='na')) required_questions_obj.dob = dob;
                            if (dob != '')
                                required_questions_obj.dob = dob;
                            if (passport != '' && (nationality == 'Non-Malaysian' || nationality == 'na'))
                                required_questions_obj.passport = passport;
                            if (work_permit != '' && work_permit != undefined && (nationality == 'Non-Malaysian' || nationality == 'na'))
                                required_questions_obj.work_permit = work_permit;
                            if (gender != '' && gender != txt_select_one)
                                required_questions_obj.gender = gender;
                            if (ic != '' && (nationality == 'Malaysian' || nationality == 'na'))
                                required_questions_obj.ic = ic;
                            if (language1 != '' && language_rate1 != '') {
                                required_questions_obj.language1 = language1;
                                required_questions_obj.language_rate1 = language_rate1;
                            }
                            if (language2 != '' && language_rate2 != '') {
                                required_questions_obj.language2 = language2;
                                required_questions_obj.language_rate2 = language_rate2;
                            }
                            if (language3 != '' && language_rate3 != '') {
                                required_questions_obj.language3 = language3;
                                required_questions_obj.language_rate3 = language_rate3;
                            }
                            if (otherlanguage != '' && otherlanguage_rate != '') {
                                required_questions_obj.otherlanguage = otherlanguage;
                                required_questions_obj.otherlanguage_rate = otherlanguage_rate;
                            }

                            if (ae_school_name != '' && ae_degree != '' && ae_grade != '' && aedu_start_date != '' && ae_major != '') {
                                required_questions_obj.school_name = ae_school_name;
                                required_questions_obj.degree = ae_degree;
                                required_questions_obj.grade = ae_grade;
                                required_questions_obj.start_date = aedu_start_date;
                                required_questions_obj.end_date = aedu_end_date;
                                required_questions_obj.currently_studing = currently_studing;
                                required_questions_obj.description = ae_major;
                            }
                            allow_apply = true;
                            break;

                        case 'nationality-languages':
                            var language1 = 'English';
                            var language_rate1 = $("input[name=language1]:checked").val();
                            var language2 = 'Bahasa Malaysia';
                            var language_rate2 = $("input[name=language2]:checked").val();
                            var language3 = 'Chinese';
                            var language_rate3 = $("input[name=language3]:checked").val();
                            var otherlanguage = 'Tamil';
                            var otherlanguage_rate = $("input[name=otherlanguage]:checked").val();
                            if (typeof language_rate1 == 'undefined')
                                language_rate1 = '';
                            if (typeof language_rate2 == 'undefined')
                                language_rate2 = '';
                            if (typeof language_rate3 == 'undefined')
                                language_rate3 = '';
                            if (typeof otherlanguage_rate == 'undefined')
                                otherlanguage_rate = '';
                            if ($("input[name=language1]").length > 0 && language_rate1 == '' && language_rate2 == '' && language_rate3 == '' && otherlanguage_rate == '') {
                                $("#language1").css("border", "1px solid rgb(252, 203, 199)");
                                //$("#language1").focus();
                                go('#language1', 150, 500);
                                $.notify(notify_msg.required.language1);
                                return false;
                            } else {
                                //save the profile stuff
                                $("#language1").css("border", "0");
                                //$("#load-spinner").show();
                                $.post(canvas_url + "api/jobseeker/field", {
                                    'language1': language1, 'language_rate1': language_rate1, 'language2': language2, 'language_rate2': language_rate2, 'language3': language3,
                                    'language_rate3': language_rate3, 'otherlanguage': otherlanguage, 'otherlanguage_rate': otherlanguage_rate,
                                    '_token': $('meta[name="csrf-token"]').attr('content'), '_method': "POST"}, function (data) {}, "json");
                                allow_apply = true;
                            }
                            break; //nationality-languages

                        case 'experience':
                            //process the experience status
                            if (document.getElementById('exp-status') != null) {
                                //user was prompted for experience status
                                var exp_status = $("#exp-status option:selected").val();
                                if (exp_status == '' || exp_status == '--Select One--') {
                                    $("#exp-status").css("border", "1px solid rgb(252, 203, 199)");
                                    //$("#exp-status").focus();
                                    go('#exp-status', 150, 500);
                                    $.notify(notify_msg.required.first_time_working);
                                    return false;
                                } else {
                                    //$("#load-spinner").show();
                                    $.post(canvas_url + "api/jobseeker/account", {'exp_status': exp_status, 'section': '5', '_token': $('meta[name="csrf-token"]').attr('content'), '_method': "POST"}, function (data) {}, "json");
                                    allow_apply = true;
                                }
                            }
                            //process job experience
                            if (document.getElementById('add-experience') != null) {
                                var current_working = $("#currently_working").is(':checked');
                                var ae_company_name = $("#ae_company_name").val();
                                var ae_title = $("#ae_title").val();
                                var ae_salary_cur = $("#ae_salary_cur").val();
                                var ae_salary = $("#ae_salary").val();
                                var ae_start_date = $("#ae_start_date").val();
                                var ae_end_date = $("#ae_end_date").val();
                                var ae_job_description = $("#ae_job_description").val();

                                //if any value is entered, all the others must be entered too
                                //if no value is provided, then skip it. experience is optional
                                if (ae_company_name != '' || ae_title != '' || ae_salary != '' || ae_start_date != '' || ae_end_date != '' || ae_job_description != '') {
                                    if (ae_company_name == '') {
                                        $("#ae_company_name").css("border", "1px solid rgb(252, 203, 199)");
                                        //$("#ae_company_name").focus();
                                        go('#ae_company_name', 150, 500);
                                        $.notify(notify_msg.required.company_name);
                                        return false;
                                    } else if (ae_title == '') {
                                        $("#ae_title").css("border", "1px solid rgb(252, 203, 199)");
                                        //$("#ae_title").focus();
                                        go('#ae_title', 150, 500);
                                        $.notify(notify_msg.required.job_title);
                                        return false;
                                    } else if (ae_salary == '') {
                                        $("#ae_salary").css("border", "1px solid rgb(252, 203, 199)");
                                        //$("#ae_salary").focus();
                                        go('#ae_salary', 150, 500);
                                        $.notify(notify_msg.required.salary);
                                        return false;
                                    } else if (ae_start_date == '') {
                                        $("#ae_start_date").css("border", "1px solid rgb(252, 203, 199)");
                                        //$("#ae_start_date").focus();
                                        go('#ae_start_date', 150, 500);
                                        $.notify(notify_msg.required.start_date);
                                        return false;
                                        //} if (ae_end_date=='' && current_working===false) {
                                    } else if (ae_end_date == '' && current_working === false) {
                                        $("#ae_end_date").css("border", "1px solid rgb(252, 203, 199)");
                                        //$("#ae_end_date").focus();
                                        go('#ae_end_date', 150, 500);
                                        $.notify(notify_msg.required.end_date);
                                        return false;
                                    } else if (ae_job_description == '') {
                                        $("#ae_job_description").css("border", "1px solid rgb(252, 203, 199)");
                                        //$("#ae_job_description").focus();
                                        go('#ae_job_description', 150, 500);
                                        $.notify(notify_msg.required.job_description);
                                        return false;
                                    } else {
                                        //$("#load-spinner").show();
                                        $.post(canvas_url + "api/jobseeker/experience", {'company_name': ae_company_name, 'title': ae_title, 'salary_cur': ae_salary_cur, 'salary': ae_salary, 'start_date': ae_start_date, 'end_date': ae_end_date, 'current_working': current_working, 'job_description': ae_job_description, '_token': $('meta[name="csrf-token"]').attr('content'), '_method': "POST"}, function (data) {}, "json");
                                        allow_apply = true;
                                    }
                                } else {
                                    allow_apply = true;
                                }
                            }
                            break; //experience

                        case 'education':
                            var currently_studing = $("#currently_studing").is(':checked');
                            var ae_school_name = $("#ae_school_name").val();
                            var ae_degree = $("#ae_degree").val();
                            var ae_grade = $("#ae_grade").val();
                            var aedu_start_date = $("#aedu_start_date").val();
                            var aedu_end_date = $("#aedu_end_date").val();
                            var ae_major = $("#ae_major").val();
                            if (ae_school_name == '') {
                                $("#ae_school_name").css("border", "1px solid rgb(252, 203, 199)");
                                //$("#ae_school_name").focus();
                                go('#ae_school_name', 150, 500);
                                $.notify(notify_msg.required.school);
                                return false;
                            } else if (ae_degree == '') {
                                $("#ae_degree").css("border", "1px solid rgb(252, 203, 199)");
                                //$("#ae_degree").focus();
                                go('#ae_degree', 150, 500);
                                $.notify(notify_msg.required.degree);
                                return false;
                            } else if (aedu_start_date == '') {
                                $("#aedu_start_date").css("border", "1px solid rgb(252, 203, 199)");
                                //$("#aedu_start_date").focus();
                                go('#aedu_start_date', 150, 500);
                                $.notify(notify_msg.required.start_date);
                                return false;
                            } else if (currently_studing == false && aedu_end_date == '') {
                                $("#aedu_end_date").css("border", "1px solid rgb(252, 203, 199)");
                                //$("#aedu_end_date").focus();
                                go('#aedu_end_date', 150, 500);
                                $.notify(notify_msg.required.end_date);
                                return false;
                            } else if (currently_studing == false && ae_grade == '') {
                                $("#ae_grade").css("border", "1px solid rgb(252, 203, 199)");
                                //$("#ae_grade").focus();
                                go('#ae_grade', 150, 500);
                                $.notify(notify_msg.required.grade);
                                return false;
                            } else if (ae_major == '') {
                                $("#ae_major").css("border", "1px solid rgb(252, 203, 199)");
                                //$("#ae_major").focus();
                                go('#ae_major', 150, 500);
                                $.notify(notify_msg.required.major);
                                return false;
                            } else {
                                //$("#load-spinner").show();
                                $.post(canvas_url + "api/jobseeker/education", {'school_name': ae_school_name, 'degree': ae_degree, 'grade': ae_grade, 'start_date': aedu_start_date, 'end_date': aedu_end_date, 'currently_studing': currently_studing, 'description': ae_major, '_token': $('meta[name="csrf-token"]').attr('content'), '_method': "POST"}, function (data) {}, "json");
                                allow_apply = true;
                            }
                            break; //education

                        case 'basic':
                            var marital_status = $("#marital_status option:selected").val();
                            var obj = {'_token': $('meta[name="csrf-token"]').attr('content'), '_method': "POST"}
                            if (document.getElementById('marital_status') != null) {
                                if (marital_status == '') {
                                    $("#marital_status").css("border", "1px solid rgb(252, 203, 199)");
                                    //$("#marital_status").focus();
                                    go('#marital_status', 150, 500);
                                    $.notify(notify_msg.required.marital_status);
                                    return false;
                                } else {
                                    obj.marital_status = marital_status;
                                }
                            }

                            //$.post(canvas_url+"api/jobseeker/account", {'name':name,'email':email,'gender':gender,'dob':dob,'marital_status':marital_status,'nationality':nationality,'work_permit':work_permit, 'section':'2', '_token':$('meta[name="csrf-token"]').attr('content'), '_method':"POST" }, function(data){},"json");
                            $.post(canvas_url + "api/jobseeker/field", obj, function (data) {}, "json");
                            allow_apply = true;
                            break; //basic

                        case 'skill-summary':
                            $('#singleFieldTags').css('border', '1px solid #EBEBEB');
                            var tags = $("#mySingleField").val();
                            var summary = $("#ae_summary").val();
                            var obj = {'_token': $('meta[name="csrf-token"]').attr('content'), '_method': "POST"}
                            if (document.getElementById('mySingleField') != null) {
                                if (tags == '') {
                                    $("#singleFieldTags").css({"border": "1px solid #fccbc7"});
                                    //$(".ui-autocomplete-input").focus();
                                    go('.ui-autocomplete-input', 150, 500);
                                    $.notify(notify_msg.required.skill_tags);
                                    return false;
                                } else {
                                    obj.skills = tags;
                                }
                            }
                            if (document.getElementById('ae_summary') != null) {
                                if (summary == '') {
                                    $("#ae_summary").css({"border": "1px solid #fccbc7"});
                                    //$("#ae_summary").focus();
                                    go('#ae_summary', 150, 500);
                                    $.notify(notify_msg.required.coverletter);
                                    return false;
                                } else {
                                    obj.summary = summary;
                                }
                            }
                            $.post(canvas_url + "api/jobseeker/field", obj, function (data) {}, "json");
                            allow_apply = true;
                            break; //skill-summary

                        default:
                            allow_apply = false; //a bit paranoid
                            break;
                    }
                }

                if (allow_apply) {
                    $btn.button("loading");
                    $(".apply_job").addClass("disabled");
                    //clean phone number
                    if (typeof apply_phone !== 'undefined' && apply_phone !== '') {
                        apply_phone = cleanPhone(apply_phone.replace(/[^0-9]/g, ''));
                    }
                    if (typeof apply_edit_phone !== 'undefined' && apply_edit_phone !== '') {
                        apply_edit_phone = cleanPhone(apply_edit_phone.replace(/[^0-9]/g, ''));
                    }

                    $.post(canvas_url + "api/job/apply", {
                        'cover_letter_english': cover_letter_english,
                        'photo_filename': photo_filename,
                        'warning_input': warning_input,
                        'required_profile_questions': required_questions_obj,
                        'saved_exp_data_string': saved_exp_data_string,
                        'resume_id': resume_id,
                        'resume_check': resume_check,
                        'cover_letter': cover_letter,
                        'expected_salary_cur': expected_salary_cur,
                        'expected_salary': expected_salary,
                        'job_id': job_id,
                        'email': apply_email,
                        'selectedDialCode':selectedDialCode,
                        'base_country':base_country,
                        'contact_number': apply_phone,
                        'apply_edit_phone': apply_edit_phone,
                        'ref': ref,
                        'is_start': is_start_date,
                        'is_end': is_end_date,
                        'is_graduation_date': is_graduation_date,
                        '_token': $('meta[name="csrf-token"]').attr('content'),
                        '_method': "POST"
                    }, function (data) {
                        if (data.status == 'success') {
                            var forceGoThru = true; //no login or signup required
                            if ((apply_email == 'na' && apply_phone == 'na') || forceGoThru) {
                                // user already logged in - no change
                                $.notify(txt_application_success, {type: 'success'});
                                setTimeout(function () {
                                    if (data.applied_id_hashed) {
                                        window.location = canvas_url + "jobseeker/application/status/" + data.applied_id_hashed;
                                    } else {
                                        window.location = canvas_url + "jobseeker/appliedjobs";
                                    }
                                }, timeout_redirect);
                            } else {
                                var applied_id = data.applied_id;
                                $.applyjobEmailValidity(data.applied_id, apply_email, apply_phone, required_questions_obj.name);
                            }
                            //if logged in we save this thing in the profile
                            if (saving_exp_logged_in == 'yes') {
                                //$.post(canvas_url+"api/jobseeker/field", saved_exp_data, function(data) {}, "json");
                            }
                        } else {
                            var text_message = '';
                            for (i = 0; i < data.msg.length; i++) {
                                if (data.msg[i]) {
                                    text_message += data.msg[i];
                                }
                            }
                            //swal("Opps!", text_message, "warning");
                            $.notify(text_message);
                        }
                        //$(".apply-spinner").hide();
                        $btn.button('reset');
                        $(".apply_job").removeClass("disabled");
                    }, "json");
                }
            } else {
                //usercontact=='no'
                //$(".apply-spinner").show();
                $btn.button("loading");
                $(".apply_job").addClass("disabled");
                $.post(canvas_url + "api/job/apply", {
                    'cover_letter_english': cover_letter_english,
                    'photo_filename': photo_filename,
                    'warning_input': warning_input,
                    'saved_exp_data_string': saved_exp_data_string,
                    'resume_id': resume_id,
                    'resume_check': resume_check,
                    'cover_letter': cover_letter,
                    'expected_salary_cur': expected_salary_cur,
                    'expected_salary': expected_salary,
                    'job_id': job_id,
                    'ref': ref,
                    'is_start': is_start_date,
                    'is_end': is_end_date,
                    'is_graduation_date': is_graduation_date,
                    'email': apply_email,
                    'apply_edit_phone': apply_edit_phone,
                    'apply_edit_email': apply_edit_email,
                    'contact_number': apply_phone,
                    'selectedDialCode':selectedDialCode,
                    'base_country':base_country,
                    '_token': $('meta[name="csrf-token"]').attr('content'), '_method': "POST"}, function (data) {
                    if (data.status == 'success') {
                        var forceGoThru = true; //no login or signup required
                        if ((apply_email == 'na' && apply_phone == 'na') || forceGoThru) {
                            // user already logged in - no change
                            $.notify(txt_application_success, {type: 'success'});
                            setTimeout(function () {
                                if (data.applied_id_hashed) {
                                    window.location = canvas_url + "jobseeker/application/status/" + data.applied_id_hashed;
                                } else {
                                    window.location = canvas_url + "jobseeker/appliedjobs";
                                }
                            }, timeout_redirect);
                        } else {
                            $.applyjobEmailValidity(data.applied_id, apply_email, apply_phone, '');
                        }
                        //if logged in we save this thing in the profile
                        if (saving_exp_logged_in == 'yes') {
                            //$.post(canvas_url+"api/jobseeker/field", saved_exp_data, function(data) {}, "json");
                        }
                    } else {
                        if (data.status == 'error2') {
                            $.notify(txt_already_applied);
                        } else {
                            var text_message = '';
                            for (i = 0; i < data.msg.length; i++) {
                                if (data.msg[i]) {
                                    text_message += data.msg[i];
                                }
                            }
                            $.notify(text_message);
                        }
                    }
                    //$(".apply-spinner").hide();
                    $btn.button('reset');
                    $(".apply_job").removeClass("disabled");
                }, "json");
            }

        }
    });

    $.applyjobEmailValidity = function (applied_id, apply_email, apply_phone, apply_name) {
        $('#no-contact').hide();
        //var applied_id = data.applied_id;
        $("#applied_id").val(applied_id);
        $("#register_email").val(apply_email);
        $("#register_phone").val(apply_phone);
        $("#register_name").val(apply_name);
        $("#email_address").val(apply_email);
        //smoothly scroll up
        $('body').animate({
            scrollTop: $("#top_content").offset().top - 100
        }, 500);
        $.post(canvas_url + "api/jobseeker/emailValidity", {'email': apply_email, 'contact_number': apply_phone, '_token': $('meta[name="csrf-token"]').attr('content'), '_method': "POST"}, function (data2) {
            if (data2.status == 'success') {
                // User exists in system
                if (data2.data == 'normal') {
                    $("#apply-form").hide();
                    $("#login-form").show();
                } else {
                    $("#apply-form").hide();
                    $("#fblogin-form").show();
                }
            } else {
                $("#apply-form").hide();
                $("#l-register").show();
            }
        }, "json");
    }

    $.emailValidity = function (value) {
        var exists = $('#if-exists').val();
        var currentValue = $('#if-exists-value').val();
        //if(exists != 'true' || ( $('#apply_email').val() == '' && $('#apply_phone').val() == '' )) {
        if (exists != 'true' || currentValue != value) {
            $('#if-login').hide();
            $('#normal-login').hide();
            $('#fb-login').hide();
            $('#if-exists').val('false');
            $.post(canvas_url + "api/jobseeker/checkEmailPhone", {'value': value, '_token': $('meta[name="csrf-token"]').attr('content'), '_method': "POST"}, function (data2) {
                if (data2.status == 'success') {
                    $('#if-exists').val('true');
                    $('#if-exists-value').val(value);
                    $('#if-login').hide();
                    $('#login-first-alert').show();
                    if (data2.data == 'normal') {
                        $('#fb-login').hide();
                        $('#normal-login').show();
                    } else {
                        $('#fb-login').show();
                        $('#normal-login').hide();
                    }
                } else {
                    $('#login-first-alert').hide();
                }
            }, "json");
        }
    }


    /*******************************************Get Single Jobseeker Detail ********************************/
    $.getJobseekerDetail = function (id) {
        var resultDiv = '';

        var jsonData = {
            id: id,
            '_token': $('meta[name="csrf-token"]').attr('content'),
            '_method': "GET"
        };

        var request = $.ajax({
            url: "../api/admin/jobseeker/" + id,
            data: jsonData,
            type: 'GET',
            crossDomain: true,
            dataType: 'json'
        });

        $('#spinner').show();

        request.done(function (data) {

            $('#spinner').hide();

            if (data.status == 'success')
            {
                var jobseeker = data.data;
                $("#name").val(jobseeker.name);
                $("#email").val(jobseeker.email);
                //$("#password").val(jobseeker.password);
                $("#platform_id").val(jobseeker.platform_id);
                $("#phone").val(jobseeker.contact_number);

                $('.submit_updatejobseeker').removeClass("disabled");
            } else
            {

            }
        });

        request.fail(function (jqXHR, textStatus) {

            $('#spinner').hide();
            $("#platform-lang").html('<div style="text-align:center"><h5 class="text-red">Error</h5></div>');
        });
    }

    /******************************************* Update Applied Job Status ********************************/
    $.changeAppliedJobStatus = function (id, status)
    {
        var txt_status = '';
        var txt_action = '';
        var txt_action_success = '';
        if (status == 'Interested. Shortlisted.')
        {
            status = 1;
            txt_status = 'You are still interested in this job as you have been shortlisted?';
            txt_action = 'Yes, i am interested';
            txt_action_success = 'Employer will be informed that you are interested.';
        } else if (status == 'Not Interested. Shortlisted.')
        {
            status = 0;
            txt_status = 'You are not interested in this job as you have been shortlisted?';
            txt_action = 'Yes, i am not interested';
            txt_action_success = 'Employer will be informed that you are not interested.';
        } else if (status == 'Accepted interview')
        {
            status = 1;
            txt_status = 'You want to accept this interview?';
            txt_action = 'Yes, i accept';
            txt_action_success = 'Employer will be informed that you accepted this interview.';
        } else if (status == 'Rejected interview')
        {
            status = 0;
            txt_status = 'You want to reject this interview?';
            txt_action = 'Yes, i reject';
            txt_action_success = 'Employer will be informed that you rejected this interview.';
        }

        swal({
            title: txt_are_u_sure,
            text: txt_status,
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: txt_action,
            closeOnConfirm: false
        }, function () {
            var jsonData = {
                'status': status,
                'id': id,
                '_token': $('meta[name="csrf-token"]').attr('content'),
                '_method': "PUT"
            };

            var request = $.ajax({
                url: canvas_url + "api/jobseeker/appliedjobs/" + id,
                data: jsonData,
                type: 'PUT',
                crossDomain: true,
                dataType: 'json'
            });

            $('#spinner').show();

            request.done(function (data) {

                $('#spinner').hide();

                if (data.status == 'success')
                {
                    swal(txt_done_label, txt_action_success, "success");
                    $.getAppliedJobs();
                } else
                {

                }
            });

            request.fail(function (jqXHR, textStatus) {

            });
        });
    }

    /*******************************************Jobseeker Applied Jobs Listing ********************************/
    $.getAppliedJobs = function (applicationsStatus)
    {
        var jsonData = {
            'applicationsStatus': applicationsStatus,
            '_token': $('meta[name="csrf-token"]').attr('content'),
            '_method': "GET"
        };

        var request = $.ajax({
            url: canvas_url + "api/jobseeker/appliedjobs",
            data: jsonData,
            type: 'GET',
            crossDomain: true,
            dataType: 'json'
        });

        $('#spinner').show();

        request.done(function (data) {

            $('#spinner').hide();

            if (data.status == 'success')
            {
                var job = data.data;
                var current = job.length;
                $("#totalrec").html(current);
                var resultDiv = '';
                var joburl = '';
                var statusBar = '';
                var setClass = '';
                var setClass_h = '';
                var featuredBar = '';
                var hightlightAction = '';
                var clogo = '';
                var joburl = '';
                var applylink = '';
                var source = '';
                var save_class = '';
                var applied_class = '';
                var hightlighted_text = '';
                var action_btn = '';
                for (var i = 0; i < current; i++)
                {

                    if (job[i].logo != null && job[i].logo != '') {
                        clogo = '<img src="' + job[i].logo + '" alt="' + job[i].company_name + ' Logo" class="">';
                    } else {
                        if (job[i].category_pic == null || job[i].category_pic == '') {
                            if (job[i].industry_id == null) {
                                job[i].industry_id = 1;
                            }
                            clogo = '<div class="splash-' + job[i].industry_id + '"></div>';
                        } else {
                            clogo = '<img src="' + job[i].category_pic + '" alt="' + job[i].category_name + ' Category" class="">';
                        }
                    }

                    if (job[i].company_privacy == 'private') {
                        clogo = '<img src="https://s3-ap-southeast-1.amazonaws.com/brightan-assets/images/others/v1/private-company.jpg" alt="Private Company" class="">';
                    }

                    if (job[i].seo_link == null || typeof job[i].seo_link == undefined)
                    {
                        joburl = canvas_url + 'job/' + job[i].job_id + '-' + FilterURL(job[i].title);
                    } else
                    {
                        joburl = canvas_url + 'job/' + job[i].job_id + '-' + job[i].seo_link;
                    }

                    applylink = canvas_url + 'job/apply-job?job_id=' + job[i].job_id;
                    source = '';

                    if (job[i].apply_direct != null && job[i].apply_direct == 'yes')
                    {
                        applylink = job[i].apply_link;
                        source = '<a class="right link-success-o comp" href="' + applylink + '" target="_blank"> ' + job[i].source + '</a>';
                    }

                    if (job[i].highlighted == 'yes')
                    {
                        setClass_h = 'highlighted';
                        hightlighted_text = '<span class="highlighted-icon"><i class="mdi mdi-star"></i></span>';
                        if (source == '')
                            source = hightlighted_text;
                        else
                            source = source + hightlighted_text;
                    } else
                    {
                        setClass_h = '';
                        hightlighted_text = '';
                    }

                    if (job[i].job_saved == 'false')
                    {
                        save_class = '<a class="btn btn-default save_job_normal" data-id="' + job[i].job_id + '" id="savejobn-' + job[i].job_id + '"><i class="mdi mdi-star-outline"></i> ' + txt_save + '</a> ';
                    } else
                    {
                        save_class = '<a class="btn btn-default btn-job-saved disabled" data-id="' + job[i].job_id + '"><i class="mdi mdi-star"></i> ' + txt_job_saved + '</a>';
                    }

                    if (job[i].final_salary == 'RM' || job[i].final_salary == 'RM1-RM1' || job[i].final_salary == 'RMRM1' || job[i].final_salary == '')
                        job[i].final_salary = txt_negotiable;

                    if (job[i].is_featured == '1')
                    {
                        setClass_h = 'featured';
                    }
                    action_btn = '';
                    if (job[i].status == 'Pending' || job[i].status == 'pending')
                        statusBar = '<a class="link" >' + txt_pending + ' <i class="mdi mdi-clock"></i> </a>';

                    if (job[i].status == 'kiv')
                        statusBar = '<a class="link keep-applied"> ' + txt_kiv + ' <i class="mdi mdi-message-text-outline"></i></a>';

                    if (job[i].status == 'Success' || job[i].status == 'hired')
                        statusBar = '<a class="link success-applied">' + txt_success + ' <i class="mdi mdi-checkbox-marked-circle-outline"></i> </a>';

                    if (job[i].status == 'Rejected' || job[i].status == 'rejected') {
                        statusBar = '<a class="link rejected-applied"';

                        //if(job[i].auto_rejected)
                        //statusBar += ' mytooltip"';
                        //else
                        //statusBar += '"';

                        //if(job[i].auto_rejected)
                        //statusBar += ' title="'+job[i].reason+'" ';

                        statusBar += '>' + txt_rejected;

                        //if(job[i].auto_rejected)
                        //    statusBar += ' '+txt_because+'... <i class="mdi mdi-close-circle-outline"></i>';

                        statusBar += '</a>';
                    }

                    if (job[i].status == 'Accepted interview')
                        statusBar = '<a class="link success-applied"> ' + txt_accepted_interview + ' <i class="mdi mdi-calendar"></i></a>';

                    if (job[i].status == 'Interested. Shorlisted.')
                        statusBar = '<a class="link success-applied">' + txt_interested + '. ' + txt_shortlisted + '. <i class="mdi mdi-checkbox-marked-circle-outline"></i> </a>';

                    if (job[i].status == 'Not Interested. Shorlisted.')
                        statusBar = '<a class="link rejected-applied"> ' + txt_not_interested + '. ' + txt_shortlisted + '. <i class="mdi mdi-close-circle-outline"></i></a>';

                    if (job[i].status == 'Rejected interview')
                        statusBar = '<a class="link rejected-applied">' + txt_rejected_interview + '. <i class="mdi mdi-close-circle-outline"></i> </a>';

                    if (job[i].status == 'Shorlisted' || job[i].status == 'shortlisted')
                    {
                        statusBar = '<a class=" link keep-applied"> ' + txt_shortlisted + ' <i class="mdi mdi-checkbox-marked-circle-outline"></i></a>';
                        if (job[i].jobseeker_status == 'Interested')
                        {
                            statusBar = '<a class=" link success-applied">' + txt_interested + '. ' + txt_shortlisted + '. <i class="mdi mdi-checkbox-marked-circle-outline"></i></a>';
                            action_btn = '';
                        } else if (job[i].jobseeker_status == 'Not Interested')
                        {
                            statusBar = '<a class="link rejected-applied"> ' + txt_not_interested + '. ' + txt_shortlisted + '. <i class="mdi mdi-close-circle-outline"></i></a>';
                            action_btn = '';
                        } else {
                            action_btn = '<div class="status-action">\
                                      <div class="form-group group responsive-xs">\
                                          <div class="group auto">\
                                            <strong>You have been shortlisted, tell employer how you feel?</strong>\
                                          </div>\
                                          <div class="group">\
                                            <a href="#" class="link link-underline link-primary" onclick="$.changeAppliedJobStatus(' + job[i].id + ',\'Interested. Shortlisted.\');"> <i class="mdi mdi-check"></i>' + txt_interested + '</a>\
                                            <span class="xs-ml-5"></span>\
                                            <a href="#" class="link link-underline link-primary" onclick="$.changeAppliedJobStatus(' + job[i].id + ',\'Not Interested. Shortlisted.\');"> <i class="mdi mdi-close"></i>' + txt_not_interested + '</a>\
                                          </div>\
                                      </div>\
                                    </div>';
                        }

                    }

                    if (job[i].status == 'Arrange interview') {
                        statusBar = '<a class="link keep-applied">' + txt_rrange_interview_q + ' <i class="mdi mdi-calendar"></i></a>';
                        action_btn = '<div class="status-action">\
                                      <a href="#" class="link link-primary" onclick="$.changeAppliedJobStatus(' + job[i].id + ',\'Accepted interview\');"> ' + txt_accept + '</a>\
                                      <span class="xs-ml-5"></span>\
                                      <a href="#" class="link link-danger" onclick="$.changeAppliedJobStatus(' + job[i].id + ',\'Rejected interview\');"> ' + txt_reject + '</a>\
                                    </div>';
                    }

                    if (job[i].resume_id != 0) {
                        var btnViewResume = '<li><a href="' + canvas_url + 'jobseeker/view-resume?id=' + job[i].resume_id + '" class="btn btn-default" target="_blank" onclick="trackEvent({ event:\'Click\', key:\'View Resume\', value:\'Applied Jobs\' })"><i class="mdi mdi-magnify"></i> ' + txt_view_resume + '</a></li>';
                        var btnReplaceResume = '<li><a data-id="' + job[i].resume_id + '"  data-apply="' + job[i].apply_id_hashed + '"  data-job="' + job[i].id + '" class="btn btn-default replace-resume" target="_blank"><i class="mdi mdi-upload"></i> Replace Resume </a></li>';
                    } else {
                        var btnViewResume = '';
                        var btnReplaceResume = '';
                    }

                    var floorViews = Math.floor(parseInt(job[i].emp_view_count) / 5);
                    var minViews = (floorViews === 0 ? 1 : floorViews * 5);
                    var maxViews = (floorViews === 0 ? 5 : (floorViews * 5) + 5);

                    resultDiv += '<div class=" job-list ' + setClass_h + '">\
                              <div class="content applied">\
                                <div class="employer-badge-wrap hide"><div class="employer-badge">\
                                    <span class="icon">\
                                      <img alt="Friendly Responsive" src="' + canvas_url + 'employer_assets/img/big-heart.png">\
                                    </span>\
                                    <span class="badge">Friendly Responsive</span>\
                                </div></div>\
                                <div class="content-wrap">\
                                    <div class="content-pic">\
                                     <div class="pic-wrap">\
                                        ' + clogo + '\
                                     </div>\
                                    </div>\
                                    <div class="content-info">\
                                      <div class="info-wrap">\
                                          <div class="info-right">\
                                            <p class="job-date"> ' + txt_applied + ' ' + job[i].apply_created_at + ' <i class="mdi mdi-timer"></i></p>\
                                            <p class="hide emp-view" style="color: #939598;"> ' + txt_profview + ' ' + minViews + '-' + maxViews + ' <i class="mdi mdi-eye"></i></p>\
                                            <div class="job-type" onclick="initTooltip(event)" data-toggle="tooltip" title="' + job[i].job_type + '"><div>' + job[i].job_type + '</div> <i class="mdi mdi-star-outline"></i> </div>\
                                            <p>' + statusBar + '</p>\
                                            <p class="job-count hide">' + job[i].number_applicants + ' ' + txt_page_applicants + ' <i class="mdi mdi-account"></i> </p>\
                                          </div>\
                                          <div class="info-left">\
                                            <p class="job-title">' + job[i].title + '</p>\
                                            <p class="job-name">' + job[i].company_name + '</p>\
                                            <p class="job-salary"><i class="mdi mdi-currency-usd"></i> ' + job[i].final_salary + '</p>\
                                            <p class="job-location"><i class="mdi mdi-map-marker"></i> ' + job[i].area + ' ' + job[i].state + '</p>\
                                          </div>\
                                      </div>\
                                    </div>\
                                </div>\
                                <div class="content-action">\
                                  <div class="row">\
                                    <div class="left">\
                                        <li><a style="cursor:pointer;" class="btn btn-default fb-share-button" data-id="' + job[i].job_id + '" data-url="' + joburl + '"><i class="mdi mdi-share"></i> ' + txt_share_button + '</a></li>\
                                        <li><a href="' + joburl + '" class="btn btn-default" target="_blank"><i class="mdi mdi-eye"></i> ' + txt_view_button + '</a></li>\
                                    </div>\
                                    <div class="right">\
                                        ' + btnViewResume + btnReplaceResume + '\
                                    </div>\
                                  </div>\
                                </div>\
                                ' + action_btn + '\
                              </div>\
                            </div>';
                }
                $("#joblisting").html(resultDiv);
                //layout();
                $('.mytooltip').tooltip();
                $(".fb-share-button").bind("click", function () {
                    var id = $(this).attr('data-id');
                    var url = $(this).attr('data-url');
                    FB.ui({
                        method: 'share',
                        href: url,
                    }, function (response) {});
                });

                $(".replace-resume").bind("click", function () {
                    var id = $(this).attr('data-id');
                    var applyID = $(this).attr('data-apply');
                    var jobID = $(this).attr('data-job');
                    swal({
                        title: txt_are_u_sure,
                        text: txt_replace_resume,
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#DD6B55",
                        confirmButtonText: txt_confirm_replace,
                        closeOnConfirm: true
                    }, function () {
                        $("#replace_apply_id").val(applyID);
                        $("#replace_resume_id").val(id);
                        $("#replace_job_id").val(jobID);

                        $("#replace-resume").modal('show')
                    });
                });
            } else {
                $("#joblisting").html('<div style="text-align:center"><h5 class="text-red">' + txt_no_job_found + '</h5></div>');
            }
        });

        request.fail(function (jqXHR, textStatus) {
            $('#spinner').hide();
            $("#joblisting").html('<div style="text-align:center"><h5 class="text-red">Error</h5></div>');
        });
    }

    /******************************************* Jobseeker Saved Jobs Listing ********************************/
    $.getSavedJobs = function ()
    {
        var jsonData = {
            '_token': $('meta[name="csrf-token"]').attr('content'),
            '_method': "GET"
        };

        var request = $.ajax({
            url: canvas_url + "api/jobseeker/savedjobs",
            data: jsonData,
            type: 'GET',
            crossDomain: true,
            dataType: 'json'
        });

        $('#spinner').show();

        request.done(function (data) {

            $('#spinner').hide();

            if (data.status == 'success')
            {
                var job = data.data;
                var current = job.length;
                $("#totalrec").html(current);
                var resultDiv = '';
                var joburl = '';
                var statusBar = '';
                var setClass = '';
                var setClass_h = '';
                var featuredBar = '';
                var hightlightAction = '';
                var clogo = '';
                var joburl = '';
                var applylink = '';
                var source = '';
                var save_class = '';
                var applied_class = '';
                var hightlighted_text = '';
                for (var i = 0; i < current; i++)
                {
                    /*
                     if (jobseekers[i].seo_link == null || typeof jobseekers[i].seo_link == undefined)
                     {
                     joburl = canvas_url+'job/'+jobseekers[i].job_id+'-'+FilterURL(jobseekers[i].base_title);
                     }
                     else
                     {
                     joburl = canvas_url+'job/'+jobseekers[i].job_id+'-'+jobseekers[i].seo_link;
                     }
                     
                     resultDiv+='<tr><td>'+jobseekers[i].job_id+'</td>\
                     <td>'+jobseekers[i].base_company_name+'</td>\
                     <td><a href="'+joburl+'" target="_blank">'+jobseekers[i].base_title+'</a></td>\
                     <td>'+jobseekers[i].base_category_title+'</td>\
                     <td>'+jobseekers[i].job_type+'</td>\
                     <td>'+jobseekers[i].created_at+'</td>\
                     <td><button type="button" class="btn btn-icon command-delete delete-savedjob" data-id="'+jobseekers[i].id+'" title="Delete"><span class="md md-delete"></span></button>\
                     </td>\
                     </tr>';
                     */

                    if (job[i].logo != null && job[i].logo != '') {
                        clogo = '<img src="' + job[i].logo + '" alt="' + job[i].company_name + ' Logo" class="">';
                    } else {
                        if (job[i].category_pic == null || job[i].category_pic == '') {
                            if (job[i].industry_id == null) {
                                job[i].industry_id = 1;
                            }
                            clogo = '<div class="splash-' + job[i].industry_id + '"></div>';
                        } else {
                            clogo = '<img src="' + job[i].category_pic + '" alt="' + job[i].category_name + ' Category" class="">';
                        }
                    }

                    if (job[i].company_privacy == 'private') {
                        clogo = '<img src="https://s3-ap-southeast-1.amazonaws.com/brightan-assets/images/others/v1/private-company.jpg" alt="Private Company" class="">';
                    }

                    if (job[i].seo_link == null || typeof job[i].seo_link == undefined)
                    {
                        joburl = canvas_url + 'job/' + job[i].job_id + '-' + FilterURL(job[i].title);
                    } else
                    {
                        joburl = canvas_url + 'job/' + job[i].job_id + '-' + job[i].seo_link;
                    }

                    applylink = canvas_url + 'job/apply-job?job_id=' + job[i].job_id;
                    source = '';

                    if (job[i].apply_direct != null && job[i].apply_direct == 'yes')
                    {
                        applylink = job[i].apply_link;
                        source = '<a class="right link-success-o comp" href="' + applylink + '" target="_blank"> ' + job[i].source + '</a>';
                    }

                    if (job[i].highlighted == 'yes')
                    {
                        setClass_h = 'highlighted';
                        hightlighted_text = '<span class="highlighted-icon"><i class="mdi mdi-star"></i></span>';
                        if (source == '')
                            source = hightlighted_text;
                        else
                            source = source + hightlighted_text;
                    } else
                    {
                        setClass_h = '';
                        hightlighted_text = '';
                    }

                    if (job[i].job_saved == 'false')
                    {
                        save_class = '<a class="btn btn-default save_job_normal" data-id="' + job[i].job_id + '" id="savejobn-' + job[i].job_id + '"><i class="mdi mdi-star-outline"></i> ' + txt_save + '</a> ';
                    } else
                    {
                        save_class = '<a class="btn btn-default btn-job-saved disabled" data-id="' + job[i].job_id + '"><i class="mdi mdi-star"></i> ' + txt_job_saved + '</a>';
                    }

                    if (job[i].job_applied == 'false')
                    {
                        applied_class = '<a href="' + applylink + '" target="_blank" class="btn btn-info"><i class="mdi mdi-check"></i> ' + txt_apply_button + '</a>';
                    } else
                    {
                        applied_class = '<a target="_blank" class="btn btn-default btn-applied disabled"><i class="mdi mdi-check"></i> ' + txt_applied + '</a>';
                    }

                    if (job[i].area != '')
                    {
                        job[i].area = job[i].area + ' ,';
                    }

                    if (job[i].final_salary == 'RM' || job[i].final_salary == 'RM1-RM1' || job[i].final_salary == 'RMRM1' || job[i].final_salary == '')
                        job[i].final_salary = txt_negotiable;

                    if (job[i].is_featured == '1')
                    {
                        setClass_h = 'featured';
                    }
                    resultDiv += '<div class=" job-list ' + setClass_h + '">\
                              <div class="content">\
                                  <div class="employer-badge-wrap hide"><div class="employer-badge">\
                                    <span class="icon">\
                                      <img alt="Friendly Responsive" src="' + canvas_url + 'employer_assets/img/big-heart.png">\
                                    </span>\
                                    <span class="badge">Friendly Responsive</span>\
                                  </div></div>\
                                  <div class="content-wrap">\
                                    <div class="content-pic">\
                                     <div class="pic-wrap">\
                                        ' + clogo + '\
                                     </div>\
                                    </div>\
                                    <div class="content-info">\
                                      <div class="info-wrap">\
                                        <div class="info-right">\
                                            <p class="job-date"> ' + txt_apply_saved + ' ' + job[i].save_created_at + ' <i class="mdi mdi-timer"></i></p>\
                                            <div class="job-type" onclick="initTooltip(event)" data-toggle="tooltip" title="' + job[i].job_type + '"><div>' + job[i].job_type + '</div> <i class="mdi mdi-star-outline"></i> </div>\
                                        </div>\
                                        <div class="info-left">\
                                            <p class="job-title">' + job[i].title + '</p>\
                                            <p class="job-name"><span> ' + job[i].company_name + '</span></p>\
                                            <p class="job-salary"><i class="mdi mdi-currency-usd"></i> ' + job[i].final_salary + '</p>\
                                            <p class="job-location"><i class="mdi mdi-map-marker"></i> ' + job[i].area + ' ' + job[i].state + '</p>\
                                        </div>\
                                      </div>\
                                    </div>\
                                </div>\
                                <div class="content-action">\
                                  <div class="row">\
                                    <div class="left">\
                                        <li><a style="cursor:pointer;" class="btn btn-default fb-share-button"  data-id="' + job[i].job_id + '" data-url="' + joburl + '"><i class="mdi mdi-share"></i> ' + txt_share_button + '</a></li>\
                                        <li><a href="' + joburl + '" class="btn btn-default" target="_blank"><i class="mdi mdi-eye"></i> ' + txt_view_button + '</a></li>\
                                        <li><a class="btn btn-default delete-savedjob" data-id="' + job[i].id + '"><i class="mdi mdi-close"></i> ' + txt_remove + '</a></li>\
                                    </div>\
                                    <div class="right">\
                                      <li>' + applied_class + '</li>\
                                    </div>\
                                  </div>\
                                </div>\
                              </div>\
                            </div>';
                }
                $("#joblisting").html(resultDiv);
                //layout();
                $('[data-toggle="tooltip"]').tooltip();
                $(".fb-share-button").bind("click", function () {
                    var id = $(this).attr('data-id');
                    var url = $(this).attr('data-url');
                    FB.ui({
                        method: 'share',
                        href: url, //'http://54.169.110.239/job/464-social-media-customer-service-specialist',
                    }, function (response) {});
                });

                $(".delete-savedjob").bind("click", function () {
                    var id = $(this).attr('data-id');
                    swal({
                        title: txt_are_u_sure,
                        text: txt_remove_job,
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#DD6B55",
                        confirmButtonText: txt_confirm_delete,
                        closeOnConfirm: false
                    }, function () {
                        $.deleteSavedJob(id);
                        swal(txt_done_label, txt_job_is_deleted, "success");
                    });
                });
            } else
            {
                $("#joblisting").html('<div style="text-align:center"><h5 class="text-red">' + txt_no_job_found + '</h5></div>');

            }
        });

        request.fail(function (jqXHR, textStatus) {
            $('#spinner').hide();
            $("#joblisting").html('<div style="text-align:center"><h5 class="text-red">Error</h5></div>');
        });
    }

    /*******************************************Delete Saved Job ********************************/
    $.deleteSavedJob = function (id)
    {
        var jsonData = {
            '_token': $('meta[name="csrf-token"]').attr('content'),
            '_method': "DELETE"
        };

        var request = $.ajax({
            url: canvas_url + "api/job/saved/" + id,
            data: jsonData,
            type: 'DELETE',
            crossDomain: true,
            dataType: 'json'
        });

        $('#spinner').show();

        request.done(function (data) {

            $('#spinner').hide();

            if (data.status == 'success')
            {
                $.getSavedJobs();
            } else
            {

            }
        });

        request.fail(function (jqXHR, textStatus) {

        });
    }
    
    $(".save_profilepic").bind("click", function () {
        var $btn = $(this);
        var logo = $("#photo_filename").val(); //$(".jobseeker-profile-thumbnail img").attr("src");
        var newpic = $("#profilepic").attr("src");

        $btn.button("loading");
        $.post(canvas_url + "api/jobseeker/account", {'pic': logo, 'section': '4', '_token': $('meta[name="csrf-token"]').attr('content'), '_method': "POST"}, function (data) {
            if (data.status == 'success')
            {
                //$(".save_job").addClass("disabled");
                swal({
                    title: txt_done_label,
                    text: txt_prof_pic_changed,
                    type: "success",
                    html: true,
                    showConfirmButton: true
                }, function (isConfirm) {
                    $("#userpicture").attr("src", newpic);
                    $(".close-modal").trigger("click");
                    $btn.button('reset');

                    window.location = canvas_url + "jobseeker/account";
                });
            } else
            {

                var text_message = '';
                for (i = 0; i < data.msg.length; i++) {
                    if (data.msg[i]) {
                        text_message += data.msg[i];
                    }
                }
                swal("Opps!", text_message, "warning");
                $btn.button('reset');

            }

        }, "json");
    });

    $(".save_accountsummary").bind("click", function () {
        var $btn = $(this);
        var personal_description = $("#personal_description").val();
        if (personal_description == ' ' || personal_description == '' || personal_description == txt_account_summary || personal_description == txt_write_something_abt) {
            $("#personal_description-div").addClass("error");
            //$("#personal_description").focus();
            go('#personal_description', 150, 500);
            $.notify(notify_msg.required.coverletter);
            return false;
        } else {
            $btn.button("loading");
            $btn.closest('.profile-wrap').find('.profile-body').addClass('load');
            $.post(canvas_url + "api/jobseeker/account", {'summary': personal_description, 'section': '1', '_token': $('meta[name="csrf-token"]').attr('content'), '_method': "POST"}, function (data) {
                if (data.status == 'success') {
                    //$(".save_job").addClass("disabled");
                    /*swal({   
                     title: txt_done_label,   
                     text: txt_summary_updated,   
                     type: "success",
                     html: true,
                     showConfirmButton: true 
                     }, function(isConfirm){   
                     window.location= canvas_url+"jobseeker/account";
                     });*/
                    $.notify(txt_summary_updated, {type: 'success'});
                    $btn.button('reset');
                    $btn.closest('.profile-wrap').find('.profile-body').removeClass('load');
                    setTimeout(function () {
                        window.location = canvas_url + "jobseeker/account";
                    }, timeout_redirect);
                } else {
                    //swal("Opps!", txt_error_saving_account+" "+data.msg, "warning");
                    $.notify(data.msg);
                    $btn.button('reset');
                    $btn.closest('.profile-wrap').find('.profile-body').removeClass('load');
                }

            }, "json");
        }
        //notify('Summary updated successfully', 'warning');
    });

    $(".save_accountbasic").bind("click", function () {
        var $btn = $(this);
        var name = $("#name").val();
        var email = $("#email").val();
        var gender = $("#gender").val();
        var dob = $("#dob").val();
        var marital_status = $("#marital_status").val();
        var nationality = $("#nationality option:selected").text();
        var base_country = $("#base_country").val();
        var work_permit = $("#work_permit").val();
        var id_number = $("#id_number").val();
        $("#name").parent().removeClass("error");

        if (name == '') {
            $("#name").parent().addClass("error");
            go('#name', 150, 500);
            $.notify(notify_msg.required.name);
            return false;
        }
        /*else if (email=='')
         {
         $("#email").addClass("invalid");
         $("#email").focus();
         return false;
         }*/
        else {
            $btn.button("loading");
            $btn.closest('.profile-wrap').find('.profile-body').addClass('load');
            $.post(canvas_url + "api/jobseeker/account", {'name': name, 'email': email, 'gender': gender, 'dob': dob, 'marital_status': marital_status, 'nationality': nationality, 'work_permit': work_permit, 'id_number': id_number,'base_country':base_country, 'section': '2', '_token': $('meta[name="csrf-token"]').attr('content'), '_method': "POST"}, function (data) {
                if (data.status == 'success') {
                    //$(".save_accountbasic").addClass("disabled");
                    /*swal({
                     title: txt_done_label,   
                     text: txt_basic_info_updated_success,
                     html: true,
                     type: "success",
                     showConfirmButton: true 
                     }, function(isConfirm) {
                     window.location= canvas_url+"jobseeker/account";
                     });*/
                    $.notify(txt_basic_info_updated_success, {type: 'success'});
                    $btn.button('reset');
                    $btn.closest('.profile-wrap').find('.profile-body').removeClass('load');
                    setTimeout(function () {
                        window.location = canvas_url + "jobseeker/account";
                    }, timeout_redirect);
                } else {
                    var text_message = '';
                    for (i = 0; i < data.msg.length; i++) {
                        if (data.msg[i]) {
                            text_message += data.msg[i];
                        }
                    }
                    //swal("Opps!", text_message, "warning");
                    $.notify(text_message, {type: 'danger'});
                    $btn.button('reset');
                    $btn.closest('.profile-wrap').find('.profile-body').removeClass('load');
                }
            }, "json");
        }
        //notify('Summary updated successfully', 'warning');
    });

    $(".save_accountcontact").bind("click", function () {
        var $btn = $(this);
        var contact_number = $("#contact_number").val();
        var selectedDialCode = $(".selected-dial-code").html();
        if (selectedDialCode=='') selectedDialCode = '+60';
        var address1 = $("#address1").val();
        var address2 = $("#address2").val();
        var city = $("#city").val();
        var postal_code = $("#postal_code").val();
        var area = $("#area").val();
        var country = $("#country").val();
        if (country == '' || country == '0')
            var state = $("#Other-state").val();
        else
            var state = $("#new_state_id").val();
            //var state = $("#" + country + "-state").val();

        $("#contact_number").parent().removeClass('error');
        $("#address1").parent().removeClass('error');
        $("#city").parent().removeClass('error');
        $("#country").parent().removeClass('error');
        $("#postal_code").parent().removeClass('error');
        $(".states").parent().removeClass('error');

        if (contact_number == '') {
            $("#contact_number").parent().addClass("error");
            //$("#contact_number").css({"border":"1px solid #fccbc7"});
            //$("#contact_number").focus();
            go('#contact_number', 150, 500);
            $.notify(notify_msg.required.contact_number);
            return false;
        } else if (address1 == '') {
            $("#address1").parent().addClass("error");
            //$("#address1").css({"border":"1px solid #fccbc7"});
            //$("#address1").focus();
            go('#address1', 150, 500);
            $.notify(notify_msg.required.address_1);
            return false;
        } else if (city == '') {
            $("#city").parent().addClass("error");
            //$("#city").css({"border":"1px solid #fccbc7"});
            //$("#city").focus();
            go('#city', 150, 500);
            $.notify(notify_msg.required.city);
            return false;
        } else if (postal_code == '') {
            $("#postal_code").parent().addClass("error");
            //$("#postal_code").css({"border":"1px solid #fccbc7"});
            //$("#postal_code").focus();
            go('#postal_code', 150, 500);
            $.notify(notify_msg.required.postcode);
            return false;
        } else if (country == '0') {
            $("#country").parent().addClass("error");
            //$("#country").css({"border":"1px solid #fccbc7"});
            //$("#country").focus();
            go('#country', 150, 500);
            $.notify(notify_msg.required.country);
            return false;
        } else if (state == '' || state == '0') {
            $(".states").parent().addClass("error");
            //$(".states").css({"border":"1px solid #fccbc7"});
            //$(".states").focus();
            go('.states', 150, 500);
            $.notify(notify_msg.required.state);
            return false;
        } else {
            // contact_number = contact_number.replace("+", "");
            contact_number = cleanPhone(contact_number);

            $btn.button("loading");
            $btn.closest('.profile-wrap').find('.profile-body').addClass('load');
            $.post(canvas_url + "api/jobseeker/account", {'contact_number': contact_number, 'address1': address1, 'address2': address2, 'city': city, 'postal_code': postal_code, 'area': area, 'country': country, 'state': state, 'section': '3','selectedDialCode':selectedDialCode, '_token': $('meta[name="csrf-token"]').attr('content'), '_method': "POST"}, function (data) {
                if (data.status == 'success') {

                    //$(".save_accountcontact").addClass("disabled");
                    /*swal({
                     title: txt_done_label,
                     text: txt_contact_info_updated,
                     html: true,
                     type: "success",
                     showConfirmButton: true 
                     }, function(isConfirm){
                     window.location= canvas_url+"jobseeker/account";
                     });*/
                    $.notify(txt_contact_info_updated, {type: 'success'});
                    $btn.button('reset');
                    $btn.closest('.profile-wrap').find('.profile-body').removeClass('load');
                    setTimeout(function () {
                        window.location = canvas_url + "jobseeker/account";
                    }, timeout_redirect);
                } else {
                    var mmm = '';
                    if (typeof data.msg == 'string') {
                        mmm = data.msg;
                    } else {
                        if (data.msg.length > 1) {
                            mmm = data.msg.join("<br>");
                        } else
                            mmm = data.msg[0];
                    }
                    $.notify(mmm);
                    $btn.button('reset');
                    $btn.closest('.profile-wrap').find('.profile-body').removeClass('load');
                }
            }, "json");

        }
        //notify('Summary updated successfully', 'warning');
    });

    /*******************************************Start of My Account Functions ********************************/
    $.hideAllTabs = function () {
        $('.jobseeker-nav').removeClass('active');
        $('.nav-content').hide();
    }

    $(".addexperience").bind("click", function () {
        $('#btn_add_experience').closest('.profile-view').find('.form-group').css('border-radius', '0 0 4px 4px')
        $("#add-experience").fadeIn();
        $(".experience-error").hide();
        go('#add-experience', 165, 500);
        $(".addexperience").hide();
    });

    $(".currently_working_here").bind("click", function () {
        var current_working = $("#currently_working").is(':checked');
        if (current_working === true)
        {
            // $("#ae_end_date").fadeOut();
            $("#ae_end_date").closest('.form-group-wrap').fadeOut();
        } else
        {
            //$("#ae_end_date").fadeIn();
            $("#ae_end_date").closest('.form-group-wrap').fadeIn();
        }
    });

    $(".hide_experience").bind("click", function () {
        $('#btn_add_experience').closest('.profile-view').find('.form-group').css('border-radius', '0')
        $("#add-experience").hide();
        $(".addexperience").fadeIn();
        $(".experience-error").fadeIn();
    });

    $(".submit_exp_status").bind("click", function () {
        var exp_status = $("#exp-status").val();
        var $btn = $(this);
        if (exp_status == '') {
            $("#exp-status-div").addClass("error");
            //$("#exp-status").focus();
            go('#exp-status', 150, 500);
            $.notify(notify_msg.required.experience_status);
            return false;
        }
        //$(".submit_exp_status").addClass("disabled");
        //$("#exp-status-spinner").show();
        $btn.button("loading");
        $btn.closest('.profile-wrap').find('.profile-body').addClass('load');
        $.post(canvas_url + "api/jobseeker/account", {'exp_status': exp_status, 'section': '5', '_token': $('meta[name="csrf-token"]').attr('content'), '_method': "POST"}, function (data) {
            if (data.status == 'success') {
                //$(".save_job").addClass("disabled");
                /*swal({   
                 title: txt_done_label,   
                 text: txt_exp_status_updated,
                 type: "success",
                 html: true,
                 showConfirmButton: true 
                 }, function(isConfirm){   
                 window.location= canvas_url+"jobseeker/account?tab=experience";
                 });*/
                $.notify(txt_exp_status_updated, {type: 'success'});
                setTimeout(function () {
                    $btn.button('reset');
                    $btn.closest('.profile-wrap').find('.profile-body').removeClass('load');
                    window.location = canvas_url + "jobseeker/account?tab=experience";
                }, timeout_redirect);
            } else {
                //swal("Opps!", txt_error_saving_account+" "+data.msg, "warning");
                $.notify(data.msg);
                $btn.button('reset');
                $btn.closest('.profile-wrap').find('.profile-body').removeClass('load');
            }
        }, "json");
        //$("#exp-status-spinner").hide();
        //$(".submit_exp_status").removeClass("disabled");
        //$btn.button('reset');
        //$btn.closest('.profile-wrap').find('.profile-body').removeClass('load'); 
        return false;
    });

    $(".save_experience").bind("click", function () {
        var $btn = $(this);
        var current_working = $("#currently_working").is(':checked');
        var ae_company_name = $("#ae_company_name").val();
        var ae_title = $("#ae_title").val();
        var ae_salary_cur = $("#ae_salary_cur").val();
        var ae_salary = $("#ae_salary").val();
        var ae_start_date = $("#ae_start_date").val();
        var ae_end_date = $("#ae_end_date").val();
        var ae_job_description = $("#ae_job_description").val();

        $("#ae_company_name-div").removeClass("error");
        $("#ae_title-div").removeClass("error");
        $("#ae_start_date-div").removeClass("error");
        $("#ae_end_date-div").removeClass("error");
        $("#ae_job_description-div").removeClass("error");
        $("#ae_salary-div").removeClass("error");

        if (ae_company_name == '') {
            $("#ae_company_name-div").addClass("error");
            //$("#ae_company_name-"+id).focus();
            go('#ae_company_name', 150, 500);
            $.notify(notify_msg.required.company);
            return false;
        } else if (ae_title == '') {
            $("#ae_title-div").addClass("error");
            //$("#ae_title-"+id).focus();
            go('#ae_title', 150, 500);
            $.notify(notify_msg.required.title);
            return false;
        } else if (ae_salary == '') {
            $("#ae_salary-div").addClass("error");
            //$("#ae_salary-"+id).focus();
            go("#ae_salary", 150, 500);
            $.notify(notify_msg.required.salary);
            return false;
        } else if (ae_start_date == '') {
            $("#ae_start_date-div").addClass("error");
            //$("#ae_start_date-"+id).focus();
            go("#ae_start_date", 150, 500);
            $.notify(notify_msg.required.start_date);
            return false;
        } else if (current_working == false && ae_end_date == '') {
            $("#ae_end_date-div").addClass("error");
            //$("#ae_end_date-"+id).focus();
            go("#ae_end_date", 150, 500);
            $.notify(notify_msg.required.end_date);
            return false;
        } else if (ae_job_description == '') {
            $("#ae_job_description-div").addClass("error");
            //$("#ae_job_description-"+id).focus();
            go("#ae_job_description", 150, 500);
            $.notify(notify_msg.required.job_description);
            return false;
        } else {
            sendNewSuggestion();
            $btn.button("loading");
            $btn.closest('.profile-wrap').find('.profile-body').addClass('load');
            $.post(canvas_url + "api/jobseeker/experience", {'company_name': ae_company_name, 'title': ae_title, 'salary_cur': ae_salary_cur, 'salary': ae_salary, 'start_date': ae_start_date, 'end_date': ae_end_date, 'current_working': current_working, 'job_description': ae_job_description, '_token': $('meta[name="csrf-token"]').attr('content'), '_method': "POST"}, function (data) {
                if (data.status == 'success') {
                    /*swal({   
                     title: txt_done_label,   
                     text: txt_experience_updated,   
                     html: true,
                     type: "success",
                     showConfirmButton: true 
                     }, function(isConfirm){   
                     window.location = canvas_url+"jobseeker/account?tab=experience";
                     });*/
                    $.notify(txt_exp_status_updated, {type: 'success'});
                    setTimeout(function () {
                        window.location = canvas_url + "jobseeker/account?tab=experience";
                    }, timeout_redirect);
                } else {
                    //swal("Opps!", txt_error_saving_exp+" "+data.msg, "warning");
                    $.notify(data.msg);
                }
                $btn.button('reset');
                $btn.closest('.profile-wrap').find('.profile-body').removeClass('load');
            }, "json").fail(function () {
                $btn.button("reset");
                $btn.closest('.profile-wrap').find('.profile-body').removeClass('load');
                $.notify('There seems to be a problem, please try again');
            });
        }
    });

    $(".update_experiences").bind("click", function () {
        var $btn = $(this);
        var id = $(this).attr("data-id");
        var rec_id = $(this).attr("data-rec-id");
        var current_working = $("#currently_working-" + id).is(':checked');
        var ae_company_name = $("#ae_company_name-" + id).val();
        var ae_title = $("#ae_title-" + id).val();
        var ae_salary_cur = $("#ae_salary_cur-" + id).val();
        var ae_salary = $("#ae_salary-" + id).val();
        var ae_start_date = $("#ae_start_date-" + id).val();
        var ae_end_date = $("#ae_end_date-" + id).val();
        var ae_job_description = $("#ae_job_description-" + id).val();

        $("#ae_company_name-div-" + id).removeClass("error");
        $("#ae_title-div-" + id).removeClass("error");
        $("#ae_start_date-div-" + id).removeClass("error");
        $("#ae_end_date-div-" + id).removeClass("error");
        $("#ae_job_description-div-" + id).removeClass("error");
        $("#ae_salary-div-" + id).removeClass("error");

        if (ae_company_name == '') {
            $("#ae_company_name-div-" + id).addClass("error");
            //$("#ae_company_name-"+id).focus();
            go('#ae_company_name-' + id, 150, 500);
            $.notify(notify_msg.required.company);
            return false;
        } else if (ae_title == '') {
            $("#ae_title-div-" + id).addClass("error");
            //$("#ae_title-"+id).focus();
            go('#ae_title-' + id, 150, 500);
            $.notify(notify_msg.required.title);
            return false;
        } else if (ae_salary == '') {
            $("#ae_salary-div-" + id).addClass("error");
            //$("#ae_salary-"+id).focus();
            go("#ae_salary-" + id, 150, 500);
            $.notify(notify_msg.required.salary);
            return false;
        } else if (ae_start_date == '') {
            $("#ae_start_date-div-" + id).addClass("error");
            //$("#ae_start_date-"+id).focus();
            go("#ae_start_date-" + id, 150, 500);
            $.notify(notify_msg.required.start_date);
            return false;
        } else if (current_working == false && ae_end_date == '') {
            $("#ae_end_date-div-" + id).addClass("error");
            //$("#ae_end_date-"+id).focus();
            go("#ae_end_date-" + id, 150, 500);
            $.notify(notify_msg.required.end_date);
            return false;
        } else if (ae_job_description == '') {
            $("#ae_job_description-div-" + id).addClass("error");
            //$("#ae_job_description-"+id).focus();
            go("#ae_job_description-" + id, 150, 500);
            $.notify(notify_msg.required.job_description);
            return false;
        } else {
            sendNewSuggestion();
            // $(".update_experiences").addClass("disabled");
            // $(".hide_experience").addClass("disabled");
            // $("#exp-spinner-"+id).show();
            $btn.button("loading");
            $btn.closest('.profile-wrap').find('.profile-body').addClass('load');
            $.post(canvas_url + "api/jobseeker/experience", {'id': rec_id, 'company_name': ae_company_name, 'title': ae_title, 'salary_cur': ae_salary_cur, 'salary': ae_salary, 'start_date': ae_start_date, 'end_date': ae_end_date, 'current_working': current_working, 'job_description': ae_job_description, '_token': $('meta[name="csrf-token"]').attr('content'), '_method': "PUT"}, function (data) {
                if (data.status == 'success') {
                    /*swal({   
                     title: txt_done_label,   
                     text: txt_experience_updated,   
                     type: "success",
                     html: true,
                     showConfirmButton: true 
                     }, function(isConfirm){   
                     window.location = canvas_url+"jobseeker/account?tab=experience";  
                     });*/
                    $.notify(txt_experience_updated, {type: 'success'});
                    setTimeout(function () {
                        window.location = canvas_url + "jobseeker/account?tab=experience";
                    }, timeout_redirect);
                } else {
                    //swal("Opps!", "There seems to be an error in updated experience. "+" "+data.msg, "warning");
                    $.notify(data.msg);
                }
                $btn.button('reset');
                $btn.closest('.profile-wrap').find('.profile-body').removeClass('load');
                // $("#exp-spinner-"+id).hide();
                // $(".hide_experience").removeClass("disabled");
                // $(".update_experiences").removeClass("disabled");            
            }, "json").fail(function () {
                $btn.button("reset");
                $btn.closest('.profile-wrap').find('.profile-body').removeClass('load');
                $.notify('There seems to be a problem, please try again');
            });
        }
    });

    $(".delete-experience").bind("click", function () {
        var id = $(this).attr('data-id');
        var rec_id = $(this).attr('data-rec-id');
        $('#delete-experience-modal').modal();
        //  swal({
        //  title: txt_are_u_sure,   
        //  text: txt_remove_experience,   
        //  type: "warning",   
        //  showCancelButton: true,   
        //  confirmButtonColor: "#DD6B55",   
        //  confirmButtonText: txt_confirm_delete,   
        //  closeOnConfirm: false 
        // }, function(){
        //  $.deleteExperience(rec_id);
        //  $("#experience-block-"+id).remove();
        //  swal(txt_done_label, txt_experience_deleted, "success"); 
        // });
        $(".delete-experience-btn").click(function () {
            var $btn = $(this);
            var jsonData = {
                '_token': $('meta[name="csrf-token"]').attr('content'),
                '_method': "DELETE"
            };
            var request = $.ajax({
                url: canvas_url + "api/jobseeker/experience/" + rec_id,
                data: jsonData,
                type: 'DELETE',
                crossDomain: true,
                dataType: 'json'
            });
            $btn.button("loading");
            request.done(function (data) {
                if (data.status == 'success') {
                    $.notify(txt_experience_deleted, {type: 'success'});
                    setTimeout(function () {
                        $btn.button('reset');
                        $("#experience-block-" + rec_id).remove();
                        $('#delete-experience-modal').modal('hide');
                        window.location = canvas_url + "jobseeker/account?tab=experience";
                    }, timeout_redirect);
                } else {
                    $btn.button('reset');
                }
            });
            request.fail(function (jqXHR, textStatus) {
                $btn.button('reset');
                $.notify('There seems to be a problem, please try again');
            });
        })
    });

    $(".addeducation").bind("click", function () {
        $("#add-education").fadeIn();
        go('#add-education', 240, 500);
        $(".education-error").hide();
        $(".addeducation").hide();
    });

    $(".hide_education").bind("click", function () {
        $("#add-education").fadeOut();
        $(".addeducation").fadeIn();
        $(".education-error").fadeIn();
    });

    $(".currently_studying_here").bind("click", function () {
        var current_working = $("#currently_studing").is(':checked');
        if (current_working === true) {
            $("#aedu_end_date").closest('.form-group-wrap').fadeOut();
            //$("#aedu_end_date").fadeOut();
        } else {
            $("#aedu_end_date").closest('.form-group-wrap').fadeIn();
            //$("#aedu_end_date").fadeIn();
        }
    });

    $(".save_education").bind("click", function () {
        var $btn = $(this);
        var currently_studing = $("#currently_studing").is(':checked');
        var ae_school_name = $("#ae_school_name").val();
        var ae_degree = $("#ae_degree").val();
        var ae_grade = $("#ae_grade").val();
        var aedu_start_date = $("#aedu_start_date").val();
        var aedu_end_date = $("#aedu_end_date").val();
        var ae_major = $("#ae_major").val();

        $("#ae_school_name-div").removeClass("error");
        $("#ae_degree-div").removeClass("error");
        $("#ae_grade-div").removeClass("error");
        $("#aedu_start_date-div").removeClass("error");
        $("#aedu_end_date-div").removeClass("error");
        $("#ae_major-div").removeClass("error");

        if (ae_school_name == '') {
            $("#ae_school_name-div").addClass("error");
            //$("#ae_school_name").focus();
            go("#ae_school_name", 150, 500);
            $.notify(notify_msg.required.school);
            return false;
        } else if (ae_degree == '') {
            $("#ae_degree-div").addClass("error");
            //$("#ae_degree").focus();
            go("#ae_degree-div", 150, 500);
            $.notify(notify_msg.required.degree);
            return false;
        } else if (aedu_start_date == '') {
            $("#aedu_start_date-div").addClass("error");
            //$("#aedu_start_date").focus();
            go("#aedu_start_date", 150, 500);
            $.notify(notify_msg.required.start_date);
            return false;
        } else if (currently_studing == false && aedu_end_date == '') {
            $("#aedu_end_date-div").addClass("error");
            //$("#aedu_end_date").focus();
            go("#aedu_end_date-div", 150, 500);
            $.notify(notify_msg.required.end_date);
            return false;
        } /*else if (currently_studing==false && ae_grade=='') {
         $("#ae_grade-div").addClass("error");
         //$("#ae_grade").focus();
         go("#ae_grade", 150, 500);
         $.notify(notify_msg.required.grade);
         return false;
         } else if(ae_major=='' && (ae_degree=='Degree' || ae_degree=='Master / PHD' || ae_degree=='Certificates / Vocational / Diploma')) {
         $("#ae_major-div").addClass("error");
         //$("#ae_major").focus();
         go("#ae_major", 150, 500);
         $.notify(notify_msg.required.major);
         return false;
         }*/ else {
            sendNewSuggestion();
            //$(".save_education").addClass("disabled");
            //$(".hide_education").addClass("disabled");
            //$("#edu-spinner").show();
            $btn.button("loading");
            $btn.closest('.profile-wrap').find('.profile-body').addClass('load');
            $.post(canvas_url + "api/jobseeker/education", {'school_name': ae_school_name, 'degree': ae_degree, 'grade': ae_grade, 'start_date': aedu_start_date, 'end_date': aedu_end_date, 'currently_studing': currently_studing, 'description': ae_major, '_token': $('meta[name="csrf-token"]').attr('content'), '_method': "POST"}, function (data) {
                if (data.status == 'success') {
                    /*swal({   
                     title:txt_done_label,   
                     text: txt_education_updated,   
                     type: "success",
                     html: true,
                     showConfirmButton: true 
                     }, function(isConfirm){
                     window.location = canvas_url+"jobseeker/account?tab=education";
                     });*/
                    $.notify(txt_education_updated, {type: 'success'});
                    setTimeout(function () {
                        $btn.button('reset');
                        $btn.closest('.profile-wrap').find('.profile-body').removeClass('load');
                        window.location = canvas_url + "jobseeker/account?tab=education";
                    }, timeout_redirect);
                } else {
                    //swal("Opps!", txt_error_saving_edu+" "+data.msg, "warning");
                    $.notify(data.msg);
                    $btn.button('reset');
                    $btn.closest('.profile-wrap').find('.profile-body').removeClass('load');
                }

                // $("#edu-spinner").hide();
                // $(".hide_education").removeClass("disabled");
                // $(".save_education").removeClass("disabled");            
            }, "json");
        }
    });

    $(".update_education").bind("click", function () {
        var $btn = $(this);
        var id = $(this).attr("data-id");
        var rec_id = $(this).attr("data-rec-id");
        var currently_studing = $("#currently_studing-" + id).is(':checked');
        var ae_school_name = $("#ae_school_name-" + id).val();
        var ae_degree = $("#ae_degree-" + id).val();
        var ae_grade = $("#ae_grade-" + id).val();
        var aedu_start_date = $("#aedu_start_date-" + id).val();
        var aedu_end_date = $("#aedu_end_date-" + id).val();
        var ae_major = $("#ae_major-" + id).val();

        $("#ae_school_name-div-" + id).removeClass("error");
        $("#ae_degree-div-" + id).removeClass("error");
        $("#ae_grade-div-" + id).removeClass("error");
        $("#aedu_start_date-div-" + id).removeClass("error");
        $("#aedu_end_date-div-" + id).removeClass("error");
        $("#ae_major-div-" + id).removeClass("error");

        if (ae_school_name == '') {
            $("#ae_school_name-div-" + id).addClass("error");
            //$("#ae_school_name-"+id).focus();
            go("#ae_school_name-" + id, 150, 500);
            $.notify(notify_msg.required.school);
            return false;
        } else if (ae_degree == '') {
            $("#ae_degree-div-" + id).addClass("error");
            //$("#ae_degree-"+id).focus();
            go("#ae_degree-" + id, 150, 500);
            $.notify(notify_msg.required.degree);
            return false;
        } else if (aedu_start_date == '') {
            $("#aedu_start_date-div-" + id).addClass("error");
            //$("#aedu_start_date-"+id).focus();
            go("#aedu_start_date-" + id, 150, 500);
            $.notify(notify_msg.required.start_date);
            return false;
        } else if (currently_studing == false && aedu_end_date == '') {
            $("#aedu_end_date-div-" + id).addClass("error");
            //$("#aedu_end_date-"+id).focus();
            go("#aedu_end_date-" + id, 150, 500);
            $.notify(notify_msg.required.end_date);
            return false;
        } /*else if (currently_studing==false && ae_grade=='') {
         $("#ae_grade-div-"+id).addClass("error");
         //$("#ae_grade-"+id).focus();
         go("#ae_grade-"+id, 150, 500);
         $.notify(notify_msg.required.grade);
         return false;
         
         } else if (
         (ae_degree=='Degree' || ae_degree=='Master / PHD' || ae_degree=='Certificates / Vocational / Diploma')
         && ae_major=='') {
         $("#ae_major-div-"+id).addClass("error");
         //$("#ae_major-"+id).focus();
         go("#ae_major-"+id, 150, 500);
         $.notify(notify_msg.required.major);
         return false;
         }*/ else {
            sendNewSuggestion();
            //$(".save_education").addClass("disabled");
            //$(".hide_education").addClass("disabled");
            //$("#edu-spinner").show();
            $btn.button("loading");
            $btn.closest('.profile-wrap').find('.profile-body').addClass('load');
            $.post(canvas_url + "api/jobseeker/education", {'id': rec_id, 'school_name': ae_school_name, 'degree': ae_degree, 'grade': ae_grade, 'start_date': aedu_start_date, 'end_date': aedu_end_date, 'currently_studing': currently_studing, 'description': ae_major, '_token': $('meta[name="csrf-token"]').attr('content'), '_method': "PUT"}, function (data) {
                if (data.status == 'success') {
                    /*swal({   
                     title:txt_done_label,   
                     text: txt_education_updated,   
                     type: "success",
                     html: true,
                     showConfirmButton: true 
                     }, function(isConfirm){   
                     window.location = canvas_url+"jobseeker/account?tab=education";
                     });*/
                    $.notify(txt_education_updated, {type: 'success'});
                    setTimeout(function () {
                        $btn.button('reset');
                        $btn.closest('.profile-wrap').find('.profile-body').removeClass('load');
                        window.location = canvas_url + "jobseeker/account?tab=education";
                    }, timeout_redirect);
                } else {
                    //swal("Opps!", txt_error_updated_edu+" "+data.msg, "warning");
                    $.notify(data.msg);
                    $btn.button('reset');
                    $btn.closest('.profile-wrap').find('.profile-body').removeClass('load');
                }
                // $("#edu-spinner-"+id).hide();
                // $(".hide_education").removeClass("disabled");
                // $(".save_education").removeClass("disabled");
            }, "json");
        }
    });

    $(".delete-education").bind("click", function () {
        var id = $(this).attr('data-id');
        var rec_id = $(this).attr('data-rec-id');
        $('#delete-education-modal').modal();
        // swal({   
        //  title: txt_are_u_sure,   
        //  text: txt_remove_edu,   
        //  type: "warning",   
        //  showCancelButton: true,   
        //  confirmButtonColor: "#DD6B55",   
        //  confirmButtonText: txt_confirm_delete,   
        //  closeOnConfirm: false 
        // }, function() {
        //  $.deleteEducation(rec_id);
        // });

        $(".delete-education-btn").click(function () {
            var $btn = $(this);
            var jsonData = {
                '_token': $('meta[name="csrf-token"]').attr('content'),
                '_method': "DELETE"
            };
            var request = $.ajax({
                url: canvas_url + "api/jobseeker/education/" + rec_id,
                data: jsonData,
                type: 'DELETE',
                crossDomain: true,
                dataType: 'json'
            });
            $btn.button("loading");
            request.done(function (data) {
                if (data.status == 'success') {
                    $.notify(txt_education_deleted, {type: 'success'});
                    setTimeout(function () {
                        $btn.button('reset');
                        $("#education-block-" + rec_id).remove();
                        $('#delete-education-modal').modal('hide');
                        window.location = canvas_url + "jobseeker/account?tab=education";
                    }, timeout_redirect);
                } else {
                    $btn.button('reset');
                }
            });
            request.fail(function (jqXHR, textStatus) {});

        })

    });
    
    $(".save_skills").bind("click", function () {
        var $btn = $(this);
        var type = $btn.attr('data-type');
        var tags = $("#mySingleField").val();
        $("#tags-div").removeClass("error");
        var language1 = $("#language1").val();
        var language_rate1 = $("input[name=language1]:checked").val();
        var language2 = $("#language2").val();
        var language_rate2 = $("input[name=language2]:checked").val();
        var language3 = $("#language3").val();
        var language_rate3 = $("input[name=language3]:checked").val();
        var otherlanguage = $("#otherlanguage").val();
        var otherlanguage_rate = $("input[name=otherlanguage]:checked").val();

        if ($(".save_skills").hasClass("disabled")) {
            return false;
        } else {
            if (type == 'skills') {
                if (tags == '') {
                    //$("#singleFieldTags").css({"border":"1px solid #fccbc7"});
                    //$(".ui-autocomplete-input").focus();
                    $("#tags-div").addClass("error");
                    go(".ui-autocomplete-input", 150, 500);
                    $.notify(notify_msg.required.skill_tags);
                    return false;
                }
            } else {
                if (language_rate1 == '' || typeof language_rate1 == 'undefined') {
                    $("#language1").addClass("error");
                    //$("#language_rate1").focus();
                    go("#language1", 150, 500);
                    $.notify(notify_msg.required.language_rate);
                    return false;
                } else if (language_rate2 == '' || typeof language_rate2 == 'undefined') {
                    $("#language2").addClass("error");
                    //$("#language_rate2").focus();
                    go("#language2", 150, 500);
                    $.notify(notify_msg.required.language_rate);
                    return false;
                } else if (language_rate3 == '' || typeof language_rate3 == 'undefined') {
                    $("#language3").addClass("error");
                    //$("#language_rate3").focus();
                    go("#language3", 150, 500);
                    $.notify(notify_msg.required.language_rate);
                    return false;
                } else if (otherlanguage_rate == '' || typeof otherlanguage_rate == 'undefined') {
                    $("#otherlanguage").addClass("error");
                    //$("#otherlanguage_rate").focus();
                    go("#otherlanguage", 150, 500);
                    $.notify(notify_msg.required.language_rate);
                    return false;
                }
            }

            //$(".save_skills").addClass("disabled");
            //$("#spinner-skills").show();
            $btn.button("loading");
            $btn.closest('.profile-wrap').find('.profile-body').addClass('load');
            language1 = 'English';
            language2 = 'Bahasa Malaysia';
            language3 = 'Chinese';
            otherlanguage = 'Tamil';

            $.post(canvas_url + "api/jobseeker/skills", {'type': type, 'skills': tags, 'language1': language1, 'language_rate1': language_rate1, 'language2': language2, 'language_rate2': language_rate2, 'language3': language3, 'language_rate3': language_rate3, 'otherlanguage': otherlanguage, 'otherlanguage_rate': otherlanguage_rate, '_token': $('meta[name="csrf-token"]').attr('content'), '_method': "POST"}, function (data) {
                if (data.status == 'success') {
                    /*swal({
                     title:txt_done_label,   
                     text: txt_skills_updated,   
                     type: "success",
                     html: true,
                     showConfirmButton: true 
                     }, function(isConfirm){
                     window.location = canvas_url+"jobseeker/account?tab=skills";
                     });*/
                    var nstring = '';
                    if (type == 'skills')
                        nstring = txt_skills_updated;
                    else
                        nstring = txt_langs_updated;
                    $.notify(nstring, {type: 'success'});
                    setTimeout(function () {
                        $btn.button('reset');
                        $btn.closest('.profile-wrap').find('.profile-body').removeClass('load');
                        window.location = canvas_url + "jobseeker/account?tab=skills";
                    }, timeout_redirect);
                } else {
                    //swal("Opps!", txt_error_saving_skills+" "+data.msg, "warning");
                    $.notify(data.msg);
                    $btn.button('reset');
                    $btn.closest('.profile-wrap').find('.profile-body').removeClass('load');
                }
                //$("#spinner-skills").hide();
                //$(".save_skills").removeClass("disabled");          
            }, "json");
        }
    });

    $(".submit_preference").bind("click", function () {
        var $btn = $(this);
        var email_alert = $('input[name=email_alert]:checked').val();
        var privacy = $('input[name=privacy]:checked').val();
        var desiredposition = $("#desiredposition").val();
        var availability = $("#availability").val();
        var prefer_timings = $("#prefer_timings").val();
        var prefer_channel = $("#prefer_channel").val();
        var prefer_locations = '0';
        if ($("#search_location option:selected").length > 0) {
            prefer_locations = $("#search_location").val();
        }
        var prefer_categories = '0';
        if ($("#search_category option:selected").length > 0) {
            prefer_categories = $("#search_category").val();
        }

        var expected_salary_curr = $("#expected_salary_curr").val();
        var expected_salary = $("#expected_salary").val();
        var userlanguage = $("#userlanguage").val();

        if ($(".submit_preference").hasClass("disabled")) {
            return false;
        } else
        {
            $("#userlanguage").parent().removeClass("error");
            $("#availability").parent().removeClass("error");
            $("#desiredposition").parent().removeClass("error");
            //$("#prefer_timings").parent().removeClass("error");
            //$("#prefer_channel").parent().removeClass("error");
            $("#search_location").parent().removeClass("error");
            $("#search_category").parent().removeClass("error");
            $("#expected_salary").parent().removeClass("error");

            if (userlanguage == '' || userlanguage == null) {
                $("#userlanguage").parent().addClass("error");
                //$("#userlanguage").focus();
                go("#userlanguage", 150, 500);
                $.notify(notify_msg.required.preferred_language);
                return false;
            }
            if (availability == '0') {
                $("#availability").parent().addClass("error");
                //$("#availability").focus();
                go("#availability", 150, 500);
                $.notify(notify_msg.required.availability);
                return false;
            }
            //comment desired position , prefer location, and prefer categories checking since its move to job alert tab
            //else if(desiredposition=='') {
            //$("#desiredposition").parent().addClass("error");
            //$("#desiredposition").focus();
            //go("#desiredposition", 150, 500);
            //$.notify(notify_msg.required.preferred_title);
            //return false;
            //} else if(prefer_locations=='0') {
            //$("#search_location").parent().addClass("error");
            //$("html, body").animate({ scrollTop: $('#desiredposition').offset().top }, 10);
            //$("#search_location").focus();
            //go("#search_location_chosen", 150, 500);
            //$.notify(notify_msg.required.preferred_location);
            //return false;
            //} else if(prefer_categories=='0') {
            //$("#search_category").parent().addClass("error");
            //$("html, body").animate({ scrollTop: $('#search_location_chosen').offset().top }, 10);
            //$("#prefer_categories-div").focus();
            //go("#search_category_chosen", 150, 500);
            //$.notify(notify_msg.required.preferred_categories);
            //return false;
            //} 
            else if (expected_salary == '') {
                $("#expected_salary").parent().addClass("error");
                //$("#expected_salary").focus();
                go("#expected_salary", 150, 500);
                $.notify(notify_msg.required.expected_salary);
                return false;
            } else {
                //$(".submit_preference").addClass("disabled");
                //$("#preference-spinner").show();
                $btn.button("loading");
                $btn.closest('.profile-wrap').find('.profile-body').addClass('load');
                $.post(canvas_url + "api/jobseeker/preference", {'userlanguage': userlanguage, 'desiredposition': desiredposition, 'availability': availability, 'prefer_timings': prefer_timings, 'prefer_channel': prefer_channel, 'prefer_locations': prefer_locations, 'prefer_categories': prefer_categories, 'expected_salary': expected_salary, 'expected_salary_curr': expected_salary_curr, 'email_alert': email_alert, 'privacy': privacy, '_token': $('meta[name="csrf-token"]').attr('content'), '_method': "POST"}, function (data) {
                    if (data.status == 'success') {
                        /*swal({   
                         title:txt_done_label,   
                         text: txt_preference_saved,   
                         type: "success",
                         html: true,
                         showConfirmButton: true 
                         }, function(isConfirm){   
                         window.location = canvas_url+"jobseeker/account?tab=preference";                    
                         });*/
                        $.notify(txt_preference_saved, {type: 'success'});
                        setTimeout(function () {
                            $btn.button('reset');
                            $btn.closest('.profile-wrap').find('.profile-body').removeClass('load');
                            window.location = canvas_url + "jobseeker/account?tab=preference";
                        }, timeout_redirect);
                    } else {
                        //swal("Opps!", txt_error_saving_preference+" "+data.msg, "warning");
                        $.notify(data.msg);
                        $btn.button('reset');
                        $btn.closest('.profile-wrap').find('.profile-body').removeClass('load');
                    }
                    //$(".submit_preference").addClass("disabled");
                    //$("#preference-spinner").hide();
                    //$btn.button('reset');
                }, "json");
            }
        }
    });

    $(".changepasswordbtn").bind("click", function () {
        var old_password = $("#old_password").val();
        var new_password = $("#new_password").val();
        var confirm_password = $("#confirm_password").val();

        $("#old_password").removeClass("input-error");
        $("#new_password").removeClass("input-error");
        $("#confirm_password").removeClass("input-error");
        if ($(".changepasswordbtn").hasClass("disabled")) {
            return false;
        } else {
            if (old_password == '') {
                $("#old_password").addClass("input-error");
                go("#old_password", 150, 500);
                $.notify(txt_enter_old_pwd);
                return false;
            } else if (new_password == '') {
                $("#new_password").addClass("input-error");
                go("#new_password", 150, 500);
                $.notify(txt_enter_new_pwd);
                return false;
            } else if (new_password.length <= 5) {
                $("#new_password").addClass("input-error");
                go("#new_password", 150, 500);
                $.notify(txt_pwd_length_error);
                setTimeout(function () {
                    $(".alert-danger").fadeOut("fast");
                }, 3000);
                return false;
            } else if (confirm_password == '') {
                $("#confirm_password").addClass("input-error");
                go("#confirm_password", 150, 500);
                $.notify(txt_confirm_pwd_change_pwd);
                return false;
            } else if (confirm_password != new_password) {
                $("#confirm_password").addClass("input-error");
                go("#confirm_password", 150, 500);
                $.notify(txt_pwd_dont_match);
                return false;
            } else {
                $(".changepasswordbtn").addClass("disabled");
                $("#exp-spinner").show();
                $.post(canvas_url + "api/jobseeker/changepassword", {'old_password': old_password, 'new_password': new_password, '_token': $('meta[name="csrf-token"]').attr('content'), '_method': "PUT"}, function (data) {
                    if (data.status == 'success') {
                        /*swal({   
                         title: txt_done_label,   
                         text: txt_pwd_updated,   
                         type: "success",
                         html: true,
                         showConfirmButton: true 
                         }, function(isConfirm){   
                         window.location = canvas_url+"jobseeker/account";  
                         });*/
                        $.notify(txt_pwd_updated, {type: 'success'});
                    } else {
                        $.notify(data.msg);
                    }

                    $("#exp-spinner").hide();
                    $(".changepasswordbtn").removeClass("disabled");
                }, "json");
            }
        }
    });

    $(".submit_new_pwd").bind("click", function () {
        var new_pwd = $("#new_pwd").val();
        var confirm_pwd = $("#confirm_pwd").val();
        var vc_code = $("#vc_code").val();
        if ($(".submit_new_pwd").hasClass("disabled")) {
            return false;
        } else {
            $("#new_pwd").removeClass("error");
            $("#confirm_pwd").removeClass("error");
            if (new_pwd == '') {
                $("#new_pwd").addClass("error");
                go('#new_pwd', 150, 500);
                $.notify(txt_pwd_error);
                return false;
            } else if (!validatePassword(new_pwd)) {
                $("#new_pwd").addClass("error");
                go('#new_pwd', 150, 500);
                $.notify(txt_pwd_length_error);
                return false;
            } else if (confirm_pwd == '') {
                $("#confirm_pwd").addClass("error");
                go('#confirm_pwd', 150, 500);
                $.notify(txt_confirm_pwd_change_pwd);
                return false;
            } else if (confirm_pwd != new_pwd) {
                $("#confirm_pwd").addClass("error");
                go('#confirm_pwd', 150, 500);
                $.notify(txt_pwd_dont_match);
                return false;
            } else {
                var jsonData = {
                    '_token': $('meta[name="csrf-token"]').attr('content'),
                    '_method': "POST",
                    new_pwd: new_pwd,
                    confirm_pwd: confirm_pwd,
                    vc_code: vc_code
                };
                var request = $.ajax({
                    url: canvas_url + "api/jobseeker/newpassword",
                    data: jsonData,
                    type: 'POST',
                    crossDomain: true,
                    dataType: 'json'
                });
                $('#spinner').show();
                $(".submit_new_pwd").addClass("disabled");
                request.done(function (data) {
                    $('#spinner').hide();
                    if (data.status == 'success') {
                        $.notify(txt_reset_success, {type: 'success'});
                        setTimeout(function () {
                            $(".alert-success").fadeOut("fast");
                            window.location = canvas_url + "jobseeker/mypage";
                        }, timeout_redirect);
                    } else {
                        $.notify($(".alert-danger").text());
                    }
                    $('#spinner').hide();
                    $(".submit_new_pwd").removeClass("disabled");
                });
                request.fail(function (jqXHR, textStatus) {});
            }
        }
    });

    /* =================  START OF JOBSEEKER RESUME BUILDER FUNCTIONS ========================== */
    function validate_tab(tab_no) {

        var gender = '';
        var nationality = '';
        var country = '';
        var allow_apply = false;
        var template_id = document.getElementsByClassName('template-wrap');

        /*First Tab*/
        var photo_filename = $("#photo_filename").val();

        var name = $("#name").val();
        var email = $("#email").val();
        var phone = $("#phone").val();
        var dob = $("#dob").val();
        var marital_status = $("#marital_status option:selected").val();
        var work_permit = $("#work_permit option:selected").val();
        var personal_description = $("#personal_description").val();

        if ($('input[name=gender]:checked').length > 0) {
            gender = $('input[name=gender]:checked')[0].value;
        }
        if ($('input[name=nationality]:checked').length > 0) {
            var nationality = $('input[name=nationality]:checked').attr('data-val');
        }
        /*First Tab*/

        /*Second Tab*/
        var address1 = $("#address1").val();
        var area = $("#area").val();
        var postal_code = $("#postal_code").val();
        var city = $("#city").val();
        var country = '';
        if ($('input[name=country]:checked').length > 0)
            country = $('input[name=country]:checked')[0].value;
        if (country == '' || country == '0')
            var state = $("#Other-state").val();
        else
            var state = $("#new_state_id").val();
            //var state = $("#" + country + "-state").val();
        /*Second Tab*/

        /*Third Tab*/
        var exp_status = $("#exp-status option:selected").val();
        var ae_company_name = $("#ae_company_name").val();
        var ae_title = $("#ae_title").val();
        var ae_salary_cur = $("#ae_salary_cur").val();
        var ae_salary = $("#ae_salary").val();
        var ae_start_date = $("#ae_start_date").val();
        var ae_end_date = $("#ae_end_date").val();
        var ae_job_description = $("#ae_job_description").val();
        var current_working = $("#currently_working").is(':checked');
        /*Third Tab*/

        /*Fourth Tab*/
        var ae_school_name = $("#ae_school_name").val();
        var currently_studing = $("#currently_studing").is(':checked');
        var ae_degree = $("#ae_degree").val();
        var ae_grade = $("#ae_grade").val();
        var aedu_start_date = $("#aedu_start_date").val();
        var aedu_end_date = $("#aedu_end_date").val();
        var ae_major = $("#ae_major").val();
        /*Fourth Tab*/

        /*Fifth Tab*/
        var tags = $("#mySingleField").val();
        var language1 = 'English';
        var language_rate1 = $("input[name=language1]:checked").val();
        var language2 = 'Bahasa Malaysia';
        var language_rate2 = $("input[name=language2]:checked").val();
        var language3 = 'Chinese';
        var language_rate3 = $("input[name=language3]:checked").val();
        var language4 = 'Tamil';
        var language_rate4 = $("input[name=language4]:checked").val();
        if (typeof language_rate1 == 'undefined')
            language_rate1 = '';
        if (typeof language_rate2 == 'undefined')
            language_rate2 = '';
        if (typeof language_rate3 == 'undefined')
            language_rate3 = '';
        if (typeof language_rate4 == 'undefined')
            language_rate4 = '';
        var expected_salary_curr = $("#expected_salary_curr").val();
        var expected_salary = $("#expected_salary").val();
        var availability = $("#availability option:selected").val();

        /*Fifth Tab*/

        switch (tab_no) {
            case 1:
                if (document.getElementById('name') != null & name == '') {
                    $("#name").parent().addClass('error');
                    go('#name', 150, 500);
                    $.notify(notify_msg.required.name);
                    return false;
                } else if (email == '') {
                    $("#email").parent().addClass("error");
                    go('#email', 150, 500);
                    $.notify(txt_email_address_error);
                    return false;
                } else if (email != 'na' && email != '' && validateEmail(email) == false) {
                    $("#email").parent().addClass('error');
                    go('#email', 150, 500);
                    $.notify(txt_correct_email_address);
                    return false;
                } else if ($("#gender-div").length > 0 && (gender == '' || gender == txt_select_one)) {
                    $('#gender-div').addClass('error');
                    go('#gender-div', 150, 500);
                    $.notify(notify_msg.required.gender);
                    return false;
                } else if ($("#dob").length > 0 && dob == '') {
                    $('#dob').parent().addClass('error');
                    go('#dob', 150, 500);
                    $.notify(notify_msg.required.birth);
                    return false;
                } else if (marital_status == '') {
                    $("#marital_status").css("border", "1px solid rgb(252, 203, 199)");
                    go('#marital_status', 150, 500);
                    $.notify(notify_msg.required.marital_status);
                    return false;
                } else if (document.getElementById('nationality-div') != null && (nationality == '0' || nationality == txt_select_one)) {
                    $("#nationality-div").parent().addClass('error');
                    go('#nationality-div', 150, 500);
                    $.notify(notify_msg.required.nationality);
                    return false;
                } else if ($("#work_permit-div").length > 0 && (work_permit == undefined || work_permit == '')) {
                    $('#work_permit-div').addClass('error');
                    go('#work_permit-div', 150, 500);
                    $.notify(notify_msg.required.work_permit);
                    return false;
                } else if (personal_description == '') {
                    $("#personal_description").parent().addClass('error');
                    go('#personal_description', 150, 500);
                    $.notify(notify_msg.required.objective);
                    return false;
                } else if (phone == '') {
                    $("#phone").parent().addClass('error');
                    go('#phone', 150, 500);
                    $.notify(notify_msg.required.contact_number);
                    return false;
                } else if (phone != 'na' && phone != '' && validatePhone(phone) == false) {
                    $("#phone").parent().addClass('error');
                    go('#phone', 150, 500);
                    $.notify(notify_msg.invalid.phone);
                    return false;
                }

                return true;

                break;

            case 2:
                if (document.getElementById('address1') != null & address1 == '') {
                    $("#address1").parent().addClass('error');
                    go('#address1', 150, 500);
                    $.notify(notify_msg.required.address1);
                    return false;
                } else if (document.getElementById('postal_code') != null & postal_code == '') {
                    $("#postal_code").parent().addClass('error');
                    go('#postal_code', 150, 500);
                    $.notify(notify_msg.required.postal_code);
                    return false;
                } else if (document.getElementById('city') != null & city == '') {
                    $("#city").parent().addClass('error');
                    go('#city', 150, 500);
                    $.notify(notify_msg.required.city);
                    return false;
                } else if (document.getElementById('country-div') != null & (country == '' || country == '0' || country == txt_select_one)) {
                    $("#country-div").addClass('error');
                    go('#country-div', 150, 500);
                    $.notify(notify_msg.required.country);
                    return false;
                } else if (document.getElementById('states-div') != null & (state == '' || state == '0' || state == txt_select_one)) {
                    $("#states-div").addClass('error');
                    go('#states-div', 150, 500);
                    $.notify(notify_msg.required.states);
                    return false;
                }

                return true;
                break;

            case 3 :
                if (experience_list != "") {
                    $.each(experience_list, function (index, experiences) {
                        //arr_exp_list.push(experiences);
                    });
                }
                if (exp_status == '' || exp_status == '--Select One--') {
                    $("#exp-status").css("border", "1px solid rgb(252, 203, 199)");
                    go('#exp-status', 150, 500);
                    $.notify(notify_msg.required.experience_status);
                    return false;
                }
                if (exp_status != 2) {
                    if (arr_exp_list.length < 0) {
                        if (ae_company_name == '') {
                            $("#ae_company_name").css("border", "1px solid rgb(252, 203, 199)");
                            go('#ae_company_name', 150, 500);
                            $.notify(notify_msg.required.company_name);
                            return false;
                        } else if (ae_title == '') {
                            $("#ae_title").css("border", "1px solid rgb(252, 203, 199)");
                            go('#ae_title', 150, 500);
                            $.notify(notify_msg.required.job_title);
                            return false;
                        } else if (ae_salary == '') {
                            $("#ae_salary").css("border", "1px solid rgb(252, 203, 199)");
                            go('#ae_salary', 150, 500);
                            $.notify(notify_msg.required.salary);
                            return false;
                        } else if (ae_start_date == '') {
                            $("#ae_start_date").css("border", "1px solid rgb(252, 203, 199)");
                            go('#ae_start_date', 150, 500);
                            $.notify(notify_msg.required.start_date);
                            return false;
                        } else if (ae_end_date == '' && current_working === false) {
                            $("#ae_end_date").css("border", "1px solid rgb(252, 203, 199)");
                            go('#ae_end_date', 150, 500);
                            $.notify(notify_msg.required.end_date);
                            return false;
                        } else if (ae_job_description == '') {
                            $("#ae_job_description").css("border", "1px solid rgb(252, 203, 199)");
                            go('#ae_job_description', 150, 500);
                            $.notify(notify_msg.required.job_description);
                            return false;
                        }
                        $("#next").css("border", "1px solid rgb(252, 203, 199)");
                        go('#next', 150, 500);
                        $.notify(txt_btn_experience);
                        return false;
                    }
                }

                return true;
                break;

            case 4 :
                if (education_list != "") {
                    $.each(education_list, function (index, educations) {
                        //arr_edu_list.push(educations);
                    });
                }
                if (arr_edu_list.length < 0) {

                    if (ae_school_name == '') {
                        $("#ae_school_name").css("border", "1px solid rgb(252, 203, 199)");
                        go('#ae_school_name', 150, 500);
                        $.notify(notify_msg.required.school);
                        return false;
                    } else if (aedu_start_date == '') {
                        $("#aedu_start_date").css("border", "1px solid rgb(252, 203, 199)");
                        go('#aedu_start_date', 150, 500);
                        $.notify(notify_msg.required.start_date);
                        return false;
                    } else if (currently_studing == false && aedu_end_date == '') {
                        $("#aedu_end_date").css("border", "1px solid rgb(252, 203, 199)");
                        go('#aedu_end_date', 150, 500);
                        $.notify(notify_msg.required.end_date);
                        return false;
                    } else if (ae_major == '') {
                        $("#ae_major").css("border", "1px solid rgb(252, 203, 199)");
                        //$("#ae_major").focus();
                        go('#ae_major', 150, 500);
                        $.notify(notify_msg.required.major);
                        return false;
                    }

                    $("#next").css("border", "1px solid rgb(252, 203, 199)");
                    go('#next', 150, 500);
                    $.notify(txt_btn_education);
                    return false;

                }

                return true;
                break;

            case 5:

                if (tags == '') {
                    $("#tags-div").addClass("error");
                    go(".ui-autocomplete-input", 150, 500);
                    $.notify(notify_msg.required.skill_tags);
                    return false;
                } else if ($("input[name=language1]").length > 0 && language_rate1 == '') {
                    $("#language1").addClass('error');
                    go('#language1', 150, 500);
                    $.notify(notify_msg.required.language1);
                    return false;
                } else if ($("input[name=language2]").length > 0 && language_rate2 == '') {
                    $("#language2").addClass('error');
                    go('#language2', 150, 500);
                    $.notify(notify_msg.required.language1);
                    return false;
                } else if ($("input[name=language3]").length > 0 && language_rate3 == '') {
                    $("#language3").addClass('error');
                    go('#language3', 150, 500);
                    $.notify(notify_msg.required.language1);
                    return false;
                } else if ($("input[name=language4]").length > 0 && language_rate4 == '') {
                    $("#language4").addClass('error');
                    go('#language4', 150, 500);
                    $.notify(notify_msg.required.language1);
                    return false;
                } else if (expected_salary == '') {
                    $("#expected_salary").parent().addClass('error');
                    go('#expected_salary', 150, 500);
                    $.notify(notify_msg.required.expected_salary);
                    return false;
                } else if (document.getElementById('availability-div') != null && (availability == undefined || availability == '' || availability == txt_select_one || availability == "0")) {
                    $("#availability-div").addClass('error');
                    go('#availability-div', 150, 500);
                    $.notify(notify_msg.required.availability);
                    return false;
                }
                return true;
                break;
        }

    }
    $(".submit_first_step").bind("click", function () {
        var i = $(".resume-content.current").index();
        i++;
        _result = validate_tab(i);
        if (_result) {
            nextSection();
            return;
        }

    });


    $("#submit").bind("click", function () {

        if (experience_list.length > 0) {
            $.each(experience_list, function (index, experiences) {
                arr_exp_list.push(experiences);
            });
        }

        if (education_list.length > 0) {
            $.each(education_list, function (index, education) {
                arr_edu_list.push(education);
            });
        }

        var template_id = id;
        var gender = '';
        var nationality = '';
        var country = '';

        var platform_id = $("#platform_id").val();

        /*First Tab*/
        var photo_filenames = "";
        var photo_filename = $("#photo_filename").val();
        var profilepic = $("#profilepic").attr("src");
        var name = $("#name").val();
        var email = $("#email").val();
        var dob = $("#dob").val();
        var marital_status = $("#marital_status option:selected").val();
        var work_permit = $("#work_permit option:selected").val();
        var phone = $("#phone").val();
        var personal_description = $("#personal_description").val();

        if (photo_filename != "") {
            photo_filenames = photo_filename;
        } else if (profilepic != "") {
            photo_filenames = profilepic;
        }

        if ($('input[name=gender]:checked').length > 0) {
            gender = $('input[name=gender]:checked')[0].value;
        }
        if ($('input[name=nationality]:checked').length > 0) {
            var nationality = $('input[name=nationality]:checked').attr('data-val');
        }
        /*First Tab*/

        /*Second Tab*/
        var address1 = $("#address1").val();
        var area = $("#area").val();
        var postal_code = $("#postal_code").val();
        var city = $("#city").val();
        var country = '';
        if ($('input[name=country]:checked').length > 0)
            country = $('input[name=country]:checked')[0].value;
        if (country == '' || country == '0')
            var state = $("#Other-state").val();
        else
            //var state = $("#" + country + "-state").val();
            var state = $("#new_state_id").val();
        /*Second Tab*/

        /*Third Tab*/
        var exp_status = $("#exp-status option:selected").val();
        /*Third Tab*/

        /*Fourth Tab*/
        var ae_school_name = $("#ae_school_name").val();
        var currently_studing = $("#currently_studing").is(':checked');
        var ae_degree = $("#ae_degree").val();
        var ae_grade = $("#ae_grade").val();
        var aedu_start_date = $("#aedu_start_date").val();
        var aedu_end_date = $("#aedu_end_date").val();
        var ae_major = $("#ae_major").val();
        /*Fourth Tab*/

        /*Fifth Tab*/
        var tags = $("#mySingleField").val();
        var language1 = 'English';
        var language_rate1 = $("input[name=language1]:checked").val();
        var language2 = 'Bahasa Malaysia';
        var language_rate2 = $("input[name=language2]:checked").val();
        var language3 = 'Chinese';
        var language_rate3 = $("input[name=language3]:checked").val();
        var language4 = 'Tamil';
        var language_rate4 = $("input[name=language4]:checked").val();
        if (typeof language_rate1 == 'undefined')
            language_rate1 = '';
        if (typeof language_rate2 == 'undefined')
            language_rate2 = '';
        if (typeof language_rate3 == 'undefined')
            language_rate3 = '';
        if (typeof language_rate4 == 'undefined')
            language_rate4 = '';
        var expected_salary_curr = $("#expected_salary_curr").val();
        var expected_salary = $("#expected_salary").val();
        var availability = $("#availability option:selected").val();

        /*Fifth Tab*/

        _result = validate_tab(5);

        arr_exp_list.sort();
        arr_exp_list.reverse();

        arr_edu_list.sort();
        arr_edu_list.reverse();

        if (_result) {
            var jsonData = {
                '_token': $('meta[name="csrf-token"]').attr('content'),
                '_method': "POST",
                template_id: template_id,
                platform_id: platform_id,
                name: name,
                email: email,
                phone: phone,
                dob: dob,
                marital_status: marital_status,
                work_permit: work_permit,
                gender: gender,
                nationality: nationality,
                address1: address1,
                area: area,
                postal_code: postal_code,
                city: city,
                country: country,
                state: state,
                exp_status: exp_status,
                expected_salary: expected_salary,
                language1: language1,
                language_rate1: language_rate1,
                language2: language2,
                language_rate2: language_rate2,
                language3: language3,
                language_rate3: language_rate3,
                language4: language4,
                language_rate4: language_rate4,
                tags: tags,
                photo_filenames: photo_filenames,
                personal_description: personal_description,
                availability: availability,
                education: arr_edu_list,
                experience: arr_exp_list,

            };

            var request = $.ajax({
                url: canvas_url + "api/jobseeker/resumebuilder",
                data: jsonData,
                type: 'POST',
                crossDomain: true,
            });

            $('#spinner').show();
            var progress = $.notify(txt_resume_generating, {'type': 'warning', allow_dismiss: false, delay: 0, showProgressbar: true});
            setTimeout(function () {
                progress.update({'progress': 25});
            }, 1300);
            setTimeout(function () {
                progress.update({'progress': 50});
            }, 2600);
            setTimeout(function () {
                progress.update({'progress': 75});
            }, 3900);
            request.done(function (data) {
                if (data.status == 'success') {
                    progress.update({'type': 'success', 'message': txt_resume_ready + "<a onClick='$(\".alert-success\").remove();' class='link strong bold' data-notify='dismiss' href='" + data.url + "' target='_blank'>" + txt_click_to_download + "</a>", 'progress': 100});
                } else {
                    progress.update({'type': 'warning', 'message': data.msg, 'progress': 100});
                    setTimeout(function () {
                        progress.close();
                    }, 4000);
                    return false;
                }
                $('#spinner').hide();
                $(".submit_first_step").removeClass("disabled");
            });
            request.fail(function (jqXHR, textStatus) {});
        } else {

            return false;
        }
        return false;
    });

    var exp_list = {};
    var arr_exp_list = [];
    var template_no = 1;

    $(".addexperiences").bind("click", function () {

        var exp_status = $("#exp-status option:selected").val();
        var ae_company_name = $("#ae_company_name").val();
        var ae_title = $("#ae_title").val();
        var ae_salary_cur = $("#ae_salary_cur").val();
        var ae_salary = $("#ae_salary").val();
        var ae_start_date = $("#ae_start_date").val();
        var ae_end_date = $("#ae_end_date").val();
        var ae_job_description = $("#ae_job_description").val();
        var current_working = $("#currently_working").is(':checked');

        if (exp_status == '' || exp_status == '--Select One--') {
            $("#exp-status").css("border", "1px solid rgb(252, 203, 199)");
            go('#exp-status', 150, 500);
            $.notify(notify_msg.required.experience_status);
            return false;
        } else if (ae_company_name == '') {
            $("#ae_company_name").css("border", "1px solid rgb(252, 203, 199)");
            go('#ae_company_name', 150, 500);
            $.notify(notify_msg.required.company_name);
            return false;
        } else if (ae_title == '') {
            $("#ae_title").css("border", "1px solid rgb(252, 203, 199)");
            go('#ae_title', 150, 500);
            $.notify(notify_msg.required.job_title);
            return false;
        } else if (ae_salary == '') {
            $("#ae_salary").css("border", "1px solid rgb(252, 203, 199)");
            go('#ae_salary', 150, 500);
            $.notify(notify_msg.required.salary);
            return false;
        } else if (ae_start_date == '') {
            $("#ae_start_date").css("border", "1px solid rgb(252, 203, 199)");
            go('#ae_start_date', 150, 500);
            $.notify(notify_msg.required.start_date);
            return false;
        } else if (ae_end_date == '' && current_working === false) {
            $("#ae_end_date").css("border", "1px solid rgb(252, 203, 199)");
            //$("#ae_end_date").focus();
            go('#ae_end_date', 150, 500);
            $.notify(notify_msg.required.end_date);
            return false;
        } else if (ae_job_description == '') {
            $("#ae_job_description").css("border", "1px solid rgb(252, 203, 199)");
            go('#ae_job_description', 150, 500);
            $.notify(notify_msg.required.job_description);
            return false;
        } else {

            template_no++;
            template_name = 'template_no' + template_no;

            _template = $('#add-experiences').html();
            _template += "<div class='template_no" + template_no + "'>";
            _template += "<div class='profile-header'>";

            _template += "<p class='bold left'>" + ae_company_name + "</p>";
            _template += "<a data-id='template_no" + template_no + "' class='btn btn-primary delete-experiences-btn right'>" + txt_delete + "<i class='mdi mdi-check'></i></a>";
            _template += "<div class='clearfix'></div>";
            _template += "</div>";
            _template += "<div class='profile-body'>";
            _template += "<div class='resume-content current active' id='exp-list' style='display:block'>";
            _template += "<div class='form-group-wrap with-text'>";
            _template += "<label class='text'>" + txt_company_name + "</label>";
            _template += "<label class='form-group' id='ae_company_name-div'>" + ae_company_name + "</label></div>";
            _template += "<div class='form-group-wrap with-text'>";
            _template += "<label class='text'>" + txt_title + "</label>";
            _template += "<label class='form-group' id='ae_title-div'>" + ae_title + "</label>";
            _template += "</div>";
            _template += "<div class='form-group-wrap with-text'>";
            _template += "<label class='text'>" + txt_salary + "</label>";
            _template += "<label class='form-group' id='ae_salary-div'>" + ae_salary_cur + " " + ae_salary + "</label>";
            _template += "</div>";
            _template += "<div class='form-group-wrap with-text'>";
            _template += "<label class='text'>" + txt_start_date + "</label>";
            _template += "<label class='form-group' id='ae_start_date-div'>" + ae_start_date + "</label>";
            _template += "</div>";
            if (current_working && ae_end_date == '') {
                _template += "<div class='form-group-wrap with-text'>";
                _template += "<label class='text'>" + txt_status + "</label>";
                _template += "<label class='form-group' id='currently_working'>" + txt_work_here + "</label>";
                _template += "</div>";
            } else if (!current_working && ae_end_date != '') {
                _template += "<div class='form-group-wrap with-text'>";
                _template += "<label class='text'>" + txt_end_date + "</label>";
                _template += "<label class='form-group' id='ae_end_date-div'>" + ae_end_date + "</label>";
                _template += "</div>";
            }
            _template += "<div class='form-group-wrap with-text'>";
            _template += "<label class='text'>" + txt_job_desc + "</label>";
            _template += "<label class='form-group' id='ae_job_description-div'>" + ae_job_description + "</label>";
            _template += "</div></div>";

            $('#add-experiences').html(_template);

            exp_list = {};
            exp_list.experience_id = template_name;
            exp_list.company_name = ae_company_name;
            exp_list.title = ae_title;
            exp_list.salary_curr = ae_salary_cur;
            exp_list.salary = ae_salary;
            exp_list.start_date = ae_start_date;
            exp_list.end_date = ae_end_date;
            exp_list.job_description = ae_job_description;
            exp_list.currently_working = current_working;
            arr_exp_list.push(exp_list);
            console.log(arr_exp_list);

        }

        document.getElementById('ae_company_name').value = "";
        document.getElementById('ae_title').value = "";
        document.getElementById('ae_salary').value = "";
        document.getElementById('ae_start_date').value = "";
        document.getElementById('ae_end_date').value = "";
        document.getElementById('ae_job_description').value = "";
        $('#currently_working').prop('checked', false);
        $("#ae_end_date").closest('.form-inline').fadeIn();

    });
    
    var edu_list = {};
    var arr_edu_list = [];

    $(".addeducations").bind("click", function () {

        var ae_school_name = $("#ae_school_name").val();
        var currently_studing = $("#currently_studing").is(':checked');
        var ae_degree = $("#ae_degree").val();
        var ae_grade = $("#ae_grade").val();
        var aedu_start_date = $("#aedu_start_date").val();
        var aedu_end_date = $("#aedu_end_date").val();
        var ae_major = $("#ae_major").val();

        if (ae_school_name == '') {
            $("#ae_school_name").css("border", "1px solid rgb(252, 203, 199)");
            go('#ae_school_name', 150, 500);
            $.notify(notify_msg.required.school);
            return false;
        } else if (aedu_start_date == '') {
            $("#aedu_start_date").css("border", "1px solid rgb(252, 203, 199)");
            go('#aedu_start_date', 150, 500);
            $.notify(notify_msg.required.start_date);
            return false;
        } else if (currently_studing == false && aedu_end_date == '') {
            $("#aedu_end_date").css("border", "1px solid rgb(252, 203, 199)");
            go('#aedu_end_date', 150, 500);
            $.notify(notify_msg.required.end_date);
            return false;
        } else if (ae_major == '') {
            $("#ae_major").css("border", "1px solid rgb(252, 203, 199)");
            //$("#ae_major").focus();
            go('#ae_major', 150, 500);
            $.notify(notify_msg.required.major);
            return false;
        } else {

            template_no++;
            template_name = 'template_no' + template_no;

            _template = $('#add-educations').html();
            _template += "<div class='template_no" + template_no + "'>";
            _template += "<div class='profile-header'>";

            _template += "<p class='bold left'>" + ae_degree + "</p>";
            _template += "<a data-id='template_no" + template_no + "' class='btn btn-primary delete-educations-btn right'>" + txt_delete + "<i class='mdi mdi-check'></i></a>";
            _template += "<div class='clearfix'></div>";
            _template += "</div>";

            _template += "<div class='profile-body'>";
            _template += "<div class='resume-content current active' id='edu-list' style='display:block'>";
            _template += "<div class='form-group-wrap with-text'>";
            _template += "<label class='text'>" + txt_school_colleges + "</label>";
            _template += "<label class='form-group' id='ae_school_name-div'>" + ae_school_name + "</label>";
            _template += "</div>";
            _template += "<div class='form-group-wrap with-text'>";
            _template += "<label class='text'>" + txt_qualification + "</label>";
            _template += "<label class='form-group' id='ae_degree-div'>" + ae_degree + "</label>";
            _template += "</div>";
            _template += "<div class='form-group-wrap with-text'>";
            _template += "<label class='text'>" + txt_grade + "</label>";
            _template += "<label class='form-group' id='ae_grade-div'>" + ae_grade + "</label>";
            _template += "</div>";
            _template += "<div class='form-group-wrap with-text'>";
            _template += "<label class='text'>" + txt_start_date + "</label>";
            _template += "<label class='form-group' id='aedu_start_date-div'>" + aedu_start_date + "</label>";
            _template += "</div>";
            if (currently_studing && aedu_end_date == '') {
                _template += "<div class='form-group-wrap with-text'>";
                _template += "<label class='text'>" + txt_status + "</label>";
                _template += "<label class='form-group' id='currently_studing'>" + txt_current_study + "</label>";
                _template += "</div>";
            } else if (!currently_studing && aedu_end_date != '') {
                _template += "<div class='form-group-wrap with-text'>";
                _template += "<label class='text'>" + txt_end_date + "</label>";
                _template += "<label class='form-group' id='aedu_end_date-div'>" + aedu_end_date + "</label>";
                _template += "</div>";
            }
            _template += "<div class='form-group-wrap with-text'>";
            _template += "<label class='text'>" + txt_major + "</label>";
            _template += "<label class='form-group' id='ae_major-div'>" + ae_major + "</label>";
            _template += "</div></div>";

            $('#add-educations').html(_template);

            edu_list = {};
            edu_list.educations_id = template_name;
            edu_list.school_name = ae_school_name;
            edu_list.currently_studing = currently_studing;
            edu_list.qualification = ae_degree;
            edu_list.grade = ae_grade;
            edu_list.start_date = aedu_start_date;
            edu_list.end_date = aedu_end_date;
            edu_list.major = ae_major;
            arr_edu_list.push(edu_list);

        }
        document.getElementById('ae_school_name').value = "";
        $('#currently_studing').prop('checked', false);
        document.getElementById('ae_grade').value = "";
        document.getElementById('aedu_start_date').value = "";
        document.getElementById('aedu_end_date').value = "";
        document.getElementById('ae_major').value = "";
        $("#aedu_end_date").closest('.form-inline').fadeIn();

    });

    $(document).on('click', '.delete-experiences-btn', function (e) {
        var template_id = $(this).attr("data-id");
        $('.' + template_id).remove();
        if (experience_list.length > 0) {
            $.each(experience_list, function (index, experience) {
                if ('template_no' + experience.id == template_id) {
                    experience_list.splice(index, 1);
                }
            });
        } else {
            $.each(arr_exp_list, function (index, experience) {
                if (experience.experience_id == template_id) {
                    arr_exp_list.splice(index, 1);
                }

            });
        }
        return false;
    });

    $(document).on('click', '.delete-educations-btn', function (e) {
        var template_id = $(this).attr("data-id");
        $('.' + template_id).remove();
        if (education_list.length > 0) {
            $.each(education_list, function (index, educations) {
                console.log(educations);
                if ('template_no' + educations.id == template_id) {
                    education_list.splice(index, 1);
                }

            });
            console.log(education_list);
        } else {
            $.each(arr_edu_list, function (index, educations) {
                console.log(educations);
                if (educations.educations_id == template_id) {
                    arr_edu_list.splice(index, 1);
                }

            });
        }

        console.log(arr_edu_list);

        return false;
    });

    $("#currently_working").bind("click", function () {
        var current_working = $("#currently_working").is(':checked');
        if (current_working === true)
        {
            $("#ae_end_date").closest('.form-inline').fadeOut();
        } else
        {
            $("#ae_end_date").closest('.form-inline').fadeIn();
        }
    });

    $("#currently_studing").bind("click", function () {
        var currently_studing = $("#currently_studing").is(':checked');
        if (currently_studing === true)
        {
            $("#aedu_end_date").closest('.form-inline').fadeOut();
        } else
        {
            $("#aedu_end_date").closest('.form-inline').fadeIn();
        }
    });

    $("input[name='nationality']").bind("click", function (event) {
        var nationality = $('input[name=nationality]:checked').attr('data-val');
        if (nationality == "Malaysian") {
            $("#work_permit").closest('.form-group-wrap').fadeOut();
        } else {
            $("#work_permit").closest('.form-group-wrap').fadeIn();
        }

    });

    $.populateInfo = function (value) {
        if ($('#email').val() != '' || $('#phone').val() != '') {
            $.post(canvas_url + "api/jobseeker/checkEmailPhone", {'value': value, '_token': $('meta[name="csrf-token"]').attr('content'), '_method': "POST"}, function (data2) {
                if (data2.status == 'success') {
                    $.post(canvas_url + "api/jobseeker/populateData", {'value': value, '_token': $('meta[name="csrf-token"]').attr('content'), '_method': "POST"}, function (data) {
                        if (data.status == 'success') {
                            var jobseeker = data.data;
                            $("#name").val(jobseeker.name);
                            $("#email").val(jobseeker.email);
                            $("#platform_id").val(jobseeker.platform_id);
                            $("#phone").val(jobseeker.contact_number);
                            $("#nationality").val(jobseeker.nationality);
                            $("#availability").val(jobseeker.availability);
                            $("#availability").val(jobseeker.personal_description);
                            $("#address1").val(jobseeker.address1);
                            $("#city").val(jobseeker.city);
                            $("#area").val(jobseeker.area);
                            $(".states").val(jobseeker.state);
                            $("#postal_code").val(jobseeker.postcode);
                            $("#exp-status").val(jobseeker.experience_status);
                            $("#dob").val(jobseeker.dob);
                            $('img#profilepic').attr('src', jobseeker.picture);
                            $("#personal_description").val(jobseeker.personal_description);
                            $('input:radio[name=gender][value=' + jobseeker.gender + ']').attr('checked', true);
                            $('input:radio[name=country][value=' + jobseeker.country + ']').attr('checked', true);
                            if (jobseeker.nationality = "Malaysian") {
                                $('input:radio[name=nationality][value=132]').attr('checked', true);
                            } else {
                                $('input:radio[name=nationality][value=900]').attr('checked', true);
                            }

                            if (data.prefer.length != 0) {
                                var i;
                                for (i = 0; i < data.prefer.length; ++i) {
                                    $("#expected_salary_curr").val(data.prefer[i].pr_expected_salary_curency);
                                    $("#expected_salary").val(data.prefer[i].pr_expected_salary);
                                    $("#availability").val(data.prefer[i].pr_availability);
                                }
                            }

                            if (data.skills.length != 0) {

                                var i;

                                for (i = 0; i < data.skills.length; ++i) {

                                    $("#singleFieldTags").text(data.skills[i].sk_title);

                                    var languange;
                                    languange = JSON.parse(data.skills[i]['sk_language'], true);
                                    var j;

                                    for (j = 0; j <= languange.length + 1; j++) {
                                        if (j < 4) {
                                            if (languange[j]['language_rate1'] != "") {
                                                $('input:radio[name=language1][value=' + languange[j]['language_rate1'] + ']').attr('checked', true);
                                            }
                                            if (languange[j]['language_rate2'] != "") {
                                                $('input:radio[name=language2][value=' + languange[j]['language_rate2'] + ']').attr('checked', true);
                                            }
                                            if (languange[j]['language_rate3'] != "") {
                                                $('input:radio[name=language3][value=' + languange[j]['language_rate3'] + ']').attr('checked', true);
                                            }
                                            if (languange[j]['otherlanguage_rate'] != "") {
                                                $('input:radio[name=language4][value=' + languange[j]['otherlanguage_rate'] + ']').attr('checked', true);
                                            }
                                        }
                                    }
                                }
                            }

                            if (data.exp.length != 0) {

                                var i;
                                for (i = 0; i < data.exp.length; ++i) {

                                    template_no++;
                                    template_name = 'template_no' + template_no;

                                    _template = $('#add-experiences').html();
                                    _template += "<div class='template_no" + template_no + "'>";
                                    _template += "<div class='profile-header'>";

                                    _template += "<p class='bold left'>" + data.exp[i].company_name + "</p>";
                                    _template += "<a data-id='template_no" + template_no + "' class='btn btn-primary delete-experiences-btn right'>" + txt_delete + "<i class='mdi mdi-check'></i></a>";
                                    _template += "<div class='clearfix'></div>";
                                    _template += "</div>";

                                    _template += "<div class='profile-body'>";
                                    _template += "<div class='resume-content current active' id='exp-list' style='display:block'>";
                                    _template += "<div class='form-group-wrap with-text'>";
                                    _template += "<label class='text'>" + txt_company_name + "</label>";
                                    _template += "<label class='form-group' id='ae_company_name-div'>" + data.exp[i].company_name + "</label></div>";
                                    _template += "<div class='form-group-wrap with-text'>";
                                    _template += "<label class='text'>" + txt_title + "</label>";
                                    _template += "<label class='form-group' id='ae_title-div'>" + data.exp[i].job_title + "</label>";
                                    _template += "</div>";
                                    _template += "<div class='form-group-wrap with-text'>";
                                    _template += "<label class='text'>" + txt_salary + "</label>";
                                    _template += "<label class='form-group' id='ae_salary-div'>" + data.exp[i].salary_curency + " " + data.exp[i].salary + "</label>";
                                    _template += "</div>";
                                    _template += "<div class='form-group-wrap with-text'>";
                                    _template += "<label class='text'>" + txt_start_date + "</label>";
                                    _template += "<label class='form-group' id='ae_start_date-div'>" + data.exp[i].start_date + "</label>";
                                    _template += "</div>";
                                    if (data.exp[i].current_working && data.exp[i].end_date == '') {
                                        _template += "<div class='form-group-wrap with-text'>";
                                        _template += "<label class='text'>" + txt_status + "</label>";
                                        _template += "<label class='form-group' id='currently_working'>" + txt_work_here + "</label>";
                                        _template += "</div>";
                                    } else if (!data.exp[i].current_working && data.exp[i].end_date != '') {
                                        _template += "<div class='form-group-wrap with-text'>";
                                        _template += "<label class='text'>" + txt_end_date + "</label>";
                                        _template += "<label class='form-group' id='ae_end_date-div'>" + data.exp[i].end_date + "</label>";
                                        _template += "</div>";
                                    }
                                    _template += "<div class='form-group-wrap with-text'>";
                                    _template += "<label class='text'>" + txt_job_desc + "</label>";
                                    _template += "<label class='form-group' id='ae_job_description-div'>" + data.exp[i].job_description + "</label>";
                                    _template += "</div></div>";

                                    $('#add-experiences').html(_template);

                                    exp_list = {};
                                    exp_list.experience_id = template_name;
                                    exp_list.company_name = data.exp[i].company_name;
                                    exp_list.title = data.exp[i].job_title;
                                    exp_list.salary_curr = data.exp[i].salary_curency;
                                    exp_list.salary = data.exp[i].salary;
                                    exp_list.start_date = data.exp[i].start_date;
                                    exp_list.end_date = data.exp[i].end_date;
                                    exp_list.job_description = data.exp[i].job_description;
                                    exp_list.currently_working = data.exp[i].current_working;
                                    arr_exp_list.push(exp_list);
                                    console.log(arr_exp_list);

                                    if ($(".resume-content.current").index() == 2) {
                                        $('#add-experience').show();
                                        document.getElementById('add-experiences').style.display = "block";
                                    } else {
                                        $('#add-experience').hide();
                                        document.getElementById('add-experiences').style.display = "none";
                                    }
                                }
                            }

                            if (data.edu.length != 0) {
                                var i;
                                for (i = 0; i < data.edu.length; ++i) {
                                    template_no++;
                                    template_name = 'template_no' + template_no;

                                    _template = $('#add-educations').html();
                                    _template += "<div class='template_no" + template_no + "'>";
                                    _template += "<div class='profile-header'>";

                                    _template += "<p class='bold left'>" + data.edu[i].edu_level + "</p>";
                                    _template += "<a data-id='template_no" + template_no + "' class='btn btn-primary delete-educations-btn right'>" + txt_delete + "<i class='mdi mdi-check'></i></a>";
                                    _template += "<div class='clearfix'></div>";
                                    _template += "</div>";

                                    _template += "<div class='profile-body'>";
                                    _template += "<div class='resume-content current active' id='edu-list' style='display:block'>";
                                    _template += "<div class='form-group-wrap with-text'>";
                                    _template += "<label class='text'>" + txt_school_colleges + "</label>";
                                    _template += "<label class='form-group' id='ae_school_name-div'>" + data.edu[i].edu_institue + "</label>";
                                    _template += "</div>";
                                    _template += "<div class='form-group-wrap with-text'>";
                                    _template += "<label class='text'>" + txt_qualification + "</label>";
                                    _template += "<label class='form-group' id='ae_degree-div'>" + data.edu[i].edu_level + "</label>";
                                    _template += "</div>";
                                    _template += "<div class='form-group-wrap with-text'>";
                                    _template += "<label class='text'>" + txt_grade + "</label>";
                                    _template += "<label class='form-group' id='ae_grade-div'>" + data.edu[i].edu_grade + "</label>";
                                    _template += "</div>";
                                    _template += "<div class='form-group-wrap with-text'>";
                                    _template += "<label class='text'>" + txt_start_date + "</label>";
                                    _template += "<label class='form-group' id='aedu_start_date-div'>" + data.edu[i].edu_start_date + "</label>";
                                    _template += "</div>";
                                    if (data.edu[i].edu_currently_studing && data.edu[i].edu_end_date == '') {
                                        _template += "<div class='form-group-wrap with-text'>";
                                        _template += "<label class='text'>" + txt_status + "</label>";
                                        _template += "<label class='form-group' id='currently_studing'>" + txt_current_study + "</label>";
                                        _template += "</div>";
                                    } else if (!data.edu[i].edu_currently_studing && data.edu[i].edu_end_date != '') {
                                        _template += "<div class='form-group-wrap with-text'>";
                                        _template += "<label class='text'>" + txt_end_date + "</label>";
                                        _template += "<label class='form-group' id='aedu_end_date-div'>" + data.edu[i].edu_end_date + "</label>";
                                        _template += "</div>";
                                    }
                                    _template += "<div class='form-group-wrap with-text'>";
                                    _template += "<label class='text'>" + txt_major + "</label>";
                                    _template += "<label class='form-group' id='ae_major-div'>" + data.edu[i].edu_course + "</label>";
                                    _template += "</div></div>";

                                    $('#add-educations').html(_template);

                                    edu_list = {};
                                    edu_list.educations_id = template_name;
                                    edu_list.school_name = data.edu[i].edu_institue;
                                    edu_list.currently_studing = data.edu[i].edu_currently_studing;
                                    edu_list.qualification = data.edu[i].edu_level;
                                    edu_list.grade = data.edu[i].edu_grade;
                                    edu_list.start_date = data.edu[i].edu_start_date;
                                    edu_list.end_date = data.edu[i].edu_end_date;
                                    edu_list.major = data.edu[i].edu_course;
                                    arr_edu_list.push(edu_list);

                                    if ($(".resume-content.current").index() == 3) {
                                        $('#add-education').show();
                                        document.getElementById('add-educations').style.display = "block";
                                    } else {
                                        $('#add-education').hide();
                                        document.getElementById('add-educations').style.display = "none";
                                    }

                                    return jobseeker;
                                }

                                return jobseeker;
                            }

                            return jobseeker;
                        }

                        return jobseeker;

                    }, "json");

                    $('#if-exists').val('true');
                    $('#if-login').hide();
                    $('#login-first-alert').show();
                    if (data2.data == 'normal') {
                        $('#fb-login').hide();
                        $('#normal-login').show();
                    } else {
                        $('#fb-login').show();
                        $('#normal-login').hide();
                    }
                } else {
                    $('#if-exists').val('false');
                    $('#login-first-alert').hide();
                }
            }, "json");
        }
    }

    $(".add-alert").bind("click", function () {
        $.getPreferCategoriesDropdown();
        //$.getPreferLocationsDropdown();
        var country = $("#jobalert_country").val();
        ShowAllStatesNew(country, 'jobalert');
        $("#add-alert").fadeIn();
        go('#add-alert', 240, 500);
        $(".alert-error").hide();
        $(".add-alert").hide();
    });
    $(".hide_alert").bind("click", function () {
        $("#add-alert").fadeOut();
        $(".add-alert").fadeIn();
        $(".alert-error").fadeIn();
    });
    $(".delete-alert").bind("click", function () {

        var id = $(this).attr('data-id');
        var rec_id = $(this).attr('data-rec-id');
        var rec_type = $(this).attr('data-rec-type');
        $('#delete-alert-modal').modal();
        $(".delete-alert-btn").click(function () {
            var $btn = $(this);
            var jsonData = {
                '_token': $('meta[name="csrf-token"]').attr('content'),
                '_method': "DELETE"
            };
            var request = $.ajax({
                url: canvas_url + "api/jobseeker/job-alert/" + rec_id + "/" + rec_type,
                data: jsonData,
                type: 'DELETE',
                crossDomain: true,
                dataType: 'json'
            });
            $btn.button('loading');
            request.done(function (data) {
                if (data.status == 'success') {
                    $.notify(txt_alert_delete_notification, {type: 'success'});
                    setTimeout(function () {
                        $btn.button('reset');
                        $("#alert-block-" + rec_id).remove();
                        $('#delete-alert-modal').modal('hide');
                        window.location = canvas_url + "jobseeker/account?tab=jobalert";
                    }, timeout_redirect);
                } else {
                    $btn.button('reset');
                }
            });
            request.fail(function (jqXHR, textStatus) {});
        })

    });

    $(".submit_jobalert_profile").bind("click", function (e) {
        e.preventDefault();
        var title = $("#new_title").val();
        var keywords = $("#new_keywords").val();
        var prefer_locations = $("#new_state_id-jobalert").val();//$("#jobalert-state").val();
        var prefer_categories = $("#prefer_categories").val();
        var jobalert_city = $("#jobalert_city").val();
        var jobalert_country = $("#jobalert_country").val();
        var expected_salary_curr = $("#new_expected_salary_curr").val();
        var expected_salary = $("#new_expected_salary").val();
        var jobalert_email = $("#new_jobalert_email").val();
        var jobalert_name = $("#new_jobalert_name").val();
        var jobalert_contact = $("#new_jobalert_contact").val();
        var job_type = $("#askhelp-prefer-jobtype").val();
        var alert_status = $('input[name=alert_status]:checked').val();

        if ($(".submit_jobalert_profile").hasClass("disabled")) {
            return false;
        } else {
            if (title == '') {
                $("#new_title").parent().addClass("error");
                go('#new_title', 150, 500);
                $.notify(txt_enter_title);
                return false;
            } else if (job_type == '') {
                $("#askhelp-prefer-jobtype").parent().addClass("error");
                go('#askhelp-prefer-jobtype', 150, 500);
                $.notify(txt_enter_jobtype);
                return false;
            } else if (keywords == '') {
                $("#new_keywords").parent().addClass("error");
                go('#new_keywords', 150, 500);
                $.notify(notify_msg.required.keywords);
                return false;
            } else if (jobalert_country == '0' || jobalert_country == null) {
                $("#jobalert_country").parent().addClass("error");
                go('#jobalert_country', 150, 500);
                $.notify(notify_msg.required.country);
                return false;
            } else if (prefer_locations == '0' || prefer_locations == null) {
                //$("#jobalert-state").parent().addClass("error");
                //go('#jobalert-state', 150, 500);
                $("#new_state_id-jobalert").parent().addClass("error");
                go('#new_state_id-jobalert', 150, 500);
                $.notify(notify_msg.required.preferred_location);
                return false;
            } else if (jobalert_city == '' || jobalert_city == null) {
                $("#jobalert_city").parent().addClass("error");
                go('#jobalert_city', 150, 500);
                $.notify(notify_msg.required.city);
                return false;
            } else if (prefer_categories == '0' || prefer_categories == null) {
                $("#prefer_categories").parent().addClass("error");
                go('#prefer_categories_chosen', 150, 500);
                $.notify(notify_msg.required.preferred_categories);
                return false;
            } else if (expected_salary == '') {
                $("#new_expected_salary").parent().addClass("error");
                go('#new_expected_salary', 150, 500);
                $.notify(notify_msg.required.salary);
                return false;
            } else if (!$.isNumeric(expected_salary)) {
                $("#new_expected_salary").parent().addClass("error");
                go('#new_expected_salary', 150, 500);
                $.notify(notify_msg.invalid.salary);
                return false;
            } else if (jobalert_name == '') {
                $("#new_jobalert_name").parent().addClass("error");
                go('#new_jobalert_name', 150, 500);
                $.notify(txt_plz_enter_name);
                return false;
            } else if (jobalert_email == '') {
                $("#new_jobalert_email").parent().addClass("error");
                go('#new_jobalert_email', 150, 500);
                $.notify(notify_msg.required.email);
                return false;
            } else if (!validateEmail(jobalert_email)) {
                $("#new_jobalert_email").parent().addClass("error");
                go('#new_jobalert_email', 150, 500);
                $.notify(txt_valid_email_error);
                return false;
            } else if (jobalert_contact == '') {
                $("#new_jobalert_contact").parent().addClass("error");
                go('#new_jobalert_contact', 150, 500);
                $.notify(notify_msg.required.contact_number);
                return false;
            } else {
                $.post(canvas_url + "api/jobseeker/save-job-alert", {'title': title, 'keywords': keywords, 'prefer_locations': prefer_locations, 'city': jobalert_city,'country': jobalert_country, 'prefer_categories': prefer_categories, 'expected_salary': expected_salary, 'expected_salary_curr': expected_salary_curr, 'jobalert_email': jobalert_email, 'name': jobalert_name, 'jobalert_contact': jobalert_contact, 'alert_status': alert_status, job_type: job_type, '_token': $('meta[name="csrf-token"]').attr('content'), '_method': "POST"}, function (data) {

                    if (data.status == 'success') {
                        /*swal({   
                         title: txt_done_label,   
                         text: txt_job_alert_saved,   
                         type: "success",
                         html: true,
                         showConfirmButton: true 
                         }, function(isConfirm){   
                         window.location = canvas_url;                    
                         });*/
                        $.notify(txt_job_alert_saved_2, {type: 'success'});
                        setTimeout(function () {
                            window.location = canvas_url + "jobseeker/account?tab=jobalert";
                            ;
                        }, timeout_redirect);
                    } else {
                        //swal("Opps!", "There seems to be an error in saving alert details."+" "+data.msg, "warning");
                        $.notify(data.msg);
                    }
                }, "json");
            }
        }
    });

    $(".update_alert").bind("click", function (e) {
        e.preventDefault();
        var $btn = $(this);
        var id = $(this).attr("data-id");
        var rec_id = $(this).attr("data-rec-id");
        var rec_type = $(this).attr("data-type");
        var title = $("#alert_title-" + id).val();
        var keywords = $("#alert_keywords-" + id).val();
        var prefer_locations = $("#new_state_id-"+id+"-jobalert").val();//$("#" + id + "-jobalert-state").val();
        var jobalert_city = $("#jobalert_city-" + id).val();
        var jobalert_country = $("#jobalert_country-" + id).val();
        var prefer_categories = $("#alert_prefer_categories-" + id).val();
        var prefer_language = $("#alert_prefer_language-" + id).val();
        var expected_salary_curr = $("#alert_expected_salary_curr-" + id).val();
        var expected_salary = $("#alert_expected_salary-" + id).val();
        var jobalert_email = $("#alert_jobalert_email-" + id).val();
        var jobalert_name = $("#alert_jobalert_name-" + id).val();
        var jobalert_contact = $("#alert_jobalert_contact-" + id).val();
        var job_type = $("#askhelp-prefer-jobtype-" + id).val();
        var formID = "#alert-edit-" + id;
        var alert_status = $('input[name=alert_status]:checked', formID).val();

        if ($(".submit_jobalert_profile").hasClass("disabled")) {
            return false;
        } else {
            if (title == '') {

            } else if (job_type == '') {
                var err_el = $("#alert-jobtype-div-" + id);
                err_el.addClass("error");
                go(err_el, 150, 500);
                $.notify(txt_enter_jobtype);
                return false;
            } else if (keywords == '') {
                var err_el = $("#alert-keywords-div-" + id);
                err_el.addClass("error");
                go(err_el, 150, 500);
                return false;
            } else if (jobalert_country == '0' || jobalert_country == null) {
                var err_el = $("#alert-country-div-" + id);
                err_el.addClass("error");
                go(err_el, 150, 500);
                $.notify(notify_msg.required.country);
                return false;
            } else if (prefer_locations == '0' || prefer_locations == null) {
                var err_el = $("#alert-state-div-" + id);
                err_el.addClass("error");
                go(err_el, 150, 500);
                $.notify(notify_msg.required.preferred_location);
                return false;
            } else if (jobalert_city == '' || jobalert_city == null) {
                var err_el = $("#alert-city-div-" + id);
                err_el.addClass("error");
                go(err_el, 150, 500);
                $.notify(notify_msg.required.city);
                return false;
            } else if (prefer_categories == '0' || prefer_categories == null) {
                var err_el = $("#alert-category-div-" + id);
                err_el.addClass("error");
                go(err_el, 150, 500);
                $.notify(notify_msg.required.preferred_categories);
                return false;
            } else if (expected_salary == '') {
                var err_el = $("#alert-salary-div-" + id);
                err_el.addClass("error");
                go(err_el, 150, 500);
                $.notify(notify_msg.required.salary);
                return false;
            } else if (!$.isNumeric(expected_salary)) {
                var err_el = $("#alert-salary-div-" + id);
                err_el.addClass("error");
                go(err_el, 150, 500);
                $.notify(notify_msg.invalid.salary);
                return false;
            } else if (jobalert_name == '') {

            } else if (jobalert_email == '') {
                var err_el = $("#alert-email-div-" + id);
                err_el.addClass("error");
                go(err_el, 150, 500);
                $.notify(notify_msg.required.email);
                return false;
            } else if (!validateEmail(jobalert_email)) {
                var err_el = $("#alert-email-div-" + id);
                err_el.addClass("error");
                go(err_el, 150, 500);
                $.notify(txt_valid_email_error);
                return false;
            } else if (jobalert_contact == '') {
                var err_el = $("#alert-phone-div-" + id);
                err_el.addClass("error");
                go(err_el, 150, 500);
                $.notify(notify_msg.required.contact_number);
                return false;
            } else {
                $.post(canvas_url + "api/jobseeker/job-alert", {'id': rec_id, 'type': rec_type, 'title': title, 'keywords': keywords, 'prefer_language': prefer_language, 'prefer_locations': prefer_locations, 'city': jobalert_city, 'prefer_categories': prefer_categories, 'expected_salary': expected_salary, 'expected_salary_curr': expected_salary_curr, 'jobalert_email': jobalert_email, 'jobalert_contact': jobalert_contact, alert_status: alert_status, job_type: job_type,'country':jobalert_country, '_token': $('meta[name="csrf-token"]').attr('content'), '_method': "PUT"}, function (data) {
                    if (data.status == 'success') {
                        /*swal({   
                         title: txt_done_label,   
                         text: txt_job_alert_saved,   
                         type: "success",
                         html: true,
                         showConfirmButton: true 
                         }, function(isConfirm){   
                         window.location = canvas_url;                    
                         });*/
                        $.notify(txt_job_alert_saved_2, {type: 'success'});
                        setTimeout(function () {
                            window.location = canvas_url + "jobseeker/account?tab=jobalert";
                            ;
                        }, timeout_redirect);
                    } else {
                        //swal("Opps!", "There seems to be an error in saving alert details."+" "+data.msg, "warning");
                        $.notify(data.msg);
                    }
                }, "json");
            }
        }
    });

    $(".tabs").bind("click", function () {
        $.hideAllTabs();
        $(this).parent().addClass("active");
        $("#" + $(this).attr('data-target')).fadeIn();
    });

    $(".tab-genresume").bind("click", function () {
        $('#download-resume').trigger('click');
    });

    $.checkFirstTimeWorking = function (val)
    {
        if (val == 'No')
        {
            $("#currently_working-div").show();
            $("#currently_working_yes").show();
        } else
        {
            $("#currently_working-div").hide();
        }
    }

    $.checkCurrentlyWorking = function (val)
    {
        if (val == 'Yes')
        {
            $("#currently_working_yes").show();
            $("#currently_working_no").hide();
        } else
        {
            $("#currently_working_no").show();
            $("#currently_working_yes").hide();
        }
    }

    $('#change-contact').click(function (e) {
        e.preventDefault();
        //prepare stuff
        $('#change-contact-save').attr('data-field', $(this).attr('data-field'));
        var placeholder;
        if ($(this).attr('data-field').toLowerCase() == 'email')
            placeholder = txt_your_email;
        else
            placeholder = txt_enter_phone;
        $('#change-contact-value').attr('placeholder', placeholder);
        $('#change-contact-value').val($(this).attr('data-' + $(this).attr('data-field').toLowerCase()));

        var label;
        if ($(this).attr('data-field').toLowerCase() == 'email')
            label = txt_email.toLowerCase();
        else
            label = txt_phone.toLowerCase();

        $('#change-contact-label').text(label);
        $('#change-contact-value').removeAttr("disabled");
        //show everything
        //$('#change-contact-bg').fadeIn('fast');
        //$('#change-contact-box').fadeIn('fast');
        $('#change-contact-modal').modal('show');
    });

    $('#change-contact-save').click(function (e) {
        //change email or phone number directly in the verification warning message in job seeker profile page
        e.preventDefault();
        var _this = $(this);
        var $btn = $(this);

        change_contact_data = {}
        change_contact_data._token = $('meta[name="csrf-token"]').attr('content');
        change_contact_data._method = 'POST';

        if ($(this).attr('data-field').toLowerCase() == 'email') {
            change_contact_data.email = $('#change-contact-value').val();
            if (change_contact_data.email == '') {
                $.notify(notify_msg.required.email);
                return false;
            } else if (!validateEmail(change_contact_data.email)) {
                $.notify(txt_correct_email_address);
                return false;
            }
        } else if ($(this).attr('data-field').toLowerCase() == 'phone') {
            change_contact_data.contact_number = $('#change-contact-value').val();
            if (change_contact_data.contact_number == '') {
                $.notify(txt_enter_phone_number);
                return false;
            } else
                change_contact_data.contact_number = change_contact_data.contact_number.replace("+", "");
        }

        //$('#change-contact-msg').hide();
        //$('#change-contact-msg').attr('class', '');
        //$("#change-contact-save").addClass("disabled");
        //$('#change-contact-value').attr("disabled", "disabled");
        //$('#change-contact-loading').show();
        $btn.button("loading");
        $.post(canvas_url + "api/jobseeker/field", change_contact_data, function (data) {
            if (data.status == 'success') {
                //$('#change-contact-msg').addClass('success');
                setTimeout(function () {
                    window.location.reload();
                }, timeout_redirect);
                $.notify(data.msg, {type: 'success'});
                $('#change-contact-modal').modal('hide')
                $btn.button('reset');
            } else {
                //$('#change-contact-msg').addClass('error');
                //$('#change-contact-value').removeAttr("disabled");
                //$("#change-contact-save").removeClass("disabled");
                $.notify({message: data.msg}, {type: "danger"});
                $btn.button('reset');
            }
            $btn.button('reset');
            //$('#change-contact-loading').hide();
            //$('#change-contact-msg').html(data.msg);
            //$('#change-contact-msg').show();
        }, "json");
    });

});

// mauresume features
var ddFeatures = $(".dropdown-menu.features"),
    btnCloseFeatures = $("#closeFeatures")
    bmBackdrop = $("<div class='modal-backdrop modal-backdrop--features in'></div>");

$(window).on("load resize", function() {

    return false;
    
});

// action for new features close button
btnCloseFeatures.on("click", function() {
    ddFeatures.fadeOut(300, function() {
        this.remove();
        $(".modal-backdrop--features").remove();
    });
});
